import { J as JS_PREFIX, g as CSS_UTILITY_PREFIX, t as translate, r as IS_HIDDEN_CLASS, f as CSS_PREFIX, X as ATC_PREORDER_TAG, H as HIDE_ONLY_N_LEFT_TAG, q as ENABLE_ONE_HOUR_PICKUP } from './built-constants-439d5572.js';
import { c as cartEventEmitter } from './built-cart-event-emitter-def8079a.js';
import './built-env-utils-ed419642.js';
import './built-config-a65ae98c.js';
import './built-loglevel-42c63e3e.js';
import { I as IS_ACTIVE_CLASS, V as VALIDATION_MESSAGE_CLASS, P as PRODUCT_PAGE_COPY, c as IS_OPEN, T as TEMPLATE_SUFFIX, C as CONTAINER_SUFFIX, d as ICON_PREFIX, e as IS_TRANSITIONING_CLASS, h as IS_OUT_OF_STOCK_CLASS, i as IS_SOLD_OUT_CLASS, f as formatPriceSingle, H as HIDE_OVERFLOW_Y_CLASS, F as FIXED_CLASS } from './built-price-format-dc3d77ee.js';
import { c as isNonFollowedProduct, g as getCustomErrorMessage, d as isErrorScenario1, e as isErrorScenario2, f as getQuantityFromMessage, h as isErrorScenario3, v as variantHasSufficientQuantity } from './built-error-message-utilities-4ca13134.js';
import { s as showElement, h as hideElement } from './built-element-utils-09877efc.js';
import { e as encode, d as decode, b as getUrlVariant } from './built-get-url-variant-a647ef33.js';
import { S as STORE_PICKUP_LIST_SELECTOR, b as STORE_PICKUP_USER_CITY_SELECTOR, c as STORE_PICKUP_USER_STATE_SELECTOR, d as STORE_PICKUP_ADDRESS, f as STORE_PICKUP_CITY, h as PICKUP_TIME_FRAME, i as STORE_PICKUP_OPTIONS, j as STORE_PICKUP_DETAILS, k as SELECT_FOR_PICKUP_OPTIONS_MESSAGE, l as STORE_PICKUP_THUMBNAIL_IMAGE, m as STORE_PICKUP_VARIANT_COLOR, n as STORE_PICKUP_VARIANT_SIZE, o as STORE_PICKUP_LOCATION_UPDATE_MESSAGE, p as STORE_PICKUP_LOCATION_UPDATE_MESSAGE_CONTENT, q as STORE_PICKUP_DEFAULT_LOCATION_UPDATE_MESSAGE, g as getSoonestPickupOption, P as PickupOption, r as getPickupOptionText, s as showElement$1, t as hideElement$1, R as REMOVE, A as ADD } from './built-utilities-e07c7454.js';
import './built-fetch-stores-17ca97d2.js';
import './built-js.cookie-7baadf9c.js';
import { g as getCurrentLocation, i as isLocationPickupApproved } from './built-index-750f2ec8.js';
import { f as fetchUserLocationData, g as getAvailablePickupStores } from './built-services-8840a941.js';
import { c as createState } from './built-create-state-8c555f12.js';

/**
* Panzoom for panning and zooming elements using CSS transforms
* Copyright Timmy Willison and other contributors
* https://github.com/timmywil/panzoom/blob/main/MIT-License.txt
*/

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var _assign = function __assign() {
  _assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return _assign.apply(this, arguments);
};
/* eslint-disable no-var */


if (typeof window !== 'undefined') {
  // Support: IE11 only
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  } // Support: IE11 only
  // CustomEvent is an object instead of a constructor


  if (typeof window.CustomEvent !== 'function') {
    window.CustomEvent = function CustomEvent(event, params) {
      params = params || {
        bubbles: false,
        cancelable: false,
        detail: null
      };
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
    };
  }
}
/**
 * Utilites for working with multiple pointer events
 */


function findEventIndex(pointers, event) {
  var i = pointers.length;

  while (i--) {
    if (pointers[i].pointerId === event.pointerId) {
      return i;
    }
  }

  return -1;
}

function addPointer(pointers, event) {
  var i; // Add touches if applicable

  if (event.touches) {
    i = 0;

    for (var _i = 0, _a = event.touches; _i < _a.length; _i++) {
      var touch = _a[_i];
      touch.pointerId = i++;
      addPointer(pointers, touch);
    }

    return;
  }

  i = findEventIndex(pointers, event); // Update if already present

  if (i > -1) {
    pointers.splice(i, 1);
  }

  pointers.push(event);
}

function removePointer(pointers, event) {
  // Add touches if applicable
  if (event.touches) {
    // Remove all touches
    while (pointers.length) {
      pointers.pop();
    }

    return;
  }

  var i = findEventIndex(pointers, event);

  if (i > -1) {
    pointers.splice(i, 1);
  }
}
/**
 * Calculates a center point between
 * the given pointer events, for panning
 * with multiple pointers.
 */


function getMiddle(pointers) {
  // Copy to avoid changing by reference
  pointers = pointers.slice(0);
  var event1 = pointers.pop();
  var event2;

  while (event2 = pointers.pop()) {
    event1 = {
      clientX: (event2.clientX - event1.clientX) / 2 + event1.clientX,
      clientY: (event2.clientY - event1.clientY) / 2 + event1.clientY
    };
  }

  return event1;
}
/**
 * Calculates the distance between two points
 * for pinch zooming.
 * Limits to the first 2
 */


function getDistance(pointers) {
  if (pointers.length < 2) {
    return 0;
  }

  var event1 = pointers[0];
  var event2 = pointers[1];
  return Math.sqrt(Math.pow(Math.abs(event2.clientX - event1.clientX), 2) + Math.pow(Math.abs(event2.clientY - event1.clientY), 2));
}

var events = {
  down: 'mousedown',
  move: 'mousemove',
  up: 'mouseup mouseleave'
};

if (typeof window !== 'undefined') {
  if (typeof window.PointerEvent === 'function') {
    events = {
      down: 'pointerdown',
      move: 'pointermove',
      up: 'pointerup pointerleave pointercancel'
    };
  } else if (typeof window.TouchEvent === 'function') {
    events = {
      down: 'touchstart',
      move: 'touchmove',
      up: 'touchend touchcancel'
    };
  }
}

function onPointer(event, elem, handler, eventOpts) {
  events[event].split(' ').forEach(function (name) {
    elem.addEventListener(name, handler, eventOpts);
  });
}

function destroyPointer(event, elem, handler) {
  events[event].split(' ').forEach(function (name) {
    elem.removeEventListener(name, handler);
  });
}

var isIE = typeof document !== 'undefined' && !!document.documentMode;
/**
 * Lazy creation of a CSS style declaration
 */

var divStyle;

function createStyle() {
  if (divStyle) {
    return divStyle;
  }

  return divStyle = document.createElement('div').style;
}
/**
 * Proper prefixing for cross-browser compatibility
 */


var prefixes = ['webkit', 'moz', 'ms'];
var prefixCache = {};

function getPrefixedName(name) {
  if (prefixCache[name]) {
    return prefixCache[name];
  }

  var divStyle = createStyle();

  if (name in divStyle) {
    return prefixCache[name] = name;
  }

  var capName = name[0].toUpperCase() + name.slice(1);
  var i = prefixes.length;

  while (i--) {
    var prefixedName = "" + prefixes[i] + capName;

    if (prefixedName in divStyle) {
      return prefixCache[name] = prefixedName;
    }
  }
}
/**
 * Gets a style value expected to be a number
 */


function getCSSNum(name, style) {
  return parseFloat(style[getPrefixedName(name)]) || 0;
}

function getBoxStyle(elem, name, style) {
  if (style === void 0) {
    style = window.getComputedStyle(elem);
  } // Support: FF 68+
  // Firefox requires specificity for border


  var suffix = name === 'border' ? 'Width' : '';
  return {
    left: getCSSNum(name + "Left" + suffix, style),
    right: getCSSNum(name + "Right" + suffix, style),
    top: getCSSNum(name + "Top" + suffix, style),
    bottom: getCSSNum(name + "Bottom" + suffix, style)
  };
}
/**
 * Set a style using the properly prefixed name
 */


function _setStyle(elem, name, value) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  elem.style[getPrefixedName(name)] = value;
}
/**
 * Constructs the transition from panzoom options
 * and takes care of prefixing the transition and transform
 */


function setTransition(elem, options) {
  var transform = getPrefixedName('transform');

  _setStyle(elem, 'transition', transform + " " + options.duration + "ms " + options.easing);
}
/**
 * Set the transform using the proper prefix
 *
 * Override the transform setter.
 * This is exposed mostly so the user could
 * set other parts of a transform
 * aside from scale and translate.
 * Default is defined in src/css.ts.
 *
 * ```js
 * // This example always sets a rotation
 * // when setting the scale and translation
 * const panzoom = Panzoom(elem, {
 *   setTransform: (elem, { scale, x, y }) => {
 *     panzoom.setStyle('transform', `rotate(0.5turn) scale(${scale}) translate(${x}px, ${y}px)`)
 *   }
 * })
 * ```
 */


function setTransform(elem, _a, _options) {
  var x = _a.x,
      y = _a.y,
      scale = _a.scale,
      isSVG = _a.isSVG;

  _setStyle(elem, 'transform', "scale(" + scale + ") translate(" + x + "px, " + y + "px)");

  if (isSVG && isIE) {
    var matrixValue = window.getComputedStyle(elem).getPropertyValue('transform');
    elem.setAttribute('transform', matrixValue);
  }
}
/**
 * Dimensions used in containment and focal point zooming
 */


function getDimensions(elem) {
  var parent = elem.parentNode;
  var style = window.getComputedStyle(elem);
  var parentStyle = window.getComputedStyle(parent);
  var rectElem = elem.getBoundingClientRect();
  var rectParent = parent.getBoundingClientRect();
  return {
    elem: {
      style: style,
      width: rectElem.width,
      height: rectElem.height,
      top: rectElem.top,
      bottom: rectElem.bottom,
      left: rectElem.left,
      right: rectElem.right,
      margin: getBoxStyle(elem, 'margin', style),
      border: getBoxStyle(elem, 'border', style)
    },
    parent: {
      style: parentStyle,
      width: rectParent.width,
      height: rectParent.height,
      top: rectParent.top,
      bottom: rectParent.bottom,
      left: rectParent.left,
      right: rectParent.right,
      padding: getBoxStyle(parent, 'padding', parentStyle),
      border: getBoxStyle(parent, 'border', parentStyle)
    }
  };
}
/**
 * Determine if an element is attached to the DOM
 * Panzoom requires this so events work properly
 */


function isAttached(elem) {
  var doc = elem.ownerDocument;
  var parent = elem.parentNode;
  return doc && parent && doc.nodeType === 9 && parent.nodeType === 1 && doc.documentElement.contains(parent);
}

function getClass(elem) {
  return (elem.getAttribute('class') || '').trim();
}

function hasClass(elem, className) {
  return elem.nodeType === 1 && (" " + getClass(elem) + " ").indexOf(" " + className + " ") > -1;
}

function isExcluded(elem, options) {
  for (var cur = elem; cur != null; cur = cur.parentNode) {
    if (hasClass(cur, options.excludeClass) || options.exclude.indexOf(cur) > -1) {
      return true;
    }
  }

  return false;
}
/**
 * Determine if an element is SVG by checking the namespace
 * Exception: the <svg> element itself should be treated like HTML
 */


var rsvg = /^http:[\w\.\/]+svg$/;

function isSVGElement(elem) {
  return rsvg.test(elem.namespaceURI) && elem.nodeName.toLowerCase() !== 'svg';
}

function shallowClone(obj) {
  var clone = {};

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      clone[key] = obj[key];
    }
  }

  return clone;
}

var defaultOptions = {
  animate: false,
  canvas: false,
  cursor: 'move',
  disablePan: false,
  disableZoom: false,
  disableXAxis: false,
  disableYAxis: false,
  duration: 200,
  easing: 'ease-in-out',
  exclude: [],
  excludeClass: 'panzoom-exclude',
  handleStartEvent: function handleStartEvent(e) {
    e.preventDefault();
    e.stopPropagation();
  },
  maxScale: 4,
  minScale: 0.125,
  overflow: 'hidden',
  panOnlyWhenZoomed: false,
  relative: false,
  setTransform: setTransform,
  startX: 0,
  startY: 0,
  startScale: 1,
  step: 0.3,
  touchAction: 'none'
};

function Panzoom(elem, options) {
  if (!elem) {
    throw new Error('Panzoom requires an element as an argument');
  }

  if (elem.nodeType !== 1) {
    throw new Error('Panzoom requires an element with a nodeType of 1');
  }

  if (!isAttached(elem)) {
    throw new Error('Panzoom should be called on elements that have been attached to the DOM');
  }

  options = _assign(_assign({}, defaultOptions), options);
  var isSVG = isSVGElement(elem);
  var parent = elem.parentNode; // Set parent styles

  parent.style.overflow = options.overflow;
  parent.style.userSelect = 'none'; // This is important for mobile to
  // prevent scrolling while panning

  parent.style.touchAction = options.touchAction;
  (options.canvas ? parent : elem).style.cursor = options.cursor; // Set element styles

  elem.style.userSelect = 'none';
  elem.style.touchAction = options.touchAction; // The default for HTML is '50% 50%'
  // The default for SVG is '0 0'
  // SVG can't be changed in IE

  _setStyle(elem, 'transformOrigin', typeof options.origin === 'string' ? options.origin : isSVG ? '0 0' : '50% 50%');

  function resetStyle() {
    parent.style.overflow = '';
    parent.style.userSelect = '';
    parent.style.touchAction = '';
    parent.style.cursor = '';
    elem.style.cursor = '';
    elem.style.userSelect = '';
    elem.style.touchAction = '';

    _setStyle(elem, 'transformOrigin', '');
  }

  function setOptions(opts) {
    if (opts === void 0) {
      opts = {};
    }

    for (var key in opts) {
      if (opts.hasOwnProperty(key)) {
        options[key] = opts[key];
      }
    } // Handle option side-effects


    if (opts.hasOwnProperty('cursor') || opts.hasOwnProperty('canvas')) {
      parent.style.cursor = elem.style.cursor = '';
      (options.canvas ? parent : elem).style.cursor = options.cursor;
    }

    if (opts.hasOwnProperty('overflow')) {
      parent.style.overflow = opts.overflow;
    }

    if (opts.hasOwnProperty('touchAction')) {
      parent.style.touchAction = opts.touchAction;
      elem.style.touchAction = opts.touchAction;
    }
  }

  var x = 0;
  var y = 0;
  var scale = 1;
  var isPanning = false;
  zoom(options.startScale, {
    animate: false,
    force: true
  }); // Wait for scale to update
  // for accurate dimensions
  // to constrain initial values

  setTimeout(function () {
    pan(options.startX, options.startY, {
      animate: false,
      force: true
    });
  });

  function trigger(eventName, detail, opts) {
    if (opts.silent) {
      return;
    }

    var event = new CustomEvent(eventName, {
      detail: detail
    });
    elem.dispatchEvent(event);
  }

  function setTransformWithEvent(eventName, opts, originalEvent) {
    var value = {
      x: x,
      y: y,
      scale: scale,
      isSVG: isSVG,
      originalEvent: originalEvent
    };
    requestAnimationFrame(function () {
      if (typeof opts.animate === 'boolean') {
        if (opts.animate) {
          setTransition(elem, opts);
        } else {
          _setStyle(elem, 'transition', 'none');
        }
      }

      opts.setTransform(elem, value, opts);
      trigger(eventName, value, opts);
      trigger('panzoomchange', value, opts);
    });
    return value;
  }

  function constrainXY(toX, toY, toScale, panOptions) {
    var opts = _assign(_assign({}, options), panOptions);

    var result = {
      x: x,
      y: y,
      opts: opts
    };

    if (!opts.force && (opts.disablePan || opts.panOnlyWhenZoomed && scale === opts.startScale)) {
      return result;
    }

    toX = parseFloat(toX);
    toY = parseFloat(toY);

    if (!opts.disableXAxis) {
      result.x = (opts.relative ? x : 0) + toX;
    }

    if (!opts.disableYAxis) {
      result.y = (opts.relative ? y : 0) + toY;
    }

    if (opts.contain) {
      var dims = getDimensions(elem);
      var realWidth = dims.elem.width / scale;
      var realHeight = dims.elem.height / scale;
      var scaledWidth = realWidth * toScale;
      var scaledHeight = realHeight * toScale;
      var diffHorizontal = (scaledWidth - realWidth) / 2;
      var diffVertical = (scaledHeight - realHeight) / 2;

      if (opts.contain === 'inside') {
        var minX = (-dims.elem.margin.left - dims.parent.padding.left + diffHorizontal) / toScale;
        var maxX = (dims.parent.width - scaledWidth - dims.parent.padding.left - dims.elem.margin.left - dims.parent.border.left - dims.parent.border.right + diffHorizontal) / toScale;
        result.x = Math.max(Math.min(result.x, maxX), minX);
        var minY = (-dims.elem.margin.top - dims.parent.padding.top + diffVertical) / toScale;
        var maxY = (dims.parent.height - scaledHeight - dims.parent.padding.top - dims.elem.margin.top - dims.parent.border.top - dims.parent.border.bottom + diffVertical) / toScale;
        result.y = Math.max(Math.min(result.y, maxY), minY);
      } else if (opts.contain === 'outside') {
        var minX = (-(scaledWidth - dims.parent.width) - dims.parent.padding.left - dims.parent.border.left - dims.parent.border.right + diffHorizontal) / toScale;
        var maxX = (diffHorizontal - dims.parent.padding.left) / toScale;
        result.x = Math.max(Math.min(result.x, maxX), minX);
        var minY = (-(scaledHeight - dims.parent.height) - dims.parent.padding.top - dims.parent.border.top - dims.parent.border.bottom + diffVertical) / toScale;
        var maxY = (diffVertical - dims.parent.padding.top) / toScale;
        result.y = Math.max(Math.min(result.y, maxY), minY);
      }
    }

    if (opts.roundPixels) {
      result.x = Math.round(result.x);
      result.y = Math.round(result.y);
    }

    return result;
  }

  function constrainScale(toScale, zoomOptions) {
    var opts = _assign(_assign({}, options), zoomOptions);

    var result = {
      scale: scale,
      opts: opts
    };

    if (!opts.force && opts.disableZoom) {
      return result;
    }

    var minScale = options.minScale;
    var maxScale = options.maxScale;

    if (opts.contain) {
      var dims = getDimensions(elem);
      var elemWidth = dims.elem.width / scale;
      var elemHeight = dims.elem.height / scale;

      if (elemWidth > 1 && elemHeight > 1) {
        var parentWidth = dims.parent.width - dims.parent.border.left - dims.parent.border.right;
        var parentHeight = dims.parent.height - dims.parent.border.top - dims.parent.border.bottom;
        var elemScaledWidth = parentWidth / elemWidth;
        var elemScaledHeight = parentHeight / elemHeight;

        if (options.contain === 'inside') {
          maxScale = Math.min(maxScale, elemScaledWidth, elemScaledHeight);
        } else if (options.contain === 'outside') {
          minScale = Math.max(minScale, elemScaledWidth, elemScaledHeight);
        }
      }
    }

    result.scale = Math.min(Math.max(toScale, minScale), maxScale);
    return result;
  }

  function pan(toX, toY, panOptions, originalEvent) {
    var result = constrainXY(toX, toY, scale, panOptions); // Only try to set if the result is somehow different

    if (x !== result.x || y !== result.y) {
      x = result.x;
      y = result.y;
      return setTransformWithEvent('panzoompan', result.opts, originalEvent);
    }

    return {
      x: x,
      y: y,
      scale: scale,
      isSVG: isSVG,
      originalEvent: originalEvent
    };
  }

  function zoom(toScale, zoomOptions, originalEvent) {
    var result = constrainScale(toScale, zoomOptions);
    var opts = result.opts;

    if (!opts.force && opts.disableZoom) {
      return;
    }

    toScale = result.scale;
    var toX = x;
    var toY = y;

    if (opts.focal) {
      // The difference between the point after the scale and the point before the scale
      // plus the current translation after the scale
      // neutralized to no scale (as the transform scale will apply to the translation)
      var focal = opts.focal;
      toX = (focal.x / toScale - focal.x / scale + x * toScale) / toScale;
      toY = (focal.y / toScale - focal.y / scale + y * toScale) / toScale;
    }

    var panResult = constrainXY(toX, toY, toScale, {
      relative: false,
      force: true
    });
    x = panResult.x;
    y = panResult.y;
    scale = toScale;
    return setTransformWithEvent('panzoomzoom', opts, originalEvent);
  }

  function zoomInOut(isIn, zoomOptions) {
    var opts = _assign(_assign(_assign({}, options), {
      animate: true
    }), zoomOptions);

    return zoom(scale * Math.exp((isIn ? 1 : -1) * opts.step), opts);
  }

  function zoomIn(zoomOptions) {
    return zoomInOut(true, zoomOptions);
  }

  function zoomOut(zoomOptions) {
    return zoomInOut(false, zoomOptions);
  }

  function zoomToPoint(toScale, point, zoomOptions, originalEvent) {
    var dims = getDimensions(elem); // Instead of thinking of operating on the panzoom element,
    // think of operating on the area inside the panzoom
    // element's parent
    // Subtract padding and border

    var effectiveArea = {
      width: dims.parent.width - dims.parent.padding.left - dims.parent.padding.right - dims.parent.border.left - dims.parent.border.right,
      height: dims.parent.height - dims.parent.padding.top - dims.parent.padding.bottom - dims.parent.border.top - dims.parent.border.bottom
    }; // Adjust the clientX/clientY to ignore the area
    // outside the effective area

    var clientX = point.clientX - dims.parent.left - dims.parent.padding.left - dims.parent.border.left - dims.elem.margin.left;
    var clientY = point.clientY - dims.parent.top - dims.parent.padding.top - dims.parent.border.top - dims.elem.margin.top; // Adjust the clientX/clientY for HTML elements,
    // because they have a transform-origin of 50% 50%

    if (!isSVG) {
      clientX -= dims.elem.width / scale / 2;
      clientY -= dims.elem.height / scale / 2;
    } // Convert the mouse point from it's position over the
    // effective area before the scale to the position
    // over the effective area after the scale.


    var focal = {
      x: clientX / effectiveArea.width * (effectiveArea.width * toScale),
      y: clientY / effectiveArea.height * (effectiveArea.height * toScale)
    };
    return zoom(toScale, _assign(_assign({
      animate: false
    }, zoomOptions), {
      focal: focal
    }), originalEvent);
  }

  function zoomWithWheel(event, zoomOptions) {
    // Need to prevent the default here
    // or it conflicts with regular page scroll
    event.preventDefault();

    var opts = _assign(_assign(_assign({}, options), zoomOptions), {
      animate: false
    }); // Normalize to deltaX in case shift modifier is used on Mac


    var delta = event.deltaY === 0 && event.deltaX ? event.deltaX : event.deltaY;
    var wheel = delta < 0 ? 1 : -1;
    var toScale = constrainScale(scale * Math.exp(wheel * opts.step / 3), opts).scale;
    return zoomToPoint(toScale, event, opts);
  }

  function reset(resetOptions) {
    var opts = _assign(_assign(_assign({}, options), {
      animate: true,
      force: true
    }), resetOptions);

    scale = constrainScale(opts.startScale, opts).scale;
    var panResult = constrainXY(opts.startX, opts.startY, scale, opts);
    x = panResult.x;
    y = panResult.y;
    return setTransformWithEvent('panzoomreset', opts);
  }

  var origX;
  var origY;
  var startClientX;
  var startClientY;
  var startScale;
  var startDistance;
  var pointers = [];

  function handleDown(event) {
    // Don't handle this event if the target is excluded
    if (isExcluded(event.target, options)) {
      return;
    }

    addPointer(pointers, event);
    isPanning = true;
    options.handleStartEvent(event);
    origX = x;
    origY = y;
    trigger('panzoomstart', {
      x: x,
      y: y,
      scale: scale,
      isSVG: isSVG,
      originalEvent: event
    }, options); // This works whether there are multiple
    // pointers or not

    var point = getMiddle(pointers);
    startClientX = point.clientX;
    startClientY = point.clientY;
    startScale = scale;
    startDistance = getDistance(pointers);
  }

  function move(event) {
    if (!isPanning || origX === undefined || origY === undefined || startClientX === undefined || startClientY === undefined) {
      return;
    }

    addPointer(pointers, event);
    var current = getMiddle(pointers);

    if (pointers.length > 1) {
      // A startDistance of 0 means
      // that there weren't 2 pointers
      // handled on start
      if (startDistance === 0) {
        startDistance = getDistance(pointers);
      } // Use the distance between the first 2 pointers
      // to determine the current scale


      var diff = getDistance(pointers) - startDistance;
      var toScale = constrainScale(diff * options.step / 80 + startScale).scale;
      zoomToPoint(toScale, current);
    } else {
      // Panning during pinch zoom can cause issues
      // because the zoom has not always rendered in time
      // for accurate calculations
      // See https://github.com/timmywil/panzoom/issues/512
      pan(origX + (current.clientX - startClientX) / scale, origY + (current.clientY - startClientY) / scale, {
        animate: false
      }, event);
    }
  }

  function handleUp(event) {
    // Don't call panzoomend when panning with 2 touches
    // until both touches end
    if (pointers.length === 1) {
      trigger('panzoomend', {
        x: x,
        y: y,
        scale: scale,
        isSVG: isSVG,
        originalEvent: event
      }, options);
    } // Note: don't remove all pointers
    // Can restart without having to reinitiate all of them
    // Remove the pointer regardless of the isPanning state


    removePointer(pointers, event);

    if (!isPanning) {
      return;
    }

    isPanning = false;
    origX = origY = startClientX = startClientY = undefined;
  }

  var bound = false;

  function bind() {
    if (bound) {
      return;
    }

    bound = true;
    onPointer('down', options.canvas ? parent : elem, handleDown);
    onPointer('move', document, move, {
      passive: true
    });
    onPointer('up', document, handleUp, {
      passive: true
    });
  }

  function destroy() {
    bound = false;
    destroyPointer('down', options.canvas ? parent : elem, handleDown);
    destroyPointer('move', document, move);
    destroyPointer('up', document, handleUp);
  }

  if (!options.noBind) {
    bind();
  }

  return {
    bind: bind,
    destroy: destroy,
    eventNames: events,
    getPan: function getPan() {
      return {
        x: x,
        y: y
      };
    },
    getScale: function getScale() {
      return scale;
    },
    getOptions: function getOptions() {
      return shallowClone(options);
    },
    pan: pan,
    reset: reset,
    resetStyle: resetStyle,
    setOptions: setOptions,
    setStyle: function setStyle(name, value) {
      return _setStyle(elem, name, value);
    },
    zoom: zoom,
    zoomIn: zoomIn,
    zoomOut: zoomOut,
    zoomToPoint: zoomToPoint,
    zoomWithWheel: zoomWithWheel
  };
}

Panzoom.defaultOptions = defaultOptions;

// @ts-check
/**
 * Root element(s)
 */

const CONTAINER_CAROUSEL_SELECTOR = "." + JS_PREFIX + "SlickCarouselContainer";
const CONTAINER_CAROUSEL_ACTIVE_SELECTOR = CONTAINER_CAROUSEL_SELECTOR + "." + IS_ACTIVE_CLASS;
const FEATURE_CAROUSEL_SELECTOR = "." + JS_PREFIX + "SlickCarouselFeature";
const FEATURE_CAROUSEL_ACTIVE_SELECTOR = FEATURE_CAROUSEL_SELECTOR + "." + IS_ACTIVE_CLASS;
const THUMBNAIL_CAROUSEL_SELECTOR = "." + JS_PREFIX + "SlickCarouselThumbnail";
const THUMBNAIL_CAROUSEL_ACTIVE_SELECTOR = THUMBNAIL_CAROUSEL_SELECTOR + "." + IS_ACTIVE_CLASS;
const SLIDE_CAROUSEL_SELECTOR = "." + JS_PREFIX + "SlickCarouselSlide";
const $galleryCounter = jQuery("." + JS_PREFIX + "ProductGallery-countValue");
/**
 * Global active carousel index
 */

let activeSlideIndex = 0;
/**
 * Boolean check that all carousel slide totals are equal
 */

let allSlideTotalsMatch = true;
/**
 * Partial carousel settings
 */

const THUMB_SLIDES_TO_SHOW = 5;
/**
 * Number of thumbnails that fit within view
 */

const THUMB_SLIDES_SCROLL_GATE = 5;
/**
 * Utility class that adds cursor: grab;
 */

const THUMB_CURSOR_GRAB_CLASS = CSS_UTILITY_PREFIX + "cursorGrab";
/**
 * Load carousel images
 */

const loadImages = () => {
  jQuery(CONTAINER_CAROUSEL_ACTIVE_SELECTOR + " " + SLIDE_CAROUSEL_SELECTOR).each(function () {
    const $slide = jQuery(this); // Remove placeholder background color once image has loaded

    $slide.on('load', function () {
      $slide.removeClass(CSS_UTILITY_PREFIX + "bgSilver " + CSS_UTILITY_PREFIX + "bgWhite");
    });

    if (!$slide.attr('srcset')) {
      const srcset = $slide.data('srcset');
      $slide.attr('srcset', srcset);
    }

    if (!$slide.attr('sizes')) {
      const sizes = $slide.data('sizes');
      $slide.attr('sizes', sizes);
    }

    if (!$slide.attr('src')) {
      // This is called data-carousel-src because there is a global script which
      // modifies data-src
      const src = $slide.data('carousel-src');
      $slide.attr('src', src);
    }
  });
};
/**
 * Checks whether all variant slide totals are equal
 */


const initAllSlideTotalsMatch = () => {
  let previousSlideTotal = null;
  jQuery(FEATURE_CAROUSEL_SELECTOR).each((index, featureCarousel) => {
    const slideTotal = jQuery(featureCarousel).children().length;

    if (previousSlideTotal !== null && slideTotal !== previousSlideTotal) {
      allSlideTotalsMatch = false;
      return false;
    }

    previousSlideTotal = slideTotal;
  });
};
/**
 * Returns the slide count of Slick Carousel elements
 *
 * @return {Number} Total slide element count
 */


const getSlideCount = function getSlideCount() {
  let slidesTraversed;
  let swipedSlide;
  const centerOffset = this.options.centerMode === true ? this.slideWidth * Math.floor(this.options.slidesToShow / 2) : 0;

  if (this.options.swipeToSlide === true) {
    /**
     * $slideTrack references the container element for the individual slides
     */
    this.$slideTrack.find('.slick-slide').each((index, slide) => {
      let offsetPoint = slide.offsetLeft;
      let outerSize = jQuery(slide).outerWidth();

      if (this.options.vertical === true) {
        offsetPoint = slide.offsetTop;
        outerSize = jQuery(slide).outerHeight();
      }

      if (offsetPoint - centerOffset + outerSize / 2 > this.swipeLeft * -1) {
        swipedSlide = slide;
        return false;
      }
    });
    slidesTraversed = Math.abs(Number(jQuery(swipedSlide).attr('data-slick-index')) - this.currentSlide) || 1;
    return slidesTraversed;
  }

  return this.options.slidesToScroll;
};
/**
 * Returns the available indexes of Slick Carousel slides
 *
 * @returns {Array} Collection of navigable slide indexes
 */


const getNavigableIndexes = function getNavigableIndexes() {
  let breakPoint = 0;
  let counter = 0;
  const indexes = [];
  let max;

  if (this.options.infinite === false) {
    max = this.slideCount;
  } else {
    breakPoint = this.options.slideCount * -1;
    counter = this.options.slideCount * -1;
    max = this.slideCount * 2;
  }

  while (breakPoint < max) {
    indexes.push(breakPoint);
    breakPoint = counter + this.options.slidesToScroll;
    counter += this.options.slidesToScroll <= this.options.slidesToShow ? this.options.slidesToScroll : this.options.slidesToShow;
  }

  return indexes;
};
/**
 * Slick Carousel bugfix; allows swipeToSlide on vertical orientation
 * @see https://github.com/kenwheeler/slick/issues/1962
 */


const improveCarouselSwipeResponse = () => {
  jQuery(THUMBNAIL_CAROUSEL_ACTIVE_SELECTOR).each(function () {
    // @ts-ignore
    this.slick.getSlideCount = getSlideCount; // @ts-ignore

    this.slick.getNavigableIndexes = getNavigableIndexes;
  });
};
/**
 * Counter UI text format helper
 *
 * Formats the counter text for UI display.
 *
 * @param {Object} obj Counter data
 * @param {Number} obj.currentIndex The active index of shown carousel slide
 * @param {Number} obj.total The total count of the active carousel slides
 * @returns {string} Formatted text for UI display
 */


const formatCounterText = ({
  currentIndex,
  total
}) => currentIndex + 1 + "/" + total;
/**
 * Update carousel gallery counter value
 * @param {Object} counterData An object containing counter data
 */


const updateGalleryCounter = counterData => {
  $galleryCounter.text(formatCounterText(counterData));
};
/**
 * Adjust cursor for thumbnails to indicate scrolling when available
 * @param {Number} thumbnailCount The active thumbnail total
 */


const updateThumbnailCursors = thumbnailCount => {
  const buttonElements = jQuery(THUMBNAIL_CAROUSEL_ACTIVE_SELECTOR + " button");

  if (thumbnailCount > THUMB_SLIDES_SCROLL_GATE) {
    buttonElements.addClass(THUMB_CURSOR_GRAB_CLASS);
  } else {
    buttonElements.removeClass(THUMB_CURSOR_GRAB_CLASS);
  }
};
/**
 * Initialize carousel
 */


const initCarousel = () => {
  const $featureCarouselActive = jQuery(FEATURE_CAROUSEL_ACTIVE_SELECTOR);
  const $thumbnailCarouselActive = jQuery(THUMBNAIL_CAROUSEL_ACTIVE_SELECTOR);
  const activeSlideTotal = jQuery(FEATURE_CAROUSEL_ACTIVE_SELECTOR + ":first " + SLIDE_CAROUSEL_SELECTOR + ":not(.slick-cloned)").length;
  /**
   * Reset index when all slides do not match in length
   */

  if (!allSlideTotalsMatch) {
    activeSlideIndex = 0;
  }
  /**
   * Visit link for Slick configuration options
   * @see https://kenwheeler.github.io/slick/
   */


  const sharedConfig = {
    arrows: false,
    infinite: false,
    initialSlide: activeSlideIndex
  };
  /**
   * Keep activeSlideIndex in sync with active slide
   * Keep gallery counter in sync with active slide value and slide total
   */

  $featureCarouselActive.on('afterChange', (event, slick, currentSlide) => {
    activeSlideIndex = currentSlide;
    updateGalleryCounter({
      currentIndex: activeSlideIndex,
      total: slick.slideCount
    });
  });
  /**
   * On Slick initialization, set gallery counter active slide value and slide total
   */

  $featureCarouselActive.on('init', () => {
    updateGalleryCounter({
      currentIndex: activeSlideIndex,
      total: activeSlideTotal
    });
    loadImages();
    updateThumbnailCursors(activeSlideTotal);
  });
  $featureCarouselActive.slick(Object.assign({}, sharedConfig, {
    asNavFor: $thumbnailCarouselActive,
    slidesToShow: 1,
    waitForAnimate: false
  }));

  if (is_mobile_device()) ; else {
    $featureCarouselActive.slick('unslick');
  }

  $thumbnailCarouselActive.slick(Object.assign({}, sharedConfig, {
    asNavFor: $featureCarouselActive,
    focusOnSelect: true,
    slidesToShow: THUMB_SLIDES_TO_SHOW,
    vertical: true,
    verticalSwiping: true,
    swipeToSlide: true,
    touchThreshold: 30
  }));
  jQuery('.js-de-SlickCarouselFeature--popup').not('.slick-initialized').slick({
    asNavFor: jQuery('.js-de-SlickCarouselThumbnail--popup'),
    slidesToShow: 1,
    waitForAnimate: false,
    arrows: true
  });
  jQuery('.js-de-SlickCarouselThumbnail--popup').not('.slick-initialized').slick({
    asNavFor: jQuery('.js-de-SlickCarouselFeature--popup'),
    arrows: false,
    focusOnSelect: true,
    slidesToShow: THUMB_SLIDES_TO_SHOW,
    vertical: true,
    verticalSwiping: true,
    swipeToSlide: true,
    touchThreshold: 30,
    infinite: false,
    responsive: [{
      breakpoint: 500,
      settings: {
        vertical: false
      }
    }]
  });
  improveCarouselSwipeResponse();
};
/**
 * Add required active classes to elements
 * @param {string} containerClass Class name of container element
 */


const prepCarousel = containerClass => {
  jQuery(containerClass).addClass(IS_ACTIVE_CLASS);
  jQuery(containerClass + " > " + FEATURE_CAROUSEL_SELECTOR).addClass(IS_ACTIVE_CLASS);
  jQuery(containerClass + " > " + THUMBNAIL_CAROUSEL_SELECTOR).addClass(IS_ACTIVE_CLASS);
}; // Reset position


const resetPosition = panzoom => {
  panzoom.reset();
  jQuery("#containerArrows").show();
};
/**
 * Destroy and clean up carousel
 */


const destroyCarousel = () => {
  const $containerCarouselActive = jQuery(CONTAINER_CAROUSEL_ACTIVE_SELECTOR);
  const $featureCarouselActive = jQuery(FEATURE_CAROUSEL_ACTIVE_SELECTOR);
  const $thumbnailCarouselActive = jQuery(THUMBNAIL_CAROUSEL_ACTIVE_SELECTOR);
  $featureCarouselActive.slick('unslick');
  $thumbnailCarouselActive.slick('unslick');
  $featureCarouselActive.off();
  $thumbnailCarouselActive.off();
  $featureCarouselActive.removeClass(IS_ACTIVE_CLASS);
  $thumbnailCarouselActive.removeClass(IS_ACTIVE_CLASS);
  $containerCarouselActive.removeClass(IS_ACTIVE_CLASS);
};
/**
 * Watch for window resize event (debounced), refresh carousel
 */


const handleWindowResize = () => {
  let timeout = null;
  jQuery(window).resize(() => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      const $featureCarouselActive = jQuery(FEATURE_CAROUSEL_ACTIVE_SELECTOR);
      const $thumbnailCarouselActive = jQuery(THUMBNAIL_CAROUSEL_ACTIVE_SELECTOR); // Sync slide index when switching between carousels (desktop vs mobile carousels)

      $featureCarouselActive.slick('slickGoTo', activeSlideIndex);
      $thumbnailCarouselActive.slick('slickGoTo', activeSlideIndex);
    }, 250);
  });
};
/**
 * Reset active carousel to represent new model
 * @param {string} model
 */


const onColorSelect = model => {
  const containerClass = CONTAINER_CAROUSEL_SELECTOR + "[data-color=\"" + model + "\"]"; // Breaking up the work into separate tasks because Slick clogs the main thread a lot

  setTimeout(() => {
    destroyCarousel();
    prepCarousel(containerClass);
  });
  setTimeout(() => {
    initCarousel();
  }); // Zoom
  // @docs: https://www.npmjs.com/package/@panzoom/panzoom

  const element = document.getElementById("de-CarouselFeature--popup-" + model);
  const panzoom = Panzoom(element, {
    animate: true,
    maxZoom: 3,
    minZoom: 1,
    step: 0.4,
    panOnlyWhenZoomed: true
  });
  jQuery(".zoomIn").on("click", () => {
    panzoom.zoomIn();
    jQuery(".containerArrows").hide();
  });
  jQuery(".zoomOut").on("click", () => {
    if (panzoom.getScale() <= 1.5) {
      resetPosition(panzoom);
    } else {
      panzoom.zoomOut();
    }
  });
  jQuery("#thumbArrows").on("click", () => {
    resetPosition(panzoom);
  });
};
/**
 * Put all functions that need to run on product-page load here
 */

const init = () => {
  initAllSlideTotalsMatch();
  initCarousel();
  handleWindowResize();
};

/**
 * Root element(s)
 */

const $slideCarousel = jQuery("." + JS_PREFIX + "CarouselContextSlide");
/**
 * Load carousel images
 */

const loadImages$1 = () => {
  $slideCarousel.each(function () {
    const $slide = jQuery(this);

    if (!$slide.attr('srcset')) {
      const srcset = $slide.data('srcset');
      $slide.attr('srcset', srcset);
    }

    if (!$slide.attr('sizes')) {
      const sizes = $slide.data('sizes');
      $slide.attr('sizes', sizes);
    }

    if (!$slide.attr('src')) {
      // This is called data-carousel-src because there is a global script which
      // modifies data-src
      const srcset = $slide.data('carousel-src');
      $slide.attr('src', srcset);
    }
  });
};
/**
 * Put all functions that need to run on product-page load here
 */


const init$1 = () => {
  loadImages$1();
};

// @ts-check
const productsJSON = window.productJSON;
const variantsJSON = [];

for (const variant of productsJSON.variants) {
  if (!document.getElementById("hidden-" + variant.id) || variant.available) {
    variantsJSON.push(variant);
  }
}

if (variantsJSON.length === 0) {
  for (const variant of productsJSON.variants) {
    variantsJSON.push(variant);
  }
}

const COLOR_INDEX = productsJSON.options.indexOf('Color');
const SIZE_INDEX = productsJSON.options.indexOf('Size');
const MODEL_INDEX = productsJSON.options.indexOf('Model Code');
const COLOR_OPTION = "option" + (COLOR_INDEX + 1);
const SIZE_OPTION = "option" + (SIZE_INDEX + 1);
const MODEL_OPTION = "option" + (MODEL_INDEX + 1);
const productId = productsJSON.id;
/**
 * Helper to get the variant based on a color & size or ID
 *
 * @param {Object} obj The selected options data
 * @param {string} [obj.size] The selected size option
 * @param {string} [obj.model] The selected color option
 * @param {string} [obj.color] The selected color option
 * @param {number} [obj.id] A product variant ID
 * @param {Array} [obj.source = variantsJSON] The array to filter to find a
 * product variant
 * @returns {Variant | undefined} A product variant object
 */

const getSelectedVariant = ({
  size,
  model,
  id,
  source = variantsJSON
} = {}) => {
  if (!Array.isArray(source) || !id && (!model || !size)) {
    return;
  }

  return source.find(variant => variant[SIZE_OPTION] === size && variant[MODEL_OPTION] == model || variant.id === id);
};
/**
 * Helper to get an available variant based on color & size or ID
 *
 * @param {Object} obj The selected options data
 * @param {string} [obj.size] The selected size option
 * @param {string} [obj.color] The selected color option
 * @param {string} [obj.model] The selected model option
 * @param {number} [obj.id] A product variant ID
 * @returns {Variant | undefined} A product variant object
 */

const getAvailableSelectedVariant = ({
  size,
  id,
  color,
  model
}) => getSelectedVariant({
  size,
  color,
  id,
  model,
  source: availableVariants()
});
/**
 * Gets model code from variant
 *
 * @param {Variant} variant
 * @returns {string} Variant model code
 */

const getModelCodeFromVariant = variant => variant[MODEL_OPTION];
/**
 * Filters for available variants
 *
 * @returns {Variant[]} An array of available variants
 */

const availableVariants = () => variantsJSON.filter(isVariantAvailable);
/**
 * Filters for available variants
 *
 * @param {String} modelCode
 * @returns {Variant[]} An array of variants from model code
 */

const getVariantsFromModelCode = modelCode => variantsJSON.filter(variant => variant[MODEL_OPTION] == modelCode);
/**
 * Returns all options (option1) that share a variant with given option (option2)
 *
 * @param {Object} params An object
 * @param {string} params.searchOption Title of option to find matches in
 * @param {string} params.findOption Title of option to match
 * @param {string | undefined} params.value Value of option to find matches in
 * @param {Array} params.variants Array of variants to filter on
 * @returns {Array} Options with matches to given option
 */

const getOptionCombinations = ({
  searchOption,
  findOption,
  value,
  variants
}) => {
  return variants.reduce((accArray, variant) => {
    if (!accArray.includes(variant[searchOption])) {
      if (value) {
        if (value == variant[findOption]) {
          accArray.push(variant[searchOption]);
        }
      } else {
        accArray.push(variant[searchOption]);
      }
    }

    return accArray;
  }, []);
};
/**
 * Gets existing colors from size
 *
 * @param {string} size A size value
 * @returns {Array} Existing colors
 */


const getExistingColorsFromSize = size => getOptionCombinations({
  searchOption: MODEL_OPTION,
  findOption: SIZE_OPTION,
  value: size,
  variants: variantsJSON
});
/**
 * Gets existing sizes from color
 *
 * @param {string} model A model value
 * @returns {Array} Existing sizes
 */

const getExistingSizesFromModel = model => getOptionCombinations({
  searchOption: SIZE_OPTION,
  findOption: MODEL_OPTION,
  value: model,
  variants: variantsJSON
});
/**
 * Gets available colors from size
 *
 * @param {string} size A size value
 * @returns {Array} Available colors
 */

const getAvailableColorsFromSize = size => getOptionCombinations({
  searchOption: MODEL_OPTION,
  findOption: SIZE_OPTION,
  value: size,
  variants: availableVariants()
});
/**
 * Gets available sizes from color
 *
 * @param {string} model A color value
 * @returns {Array} Available sizes
 */

const getAvailableSizesFromModel = model => getOptionCombinations({
  searchOption: SIZE_OPTION,
  findOption: MODEL_OPTION,
  value: model,
  variants: availableVariants()
});
/**
 * @typedef {Object} VariantOptions
 * @property {string | null} size
 * @property {string | null} color
 * @property {string | null} model
 */

/**
 * @param {Variant} variant
 * @returns {VariantOptions}
 */

const getVariantOptions = variant => ({
  size: variant[SIZE_OPTION],
  color: variant[COLOR_OPTION],
  model: variant[MODEL_OPTION]
});
/**
 * Helper to know if a product variant is available
 * @param {Variant} variant
 * @returns {boolean}
 */

const isVariantAvailable = variant => variant == null ? void 0 : variant.available;
/**
 * Helper to know if a product variant is "out of stock"
 * @see https://app.gitbook.com/@decathlonusa/s/shopify/product-feature/product-page#sold-out-logic
 * @param {Variant} variant
 * @returns {boolean}
 */

const isVariantOutOfStock = variant => !isVariantAvailable(variant) && !isNonFollowedProduct(productsJSON);
/**
 * Helper to know if a product variant is "sold out"
 * @see https://app.gitbook.com/@decathlonusa/s/shopify/product-feature/product-page#sold-out-logic
 * @param {Variant} variant
 * @returns {boolean}
 */

const isVariantSoldOut = variant => !isVariantAvailable(variant) && isNonFollowedProduct(productsJSON);

class Variant {
  constructor(htmlElement) {
    this.id = htmlElement.getAttribute("data-variant-id");
    this.sku = htmlElement.getAttribute("data-sku");
    this.maxAllowedQuantity = htmlElement.getAttribute("data-max-allowed-quantity");
    this.totalInventoryQuantity = htmlElement.getAttribute("data-total-inventory-quantity");
    this.option1 = htmlElement.getAttribute("data-option-1");
    this.option2 = htmlElement.getAttribute("data-option-2");
    this.option3 = htmlElement.getAttribute("data-option-3");
  }

}

class VariantCollection {
  constructor() {
    this.variants = new Array();
    this.existingOptions3 = new Array();
    this.existingOptions2 = new Array();
  }

  addVariant(variant) {
    this.variants.push(variant);

    if (!(this.existingOptions3.indexOf(variant.option3) >= 0)) {
      // On evite les doublons
      this.existingOptions3.push(variant.option3);
    }

    if (!(this.existingOptions2.indexOf(variant.option2) >= 0)) {
      // On evite les doublons
      this.existingOptions2.push(variant.option2);
    }
  }

  findMatchingVariants() {
    if (this.variants.length == 0) {
      return null;
    }

    let strOption3 = '';
    const selectedOption3s = document.getElementsByClassName(JS_PREFIX + "ColorSwatches-option de-is-active");

    if (selectedOption3s.length > 0) {
      const selectedOption3 = selectedOption3s.item(0);
      strOption3 = selectedOption3.dataset.modelCode;
    }

    let strOption2 = ''; // $selectedOption2 = $('.js-de-SizeSwatches-option.de-is-active:first');

    const selectedOption2s = document.getElementsByClassName(JS_PREFIX + "SizeSwatches-option de-is-active");

    if (selectedOption2s.length > 0) {
      const selectedOption2 = selectedOption2s.item(0);
      strOption2 = selectedOption2.value;
    }

    const tempCollections = new Array();
    let matchingVariantsForOption3 = new Array();
    let matchingVariantsForOption2 = new Array(); // Si pas d'options 3 dans les options 3 existantes alors pas de selections a faire parmi les variants qui ont cette option
    // variants qui matchent avec l'option 3

    if (this.existingOptions3.length >= 2) {
      // Au moins deux options 3 possibles
      for (var i = 0; i < this.variants.length; i++) {
        if (this.variants[i].option3 == strOption3) {
          // Le variant match avec cette option
          matchingVariantsForOption3.push(this.variants[i]);
        }
      }
    } else {
      // Moins de deux options 3 possibles, tous les variants sont acceptables
      matchingVariantsForOption3 = this.variants;
    } // Variants qui matchent avec l'option 2


    if (this.existingOptions2.length >= 2) {
      // Au moins deux options 2 possibles
      for (var i = 0; i < this.variants.length; i++) {
        if (this.variants[i].option2 == strOption2) {
          // Le variant match avec cette option
          matchingVariantsForOption2.push(this.variants[i]);
        }
      }
    } else {
      // Moins de deux options 2 possibles, tous les variants sont acceptables
      matchingVariantsForOption2 = this.variants;
    } // Ici quel est le variant commun aux deux listes ?


    if (matchingVariantsForOption3.length >= 1 && matchingVariantsForOption2.length >= 1) {
      let variantConcerne = null;

      for (let i = 0; i < this.variants.length; i++) {
        if (matchingVariantsForOption3.indexOf(this.variants[i]) >= 0 && matchingVariantsForOption2.indexOf(this.variants[i]) >= 0) {
          // Variant trouve
          if (variantConcerne !== null) {
            console.error('Deux variants ont été trouvés pour la combinaison d\'option.');
          }

          variantConcerne = this.variants[i];
        }
      }

      if (variantConcerne !== null) {
        return variantConcerne;
      }
    } else {
      // Aucune solutions trouvee
      return null;
    }
  }

}

class Location {
  constructor() {
    const locationObj = getWithExpiry('locations');

    if (locationObj) {
      this.locations = locationObj.locations;
    } else {
      const countryCode = document.getElementById("stock-country-code").innerHTML;
      const shopUrl = window.location.href;
      let url = '';

      if (shopUrl.includes('preprod')) {
        url += "https://pp-decafy-stock.decathlon.net/locations/" + countryCode;
      } else {
        url += "https://decafy-stock.decathlon.net/locations/" + countryCode;
      }

      fetch("" + url).then(result => result.json()).then(data => {
        setWithExpiry('locations', {
          locations: data
        }, 86400000);
        this.locations = data;
      });
    }

    if (!this.locations) this.locations = [];
  }

}

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);

  if (!itemStr) {
    return null;
  }

  const item = JSON.parse(itemStr);
  const now = new Date();

  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }

  return item.value;
}

function setWithExpiry(key, value, ttl) {
  const now = new Date();
  const item = {
    value,
    expiry: now.getTime() + ttl
  };
  localStorage.setItem(key, JSON.stringify(item));
}

// Copié collé de ./index.js, à mettre à jour
// const API_ENDPOINT = `/apps/${process.env.DECATHLON_INVENTORY_APP_PROXY_SUBPATH}/v1`;
const variantCollection = new VariantCollection();
const LocationClass = new Location(); // Const state = createState(/** @type {State} */ ({}));

const buildCollection = () => {
  const htmlVariants = document.getElementsByClassName("variant-details-for-js");

  if (htmlVariants.length > 0) {
    for (let i = 0; i < htmlVariants.length; i++) {
      const variant = new Variant(htmlVariants[i]);
      variantCollection.addVariant(variant);
    }
  }
};
const findMatchingVariants = async () => {
  const variantConcerne = variantCollection.findMatchingVariants();

  if (variantConcerne) {
    // On affiche les stores inventory
    const url = "https://" + location.hostname + "//variants/" + variantConcerne.id + "/?section_id=store-availability&display=true";
    fetch(url).then(function (response) {
      return response.text();
    }).then(response => {
      document.getElementById("store-availability-information").innerHTML = response;
      const locations = [...document.querySelectorAll('li.js-location')];
      const locationsIds = [];
      let shopLocations = LocationClass.locations;
      if (!shopLocations) shopLocations = [];
      locations.forEach(location => {
        locationsIds.push(location.dataset.locationId);
      });
      let countLocations = locations.length;
      const drawerTitle = document.querySelector('.shops-drawer-body-header-title');
      drawerTitle.innerHTML = "" + translate("Encontramos {{shopCount}} tiendas cercanas", {
        shopCount: shopLocations.length === 0 ? locations.length : shopLocations.length
      });
      shopLocations = shopLocations.filter(shopLocation => !locationsIds.includes("" + shopLocation.id));
      const shopList = document.querySelector("ul.shops-drawer-body-list");
      shopLocations.forEach(element => {
        countLocations++;
        const selectContainerContent = document.createElement('li');
        selectContainerContent.classList.add('shops-drawer-shop-content-unavailable');
        selectContainerContent.innerHTML = "\n                        <h4 class=\"shops-drawer-shop-name\">" + countLocations + " - " + element.name + "</h4>\n                        <span class=\"shops-drawer-shop-unavailable\">" + translate("Agotado en tienda") + "</span>\n                      ";
        shopList.appendChild(selectContainerContent);
      });
      addStoreSelectorEventListener();
      initDrawer();
      const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
      const d = new Date();
      const dayName = days[d.getDay()];
      const hour = d.toLocaleString('en-GB', {
        hour: '2-digit',
        minute: '2-digit'
      });
      locations.forEach(location => {
        let isClosed = false;
        let day = dayName;
        const locationId = location.dataset.locationId;
        let openingHour = document.getElementById("js-" + dayName + "-" + locationId + "-opening");
        let closingHour = document.getElementById("js-" + dayName + "-" + locationId + "-closing");
        if (!openingHour || !closingHour) return;
        if (closingHour.innerHTML < hour) isClosed = true;

        if (isClosed) {
          day = days[d.getDay() == 6 ? 0 : d.getDate() + 1];
          openingHour = document.getElementById("js-" + day + "-" + locationId + "-opening");
          closingHour = document.getElementById("js-" + day + "-" + locationId + "-closing");
          location.innerHTML += "<span class=\"shops-drawer-shop-hours\">" + translate("Tienda abierta hoy desde{{openingHour}} a {{closingHour}}", {
            openingHour: openingHour.innerHTML,
            closingHour: closingHour.innerHTML
          }) + "</span>";
        } else {
          location.innerHTML += "<span class=\"shops-drawer-shop-hours\">" + translate("Tienda abierta mañana desde {{openingHour}} a {{closingHour}}", {
            openingHour: openingHour.innerHTML,
            closingHour: closingHour.innerHTML
          }) + "</span>";
        }
      });
    });
  }
};

function initDrawer() {
  const Drawer = function Drawer(element) {
    this.element = element;
    this.content = document.getElementsByClassName('js-drawer__body')[0];
    this.triggers = document.querySelectorAll("[aria-controls=\"" + this.element.getAttribute('id') + "\"]");
    this.firstFocusable = null;
    this.lastFocusable = null;
    this.selectedTrigger = null;
    this.isModal = this.element.classList.contains('js-drawer--modal');
    this.showClass = "drawer--is-visible";
    this.preventScrollEl = this.getPreventScrollEl();
    this.initDrawer();
  };

  Drawer.prototype.getPreventScrollEl = function () {
    let scrollEl = false;
    const querySelector = this.element.getAttribute('data-drawer-prevent-scroll');
    if (querySelector) scrollEl = document.querySelector(querySelector);
    return scrollEl;
  };

  Drawer.prototype.initDrawer = function () {
    const self = this; // Open drawer when clicking on trigger buttons

    if (this.triggers) {
      for (let i = 0; i < this.triggers.length; i++) {
        this.triggers[i].addEventListener('click', function (event) {
          event.preventDefault();

          if (self.element.classList.contains(self.showClass)) {
            self.closeDrawer(event.target);
            return;
          }

          self.selectedTrigger = event.target;
          self.showDrawer();
          self.initDrawerEvents();
        });
      }
    } // If drawer is already open -> we should initialize the drawer events


    if (self.element.classList.contains(self.showClass)) this.initDrawerEvents();
  };

  Drawer.prototype.showDrawer = function () {
    const self = this;
    this.content.scrollTop = 0;
    self.element.classList.add(self.showClass);
    this.getFocusableElements();
    self.element.focus(); // Wait for the end of transitions before moving focus

    this.element.addEventListener("transitionend", function cb(event) {
      self.element.focus();
      self.element.removeEventListener("transitionend", cb);
    });
    this.emitDrawerEvents('drawerIsOpen', this.selectedTrigger); // Change the overflow of the preventScrollEl

    if (this.preventScrollEl) this.preventScrollEl.style.overflow = 'hidden';
    document.getElementById('drawer-overlay-1').classList.toggle('hidden');
  };

  Drawer.prototype.closeDrawer = function (target) {
    this.element.classList.remove(this.showClass);
    this.firstFocusable = null;
    this.lastFocusable = null;
    if (this.selectedTrigger) this.selectedTrigger.focus(); // Remove listeners

    this.cancelDrawerEvents();
    if (target) this.emitDrawerEvents('drawerIsClose', target); // Change the overflow of the preventScrollEl

    if (this.preventScrollEl) this.preventScrollEl.style.overflow = '';
    document.getElementById('drawer-overlay-1').classList.toggle('hidden');
  };

  Drawer.prototype.initDrawerEvents = function () {
    // Add event listeners
    this.element.addEventListener('keydown', this);
    this.element.addEventListener('click', this);
    document.getElementById('drawer-overlay-1').addEventListener('click', this);
  };

  Drawer.prototype.cancelDrawerEvents = function () {
    // Remove event listeners
    this.element.removeEventListener('keydown', this);
    this.element.removeEventListener('click', this);
  };

  Drawer.prototype.handleEvent = function (event) {
    switch (event.type) {
      case 'click':
        {
          this.initClick(event);
        }

      case 'keydown':
        {
          this.initKeyDown(event);
        }
    }
  };

  Drawer.prototype.initKeyDown = function (event) {
    if (event.keyCode && event.keyCode == 27 || event.key && event.key == 'Escape') {
      // Close drawer window on esc
      this.closeDrawer(false);
    } else if (this.isModal && (event.keyCode && event.keyCode == 9 || event.key && event.key == 'Tab')) {
      // Trap focus inside drawer
      this.trapFocus(event);
    }
  };

  Drawer.prototype.initClick = function (event) {
    // Close drawer when clicking on close button or drawer bg layer 
    if (!event.target.closest('.js-drawer__close') && !event.target.classList.contains('.js-drawer__close')) return;
    event.preventDefault();
    this.closeDrawer(event.target);
  };

  Drawer.prototype.trapFocus = function (event) {
    if (this.firstFocusable == document.activeElement && event.shiftKey) {
      // On Shift+Tab -> focus last focusable element when focus moves out of drawer
      event.preventDefault();
      this.lastFocusable.focus();
    }

    if (this.lastFocusable == document.activeElement && !event.shiftKey) {
      // On Tab -> focus first focusable element when focus moves out of drawer
      event.preventDefault();
      this.firstFocusable.focus();
    }
  };

  Drawer.prototype.getFocusableElements = function () {
    // Get all focusable elements inside the drawer
    const allFocusable = this.element.querySelectorAll('[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable], audio[controls], video[controls], summary');
    this.getFirstVisible(allFocusable);
    this.getLastVisible(allFocusable);
  };

  Drawer.prototype.getFirstVisible = function (elements) {
    // Get first visible focusable element inside the drawer
    for (let i = 0; i < elements.length; i++) {
      if (elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length) {
        this.firstFocusable = elements[i];
        return true;
      }
    }
  };

  Drawer.prototype.getLastVisible = function (elements) {
    // Get last visible focusable element inside the drawer
    for (let i = elements.length - 1; i >= 0; i--) {
      if (elements[i].offsetWidth || elements[i].offsetHeight || elements[i].getClientRects().length) {
        this.lastFocusable = elements[i];
        return true;
      }
    }
  };

  Drawer.prototype.emitDrawerEvents = function (eventName, target) {
    const event = new CustomEvent(eventName, {
      detail: target
    });
    this.element.dispatchEvent(event);
  };

  window.Drawer = Drawer; // Initialize the Drawer objects

  const drawer = document.getElementsByClassName('js-drawer');

  if (drawer.length > 0) {
    for (let i = 0; i < drawer.length; i++) {
      (function (i) {
        new Drawer(drawer[i]);
      })(i);
    }
  }
}

const addStoreSelectorEventListener = () => {
  // Var elements = document.getElementsByClassName('lieu-de-disponibilite');
  // for(var i = 0; i < elements.length; i++) {
  //     elements[i].addEventListener('click', function(){
  //         console.log('clock');
  //     }, false);
  // }
  const elements = document.getElementsByClassName('lieu-de-disponibilite-select');

  for (let i = 0; i < elements.length; i++) {
    elements[i].addEventListener('change', function () {
      // On cache tous les magasins
      const idSelectedLocation = this.value;
      const lieux = document.getElementsByClassName('lieu-de-disponibilite');

      for (var j = 0; j < lieux.length; j++) {
        if (lieux[j].classList.contains("show")) {
          lieux[j].classList.remove("show");
        }
      } // On affiche celui selectionne


      for (var j = 0; j < lieux.length; j++) {
        const idLocation = lieux[j].getAttribute("data-id-location");

        if (idLocation == idSelectedLocation) {
          lieux[j].classList.add("show");
        }
      }
    }, false);
  }
};
/**
 * Initializes functionality by setting up event binding
 *
 * @todo Consider removing jQuery dependency
 */

const init$2 = () => {
  buildCollection();
  addStoreSelectorEventListener();
};

// @ts-check
/**
 * @typedef State
 * @property {string} [color]
 * @property {string} [model]
 * @property {string} [title]
 * @property {HTMLElement} [selectedOption]
 */

const state = createState(
/** @type {State} */
{});
/**
 * Module-specific constants
 */

const CLICK_EVENT = 'click';
/**
 * Root element
 */

const $Swatches = jQuery("." + JS_PREFIX + "ColorSwatches");
/** @type {NodeListOf<HTMLButtonElement>} */

const swatchOptionEls = document.querySelectorAll("." + JS_PREFIX + "ColorSwatches-option");
const $ColorSwatchesOptions = jQuery(swatchOptionEls);
const $ColorInfo = jQuery("." + JS_PREFIX + "ColorInfo");
const $TitleInfo = jQuery("." + JS_PREFIX + "TitleInfo");
/**
 * Updates the selected color UI state
 *
 * @param {Element} selectedOption The selected option HTML element
 */

const updateColorUiState = selectedOption => {
  // Visually unselect all options
  $ColorSwatchesOptions.removeClass(IS_ACTIVE_CLASS); // Then visually select the current option

  jQuery(selectedOption).addClass(IS_ACTIVE_CLASS);
};

const selectFirstSwatch = () => {
  const firstAvailableVariant = availableVariants()[0];
  const modelCode = firstAvailableVariant && getVariantOptions(firstAvailableVariant).model;
  const firstSwatch = $ColorSwatchesOptions.toArray().find(el => el.dataset.promotion !== "") || modelCode && $ColorSwatchesOptions.toArray().find(el => el.dataset.modelCode === modelCode);
  if (firstSwatch) firstSwatch.click(); // Handle sale flag  if is firstSwatch

  if ($ColorSwatchesOptions.toArray().find(el => el.dataset.promotion !== "")) {
    const price = jQuery('.js-de-CurrentPrice .js-de-PriceAmount');
    jQuery('.on_sale_product_flag').removeClass('de-u-hidden');
    price.addClass('de-price-red');
    price.removeClass('de-price-yellow');
  }
};
/**
 * Handles UI updates for the Color Swatches component
 *
 * @param {State} state

 */

const render = ({
  selectedOption,
  color,
  title
}) => {
  // We need to update the selected color option UI state
  updateColorUiState(selectedOption); // We need to update the selected color & title text

  $ColorInfo.text(color); // $TitleInfo.text(title); les composants se sont rerendus, donc on peut lancer la determination du variant a partir des classes css selectionnees

  findMatchingVariants();
};

state.onChange(render);
/** @param {(color: string, model: string) => void} cb */

const handleColorSelect = cb => state.onChange(({
  color,
  model
}) => cb(color, model), state => [state.color, state.model, state.title]);
/**
 * Handler for when a color choice is made
 *
 * @todo Consider removing jQuery dependency
 * @this {HTMLElement} The triggered color swatch option element
 */

const onColorSelect$1 = function onColorSelect() {
  state.updateState({
    // @todo Consider removing jQuery dependency
    // @ts-ignore
    color: jQuery(this).val(),
    model: jQuery(this).data("modelCode"),
    title: jQuery(this).data("modelTitle"),
    selectedOption: this
  });
};
/**
 * Initializes functionality by setting up event binding
 *
 * @todo Consider removing jQuery dependency
 */


const init$3 = () => {
  $ColorSwatchesOptions.on(CLICK_EVENT, onColorSelect$1); // We want to select first available or only color swatch on page init

  selectFirstSwatch();
  findMatchingVariants();
};

// @ts-check
/**
 * @typedef State
 * @property {string | null | undefined} size
 * @property {HTMLElement | undefined} selectedOption
 * @property {Variant | null | undefined} variant
 * @property {string | null | undefined} color
 * @property {string | null | undefined} model
 */

/** @type State */

const initialState = {
  size: null,
  selectedOption: null,
  variant: null,
  color: null,
  model: null
};
const state$1 = createState(initialState);
/**
 * Module-specific constants
 */

const CLICK_EVENT$1 = 'click';
/**
 * Root element
 */

const $Swatches$1 = jQuery("." + JS_PREFIX + "SizeSwatches");
const $SwatchContainer = jQuery("." + JS_PREFIX + "SizeContainer");
/** @type {NodeListOf<HTMLButtonElement>} */

const swatchOptionEls$1 = document.querySelectorAll("." + JS_PREFIX + "SizeSwatches-option");
/** @type {HTMLElement} */

const validationTextEl = document.querySelector("." + VALIDATION_MESSAGE_CLASS);
const $SizeSwatchesOptions = jQuery(swatchOptionEls$1);
const $SizeInfo = jQuery("." + JS_PREFIX + "SizeInfo");
/**
 * Updates the selected size UI state
 *
 * @param {Element} selectedOption The selected option HTML element
 */

const updateSizeUiState = selectedOption => {
  // Visually unselect all options
  $SizeSwatchesOptions.removeClass(IS_ACTIVE_CLASS); // Then visually select the current option

  jQuery(selectedOption).addClass(IS_ACTIVE_CLASS); // Price type flag handle

  const flagEl = jQuery('.js-de-ProductFlag');
  let priceType = jQuery(selectedOption).attr('data-price-type');

  switch (priceType) {
    case "STANDARD":
      jQuery(flagEl).hide();
      jQuery(flagEl).text("STANDARD");
      break;

    case "DAY_TO_DAY_PROMOTION":
      jQuery(flagEl).show();
      jQuery(flagEl).text("{{'products.product.on_promotion' | t }}");
      break;

    case "SEASON_SALES":
      jQuery(flagEl).show();
      jQuery(flagEl).text("{{'products.product.on_sale' | t }}");
      break;

    case "END_OF_LINE":
      jQuery(flagEl).show();
      jQuery(flagEl).text("{{ 'collections.trending_products.end_series' | t }}");
      break;

    default:
      jQuery(flagEl).hide();
      break;
  }
};
/**
 * Makes the DOM match the state
 * @param {State} state
 */


const render$1 = ({
  selectedOption,
  size,
  variant,
  model
}) => {
  $Swatches$1.toggleClass(IS_HIDDEN_CLASS, getExistingSizesFromModel(model).length === 1);
  const addToCartButton = document.getElementById('AddToCart');
  if (getExistingSizesFromModel(model).length === 1) addToCartButton.dataset.display = ''; // We need to update the selected color option UI state

  updateSizeUiState(selectedOption); // We need to update the selected color text

  $SizeInfo.text(variant ? size : PRODUCT_PAGE_COPY.SELECT_A_SIZE); // Les composants se sont rerendus, donc on peut lancer la determination du variant a partir des classes css selectionnees

  findMatchingVariants(); // Trigger click to update active size on DOM ready or state change

  jQuery('.de-SwatchObjects-item.de-is-active').trigger("click");
};

state$1.onChange(render$1);
/**
 * @param {string | undefined} model
 */

const onColorSelect$2 = model => {
  const existingSizes = getExistingSizesFromModel(model);

  if (existingSizes.length === 1) {
    if (document.getElementById('productBuyBoxSizeText')) document.getElementById('productBuyBoxSizeText').remove();
    const onlyApplicableSize = existingSizes[0];
    document.querySelector('.de-ProductPageTopShelf-sizeSwatches .product__buybox_label_container').innerHTML += "<span id=\"productBuyBoxSizeText\">" + onlyApplicableSize + "</span>";

    if (onlyApplicableSize !== state$1.getState().size) {
      const target = $SizeSwatchesOptions.filter((_index, el) => el.value === onlyApplicableSize).get(0);
      onSizeSelect.bind(target)();
    }
  }

  state$1.updateState({
    model
  });
};
/** @param {(size: string) => void} cb */

const handleSizeSelect = cb => state$1.onChange(({
  size
}) => cb(size), state => [state.size]);
/**
 * Handler for when a size choice is made
 *
 * @todo Consider removing jQuery dependency
 * @this HTMLElement The triggered size swatch option element
 */

const onSizeSelect = function onSizeSelect() {
  // @todo Consider removing jQuery dependency
  const newSize = jQuery(this).val();
  const oldSize = state$1.getState().size;
  state$1.updateState({
    // @ts-ignore
    size: newSize,
    selectedOption: this
  });

  if (newSize !== oldSize) {
    resetMissingSizeInfo();
  }
};
/**
 * @param {Variant} variant
 */


const onVariantSelect = variant => {
  state$1.updateState({
    variant
  });
  resetMissingSizeInfo();
};

const showMissingSizeInfo = () => {
  if (validationTextEl) {
    var _window$DEC_GLOBALS;

    validationTextEl.textContent = // For specific products, we want to show a custom error message controlled by DY
    ((_window$DEC_GLOBALS = window.DEC_GLOBALS) == null ? void 0 : _window$DEC_GLOBALS.alternateSizeError) || PRODUCT_PAGE_COPY.SELECT_A_SIZE;
  }
};

const resetMissingSizeInfo = () => {
  if (validationTextEl) {
    validationTextEl.textContent = '';
  }
};

const handleAddToCartAttemptWithNoVariant = () => {
  // Can't add to cart if no size is selected
  showMissingSizeInfo();
};
/**
 * Initializes functionality by setting up event binding
 *
 * @todo Consider removing jQuery dependency
 */

const init$4 = () => {
  $SizeSwatchesOptions.on(CLICK_EVENT$1, onSizeSelect);
  findMatchingVariants();
};

// @ts-check

let videojs = window.videojs;
let brightCove = window.bc;
const galleryVideoId = 'gallery_video';
const accountId = '3415345270001';
const playerId = 'jQMS54WMw';
const videoCarouselSelector = "." + JS_PREFIX + "slick--videos";
const videoSectionSelector = "." + JS_PREFIX + "VideoSection";
const accordionSelector = "." + JS_PREFIX + "Accordion";
const thumbnailCarouselSelector = "." + JS_PREFIX + "slick--videos-thumbnails";
const gallerySelector = "." + JS_PREFIX + "ProductGallery-showcase";
const mobileGalleryControlsSelector = "." + JS_PREFIX + "MobileGalleryControls";
const controlsWrapperSelector = "." + JS_PREFIX + "GalleryControlsWrapper";
const mobileGalleryControlsWrapperSelector = mobileGalleryControlsSelector + " " + controlsWrapperSelector;
const galleryMediaToggleSelector = "." + JS_PREFIX + "toggle-media"; // 960 roughly equates to the media query variable $breakpoint-lg

const LARGE_BREAKPOINT = 960; // When element is within viewport

const IS_INTERSECTING_CLASS = CSS_PREFIX + "is-intersecting";
/**  @type {import('video.js').VideoJsPlayer[]} */

const players = []; // Create array for error video IDs

/** @type {string[]} */

const errorVideoIds = [];
/**
 * Handle all players' play event
 *
 * @param {Event} event The handler event object
 */

const onPlay = event => {
  // Determine which player the event is coming from
  const {
    id
  } =
  /** @type {HTMLElement} */
  event.target; // Loop through the array of players

  for (let i = 0; i < players.length; i++) {
    // Get the player(s) that did not trigger the play event
    if (players[i].id() !== id) {
      // Pause the other player(s)
      videojs(players[i].id()).pause();
    }
  }
};
/**
 * Track all players' errors or error events
 *
 * @param {string} videoId - The ID of the video in error
 */


const trackVideosWithErrors = videoId => {
  // Build the product URL
  const productURL = window.location.host + window.location.pathname; // Send an event to Google Analytics, only one per broken video

  if (!errorVideoIds.includes(videoId)) {
    window.dataLayer.push({
      event: 'video-is-broken',
      videoId,
      productURL
    });
    errorVideoIds.push(videoId);
  }
};
/**
 * Return a trimmed version of the video player's `referenceId`
 * @param {string} referenceId
 */


const trimVideoReferenceId = referenceId => referenceId.replace(/ref:|_1/g, '').trim();
/**
 * Get a video id from a video error event
 *
 * @param {HTMLElement} videoEl - A video error event
 * @returns {string} - The video's id
 */


const getIDFromVideoElement = videoEl => trimVideoReferenceId(videoEl.dataset.videoId);
/**
 * Creates a BC compatible HTML5 Video element for the carousel
 *
 * @param {string} videoId
 * @returns {HTMLVideoElement}
 */


const createCarouselVideoEl = videoId => createVideoEl(videoId);
/**
 * Creates a BC compatible HTML5 video element for the mobile gallery
 *
 * @param {string} videoId
 * @returns {HTMLVideoElement}
 */


const createGalleryVideoEl = videoId => createVideoEl(videoId, CSS_PREFIX + "galleryVideo " + JS_PREFIX + "galleryVideo " + IS_HIDDEN_CLASS, galleryVideoId);
/**
 * Creates an HTML5 video element
 *
 * @param {string} videoId Brightcove video id
 * @param {string} classes classes to apply to video element
 * @param {string} [id] id for video element instead of BC assigned id
 */


const createVideoEl = (videoId, classes = '', id = null) => {
  const videoEl = document.createElement('video');
  id && (videoEl.id = id);
  videoEl.dataset.videoId = "ref:" + videoId + "_1";
  videoEl.dataset.account = accountId;
  videoEl.dataset.player = playerId;
  videoEl.controls = true; // @ts-ignore

  videoEl.playsinline = true;
  videoEl.classList.add('video-js');
  classes.length && videoEl.classList.add(...classes.split(' '));
  return videoEl;
};
/**
 * Shows the Video product section, menu element, and opens the accordion
 * contents for mobile
 */


const showVideoProductSection = () => {
  const videoSection = document.querySelector(videoSectionSelector);
  const videoSectionAccordion = videoSection.querySelector(accordionSelector);
  const videoMenuItem = document.querySelector("." + JS_PREFIX + "VideoMenuItem");
  videoSection.classList.remove(IS_HIDDEN_CLASS);
  videoSectionAccordion.classList.add(IS_OPEN);
  videoMenuItem.classList.remove(IS_HIDDEN_CLASS);
};
/**
 * Show the media toggle for mobile, and space elements properly
 */


const showMobileGalleryVideoToggle = () => {
  const mobileGalleryControlsWrapper = document.querySelector(mobileGalleryControlsWrapperSelector);
  mobileGalleryControlsWrapper.querySelector(galleryMediaToggleSelector).classList.remove(IS_HIDDEN_CLASS);
  mobileGalleryControlsWrapper.classList.remove(CSS_UTILITY_PREFIX + "flexJustifyEnd");
  mobileGalleryControlsWrapper.classList.add(CSS_UTILITY_PREFIX + "flexJustifyBetween");
};
/**
 * Get the player for the gallery video
 *
 * @returns {import('video.js').VideoJsPlayer|undefined}
 */


const getGalleryVideoPlayer = () => videojs.getPlayer(galleryVideoId);
/**
 * Control the gallery video player
 *
 * @param {'play' | 'pause'} action
 */


const controlGalleryPlayer = action => {
  const player = getGalleryVideoPlayer();
  player && player[action]();
};
/**
 * Pause the gallery player
 */


const pauseGalleryVideoPlayer = () => controlGalleryPlayer('pause');
/**
 * Play the gallery player
 */


const playGalleryVideoPlayer = () => controlGalleryPlayer('play');
/**
 * Creates a carousel item to be initialized by slick for video carousel
 *
 * @param {HTMLVideoElement} videoEl
 * @returns {HTMLDivElement}
 */


const createCarouselWrapper = videoEl => {
  const embedWrapper = document.createElement('div');
  const embedContainer = document.createElement('div');
  embedWrapper.classList.add('embedWrapper');
  embedContainer.classList.add('embedContainer');
  embedContainer.append(videoEl);
  embedWrapper.append(embedContainer);
  return embedWrapper;
};
/**
 * Adds wrapper elements to video elements & appends to carousel in video product section
 *
 * @param {HTMLVideoElement[]} videoEls
 */


const appendCarouselVideos = videoEls => {
  const videoCarousel = document.querySelector(videoCarouselSelector);
  videoEls.forEach(videoEl => {
    videoCarousel.append(createCarouselWrapper(videoEl));
  });
};
/**
 *  Appends dummy thumbnail img elements
 *
 * @param {number} thumbnailCount
 */


const appendThumbnails = thumbnailCount => {
  const thumbnailCarousel = document.querySelector(thumbnailCarouselSelector);

  for (let i = 1; i <= thumbnailCount; i++) {
    const wrapperDivEl = document.createElement('div');
    const thumbnailImgEl = document.createElement('img');
    thumbnailImgEl.classList.add(CSS_PREFIX + "AdditionalVideos-thumb", JS_PREFIX + "AdditionalVideos-thumb-" + i);
    wrapperDivEl.append(thumbnailImgEl);
    thumbnailCarousel.append(wrapperDivEl);
  }
};
/**
 * Appends gallery HTML 5 video element to mobile gallery
 *
 * @param {HTMLVideoElement} videoEl gallery video element
 */


const appendGalleryVideo = videoEl => document.querySelector(gallerySelector).append(videoEl);
/**
 * Initializes slick carousels, thumbnails, poster images &
 * shows video section
 */


const initCarousel$1 = () => {
  const $videoCarousel = jQuery(videoCarouselSelector);
  const $thumbnailCarousel = jQuery(thumbnailCarouselSelector);
  showVideoProductSection(); // Create carousel with videos

  $videoCarousel.slick({
    asNavFor: $thumbnailCarousel,
    arrows: false,
    swipe: false,
    infinite: false
  }); // Pause video on current slide before slide change

  $videoCarousel.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    if (currentSlide !== nextSlide && videojs) {
      // Pause video (currentSlide+1 to skip over gallery video, which is first element in players[])
      videojs(players[currentSlide + 1].id()).pause();
    }
  });
  /**
   * We have no way to know when the poster image CSS is set, so
   * we wait for window load to set up & show the thumbnails.
   */

  if ($thumbnailCarousel.children().length > 0) {
    window.addEventListener('load', () => {
      // Load poster images into DOM for slick slider navigation
      const $posterImages = jQuery(videoCarouselSelector + " .vjs-poster");
      $posterImages.each(function (index) {
        const count = index + 1;
        jQuery(".js-de-slick--videos-thumbnails .js-de-AdditionalVideos-thumb-" + count).attr('src', jQuery(this).css('background-image').replace(/^url\(['"](.+)['"]\)/, '$1'));
      });
      $thumbnailCarousel.removeClass(IS_HIDDEN_CLASS);
      $thumbnailCarousel.slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: $videoCarousel,
        focusOnSelect: true,
        swipeToSlide: true,
        touchThreshold: 30,
        infinite: false
      });
    });
  }
};
/**
 * Shows mobile gallery player toggle element, initializes event
 * listeners for switching to the mobile gallery player, and auto
 * pause/play logic
 */


const initGalleryControls = () => {
  showMobileGalleryVideoToggle();
  const $toggleButton = jQuery(galleryMediaToggleSelector);
  const $viewImagesCTA = jQuery('.js-de-view-images');
  const $watchVideoCTA = jQuery('.js-de-watch-video');
  const $imageCount = jQuery('.js-de-ProductGallery-count');
  const $galleryVideo = jQuery("#" + galleryVideoId);

  const switchToImages = () => {
    // Remove Video, switch to Images
    $toggleButton.removeClass('js-de-toggle');
    $watchVideoCTA.removeClass(IS_HIDDEN_CLASS);
    $viewImagesCTA.addClass(IS_HIDDEN_CLASS);
    $galleryVideo.addClass(IS_HIDDEN_CLASS);
    $imageCount.removeClass(IS_HIDDEN_CLASS); // Pause Video

    pauseGalleryVideoPlayer();
  };

  const switchToVideo = () => {
    // Add Video
    $toggleButton.addClass('js-de-toggle');
    $imageCount.addClass(IS_HIDDEN_CLASS);
    $viewImagesCTA.removeClass(IS_HIDDEN_CLASS);
    $watchVideoCTA.addClass(IS_HIDDEN_CLASS);
    $galleryVideo.removeClass(IS_HIDDEN_CLASS); // Play Video

    playGalleryVideoPlayer();
  };

  $Swatches.on('ColorSwatches:select', switchToImages); // Attach click event to 'Watch Videos' button to toggle between video and image

  $toggleButton.click(function () {
    if ($toggleButton.hasClass('js-de-toggle')) {
      switchToImages();
    } else {
      switchToVideo();
    }
  });
  /**
   * Watch for window resize event (debounced), pause gallery video
   */

  let timeout = null;
  jQuery(window).resize(() => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      if (jQuery(window).width() >= LARGE_BREAKPOINT) {
        // Pause Video
        pauseGalleryVideoPlayer();
      }
    }, 250);
  });
  /**
   * Determine when element is within viewport
   * Confirm IntersectionObserver is available on the global object
   */

  if (window.IntersectionObserver) {
    const $videoCarousel = jQuery(videoCarouselSelector);
    /**
     * Trigger function when a video player componenet is within viewport
     * @see IntersectionObserver https://css-tricks.com/a-few-functional-uses-for-intersection-observer-to-know-when-an-element-is-in-view/
     */

    const observerOptions = {
      rootMargin: "0px 0px -" + $videoCarousel.height() + "px 0px"
    }; // Toggle class that shows or hides controller bar/play button

    const handleObserver = entries => entries.forEach(entry => entry.isIntersecting ? entry.target.classList.add(IS_INTERSECTING_CLASS) : entry.target.classList.remove(IS_INTERSECTING_CLASS)); // Create new Observer instance


    const observer = new IntersectionObserver(handleObserver, observerOptions); // Add a watcher to each video player component

    $videoCarousel.each((index, videoElement) => observer.observe(videoElement));
  }
};
/**
 * Establishes listeners for onplay and error events
 */


const initializeVideoListeners = () => {
  players.forEach(player => {
    // Define the ready event for the player
    player.ready(function () {
      var _myPlayer$mediainfo;

      // Assign this player to a variable
      const myPlayer = this;
      const videoLoadError = myPlayer.error && myPlayer.error() && myPlayer.error().code;
      const referenceId = ((_myPlayer$mediainfo = myPlayer.mediainfo) == null ? void 0 : _myPlayer$mediainfo.referenceId) && trimVideoReferenceId(myPlayer.mediainfo.referenceId); // Assign and event listener for play event

      myPlayer.on('play', onPlay); // Handle videos that don't work on page load

      if (videoLoadError && referenceId) {
        trackVideosWithErrors(referenceId);
      } // Assign an event listener for a video player error event


      myPlayer.on('error', event => {
        trackVideosWithErrors(getIDFromVideoElement(
        /** @type {HTMLElement} */
        event.target));
      });
    });
  });
};
/**
 * Initializses carousels & the watch video link for mobile
 */


const initUi = () => {
  initCarousel$1();
  initGalleryControls();
};
/**
 * Runs BC video initialization, initializes & shows carousels/thumbnails, and runs video initialization tasks/listener binding
 *
 * @param {HTMLVideoElement[]} videoEls HTML5 Video elements to initialize as brightcove players
 */


const initVideoPlayers = videoEls => {
  brightCove = window.bc;
  videojs = window.videojs;
  videoEls.forEach(video => {
    players.push(brightCove(video));
  });
  initializeVideoListeners();
  initUi();
};
/**
 * Appends video elements for each ID. Once Brightcove script is
 * available, starts initializing players & UI.
 *
 * if length is 0, then no videos are functional & we update the mobile UI
 *
 * @param {string[]} videoIds
 */


const init$5 = videoIds => {
  if (videoIds.length > 0) {
    const carouselVideoEls = videoIds.map(videoId => createCarouselVideoEl(videoId));
    const galleryVideoEl = createGalleryVideoEl(videoIds[0]);
    const videoEls = [galleryVideoEl, ...carouselVideoEls];
    appendCarouselVideos(carouselVideoEls);
    appendGalleryVideo(galleryVideoEl);
    if (carouselVideoEls.length > 1) appendThumbnails(carouselVideoEls.length);

    if (window.bc) {
      initVideoPlayers(videoEls);
    } else {
      const bcScript = document.querySelector("." + JS_PREFIX + "brightcove-script");
      bcScript.addEventListener('load', () => initVideoPlayers(videoEls));
    }
  }
};
/**
 * Run init once we have validated the Video IDs. If the window object is not
 * present, listen for custom event.
 */


if (window.validVideoIds) {
  init$5(window.validVideoIds);
} else {
  document.addEventListener('videosValidated',
  /** @type {CustomEvent} */
  event => init$5(event.detail));
}

// @ts-check
/**
 * Module-specific constants
 */

const ACCORDION_SUFFIX = '-accordion';
const ACCORDION_SELECTOR = "." + JS_PREFIX + "Accordion";
const ACCORDION_HEADER_SELECTOR = ACCORDION_SELECTOR + "-header";
const ACCORDION_TOGGLE_SELECTOR = ACCORDION_SELECTOR + "-toggle";
const CLICK_EVENT$2 = 'click';
/**
 * Gets an accordion closest to an accordion header element
 * @param {Element} headerEl
 * @returns {Element} accordionEl
 */

const getAccordionElForHeaderEl = headerEl => headerEl.closest(ACCORDION_SELECTOR);
/**
 * Get an accordion header toggle from an accordion
 * @param {Element} accordionEl
 * @returns {HTMLButtonElement | null} accordionEl header toggle
 */


const getHeaderToggleFromAccordion = accordionEl => accordionEl && accordionEl.querySelector(ACCORDION_HEADER_SELECTOR);
/**
 * Gets anchor links that trigger an accordion, from the passed in accordion
 * element
 * @param {Element} accordionEl - accordionEl header toggle
 * @returns {NodeListOf<HTMLLinkElement>} Named anchor toggles
 */


const getAnchorElsFromAccordionEl = accordionEl => {
  var _accordionEl$id;

  const anchorId = accordionEl == null ? void 0 : (_accordionEl$id = accordionEl.id) == null ? void 0 : _accordionEl$id.substring(0, accordionEl.id.indexOf(ACCORDION_SUFFIX));
  return document.querySelectorAll("[href*=\"#" + anchorId + "\"]");
};
/**
 * Toggle the open-state class on an accordion and update associated toggles
 * @param {Element} accordionEl
 */


const toggleAccordion = accordionEl => {
  if (!accordionEl) return;
  accordionEl.classList.toggle(IS_OPEN);
  updateToggleStates(accordionEl);
};
/**
 * Is the accordion open
 * @param {Element} accordionEl
 * @returns {Boolean}
 */


const isAccordionOpen = accordionEl => (accordionEl == null ? void 0 : accordionEl.classList.contains(IS_OPEN)) || false;
/**
 * Set the `aria-expanded` of an accordion toggle
 * @param {HTMLElement} toggleEl
 * @param {boolean} isTargetOpen
 */


const setAriaExpandedAttrForEl = (toggleEl, isTargetOpen) => toggleEl.setAttribute('aria-expanded', String(isTargetOpen));
/**
 * Opens an accordion
 * @param {Element} accordionEl
 */


const openAccordion = accordionEl => {
  if (!accordionEl) return;
  accordionEl.classList.add(IS_OPEN); // Set aria on header, if this was triggered by an external link
  // @TODO -debug, still not working as expected

  updateToggleStates(accordionEl);
};
/**
 * Closes an accordion
 * @param {Element} accordionEl
 */


const closeAccordion = accordionEl => {
  if (!accordionEl) return;
  accordionEl.classList.remove(IS_OPEN); // Set aria on header, if this was triggered by an external link
  // @TODO -debug, still not working as expected

  updateToggleStates(accordionEl);
};
/**
 * Toggles states on elements used as toggles for an accordion
 * @param {Element} accordionEl
 */


const updateToggleStates = accordionEl => {
  if (!accordionEl) return;
  const currentAccordionState = isAccordionOpen(accordionEl);
  const headerToggleEl = getHeaderToggleFromAccordion(accordionEl);
  const anchorToggleEls = getAnchorElsFromAccordionEl(accordionEl);
  headerToggleEl && setAriaExpandedAttrForEl(headerToggleEl, currentAccordionState);
  anchorToggleEls.forEach(toggleEl => setAriaExpandedAttrForEl(toggleEl, currentAccordionState));
};
/**
 * Takes an accordion and an action, then toggles the accordion's open-state
 * class. Nested functions also update `aria-expanded` on its toggle(s)
 * @param {Element} accordionEl
 * @param {String} [action]
 */


const toggleAccordionState = (accordionEl, action) => {
  if (!accordionEl) return;

  switch (action) {
    case 'open':
      openAccordion(accordionEl);
      break;

    case 'close':
      closeAccordion(accordionEl);
      break;

    default:
      toggleAccordion(accordionEl);
      break;
  }
};
/**
 * Gets the fragment from the accordion's link toggle, minus any extraneous
 * characters
 * @param {HTMLLinkElement} linkEl A fragment link
 * @returns {String | undefined} A target for a page fragment link
 */


const getFragmentTargetId = linkEl => {
  var _linkEl$href;

  if (!(linkEl == null ? void 0 : (_linkEl$href = linkEl.href) == null ? void 0 : _linkEl$href.includes('#'))) return;
  let hashFrag = linkEl.href.slice(linkEl.href.indexOf('#') + 1);
  const hasQueryString = hashFrag && hashFrag.includes('?');

  if (hashFrag && hasQueryString) {
    hashFrag = hashFrag.substring(0, hashFrag.indexOf('?'));
  }

  return hashFrag;
};
/**
 * Find an accordion
 * @param {HTMLLinkElement} linkEl A fragment link
 * @returns {Element | undefined} accordion
 */


const getAccordionElFromAnchorEl = linkEl => {
  const id = getFragmentTargetId(linkEl);
  return id && document.getElementById("" + id + ACCORDION_SUFFIX);
};
/**
 * Handler for when an accordion toggle link is clicked
 *
 * @this {HTMLLinkElement} - The toggling link element
 */


const onToggleClick = function onToggleClick() {
  const accordionEl = getAccordionElFromAnchorEl(this);

  if (accordionEl) {
    setAriaExpandedAttrForEl(this, true);
    openAccordion(accordionEl);
  }
};
/**
 * Handler for when an accordion header button is clicked
 *
 * @this {HTMLButtonElement} - The triggered button element
 */


const onButtonClick = function onButtonClick() {
  const accordionEl = getAccordionElForHeaderEl(this);
  accordionEl && toggleAccordionState(accordionEl);
};
/**
 * Get all accordion toggles and set initial `aria-expanded` state
 */


const setInitialState = () => {
  /** @type {NodeListOf<HTMLLinkElement>} */
  const toggleEls = document.querySelectorAll(ACCORDION_TOGGLE_SELECTOR);
  toggleEls.forEach(toggleEl => {
    const accordionEl = getAccordionElFromAnchorEl(toggleEl);
    accordionEl && toggleAccordionState(accordionEl);
  });
};
/**
 * Initializes functionality by setting up event bindings and setting initial
 * state on toggles and accordions
 */


const init$6 = () => {
  document.querySelectorAll(ACCORDION_HEADER_SELECTOR).forEach(element => element.addEventListener(CLICK_EVENT$2, onButtonClick));
  document.querySelectorAll(ACCORDION_TOGGLE_SELECTOR).forEach(element => element.addEventListener(CLICK_EVENT$2, onToggleClick));
  document.addEventListener('load', setInitialState);
};

// @ts-check
/**
 * Reviews-specific values
 */

const CUSTOMER_REVIEW = 'CustomerReview';
/**
 * The CSS class on the button used to get more reviews
 */

const MORE_REVIEWS_BUTTON_CLASS = JS_PREFIX + "moreReviewsButton";
/**
 * The CSS class on the button used to get more reviews
 */

const MORE_REVIEWS_BUTTON_TEXT_CLASS = MORE_REVIEWS_BUTTON_CLASS + "-text";
/**
 * The CSS class on the button used to get more reviews
 */

const MORE_REVIEWS_BUTTON_LOADING_TEXT_CLASS = MORE_REVIEWS_BUTTON_CLASS + "-loadingText";
/**
 * The CSS class on the button used to get more reviews
 */

const REVIEWS_LOADING_CLASS = JS_PREFIX + "LoadingReviews";
/**
 * Timeout for delaying showing loading state after calls to the revies API
 */

const REVIEWS_LOADING_TIMEOUT = 200;
/**
 * The CSS class on a review block
 */

const REVIEW_CLASS = "" + JS_PREFIX + CUSTOMER_REVIEW;
/**
 * The CSS class on the reviews container block
 */

const REVIEWS_CONTAINER_CLASS = "" + JS_PREFIX + CUSTOMER_REVIEW + "s";
/**
 * The CSS class on a preloaded review block
 */

const REVIEW_PRELOADED_CLASS = "" + JS_PREFIX + CUSTOMER_REVIEW + "-preloaded";
/**
 * The CSS class on the reviews sort select
 */

const REVIEW_SORT_SELECT = "" + JS_PREFIX + CUSTOMER_REVIEW + "-sort";
/**
 * The CSS class on reviews rating elements (assigned a star-rating value)
 */

const REVIEW_FILTER = "" + JS_PREFIX + CUSTOMER_REVIEW + "-filter";
/** The CSS class on the element that displays the current filter if it exists */

const REVIEW_FILTER_STATUS = "" + JS_PREFIX + CUSTOMER_REVIEW + "-filterStatus";
/** The CSS class on the element within the filter status that shows the number of stars */

const REVIEW_FILTER_STAR_VALUE = "" + JS_PREFIX + CUSTOMER_REVIEW + "-filterStarValue";
/** The CSS class on the clear filter button */

const REVIEW_CLEAR_FILTER = "" + JS_PREFIX + CUSTOMER_REVIEW + "-clearFilter";
/** The CSS class on the review summary text (N out of 5 stars). This gets used as a clear button as well */

const REVIEW_SUMMARY_CLEAR_FILTER = JS_PREFIX + "ReviewSummary-starsSummary";
/**
 * The CSS ID on a reviews container block
 */

const REVIEWS_CONTAINER_SELECTOR = "" + CSS_PREFIX + CUSTOMER_REVIEW + "s";
/* ----- */

/**
 * Multiplier for converting ratings stars (1-5) to a percentage
 */

const STAR_RATING_PERCENTAGE_MULTIPLIER = 20;
/**
 * Base URL for querying the Decathlon Reviews API
 */

const REVIEWS_BASE_URL = 'https://my.decathlon.co.jp/reviews/reviews.php';
const SHOP_REGION = document.getElementById('shopRegion').innerHTML;
const SHOP_LANG = document.getElementById('shopLang').innerHTML;
/**
 * Base query parameters for the Decathlon Reviews API
 * Change locale if different from english
 */

const REVIEWS_BASE_QUERY_PARAMS = {
  site: 1132,
  type: 1,
  source: 'magento',
  locale: SHOP_LANG + '_' + SHOP_REGION,
  version: 2,
  origin: location.origin
};
/**
 * Constants used for Handlebars partials
 */

const VERIFIED_PURCHASE_ICON_TEMPLATE_ID = 'verified_purchase_icon';
const VOTING_ICON_TEMPLATE_ID = 'helpful_icon';
const LOGO_WITHOUT_BACKGROUND_TEMPLATE_ID = 'logo_no_bg';
/**
 * Element dataset variables
 */

/**
 * Star rating value from rows in the review matrix, for filtering
 */

const STAR_RATING = 'starRating';

/**
 * The model code and, total pre-rendered reviews value, and reviews-per-page value
 * are retrieved from a data attribute in the UI.
 * Model code is necessary for calling the Reviews API
 */

const jsReviewsEl = document.querySelector("." + REVIEWS_CONTAINER_CLASS) || {
  dataset: {}
};
const totalPrerenderedReviews = jsReviewsEl.dataset.totalPrerenderedReviews;
const modelCode = jsReviewsEl.dataset.modelCode;
const reviewsPerPage = jsReviewsEl.dataset.reviewsPerPage;
/**
 * Confirm that the total number of pre-rendered reviews is (a number greater than 0 and) evenly divisible by
 * the reviews-per-page number (also a number, greater than 0)
 * If this value is false, it will stop attempts to do paginated API requests (see below)
 */

const validReviewNumbers = !isNaN(parseInt(totalPrerenderedReviews, 10)) && !isNaN(parseInt(reviewsPerPage, 10)) && totalPrerenderedReviews > 0 && reviewsPerPage > 0 && totalPrerenderedReviews % reviewsPerPage === 0;

/**
 * Queries to get different sets of reviews
 */
/**
 * Get the NodeList of server-rendered reviews (this will remain static,
 * so no need for a function)
 */

const prerenderedReviewList = document.querySelectorAll("." + REVIEW_PRELOADED_CLASS);
/**
 * Get all reviews, loaded from the API or pre-rendered
 * @returns A NodeList of all reviews
 */

const getAllReviews = () => document.querySelectorAll("." + REVIEW_CLASS);
/**
 * Get all reviews that have been loaded from the API (i.e., were not pre-rendered on page load)
 * @returns A NodeList of all non-preloaded reviews
 */

const getLoadedReviews = () => document.querySelectorAll("." + REVIEW_CLASS + ":not(." + REVIEW_PRELOADED_CLASS + ")");
/**
 * Get the sort select
 */

/** @type HTMLSelectElement */

const reviewsSortSelect = document.querySelector("." + REVIEW_SORT_SELECT);

// @ts-check
const originalReviewsSortFilterState = {
  // The default sort, to be used on page load
  sort: 'createdAt',
  page: 1,
  // The default sort direction, to be used on page load
  direction: 'desc',
  // The ratings filter, which is none on page load
  notes: ''
};
/**
 * This will be used for holding state to control load/sort/filter interactions
 * @type {ReviewsState}
 */

const originalReviewsState = Object.assign({}, originalReviewsSortFilterState, {
  reviewsPerPage,
  // The number of pre-rendered reviews will be set when the main script runs
  prerenderedReviews: 0,
  loading: false,
  isMoreReviewRequest: false
});
const {
  updateState: setReviewsState,
  getState: getReviewsState,
  onChange: onReviewsStateChange
} = createState(originalReviewsState);
/**
 * Sets the number of prerendered reviews on the reviews state object
 */

const setPrerenderedReviewsOnState = () => {
  setReviewsState({
    prerenderedReviews: prerenderedReviewList.length
  });
};
/**
 * Checks whether the `sort`, `direction`, and `notes` values
 * have been set back to the original (default) state
 * The default state is
 * 1. 'sort':'createdAt'
 * 2. 'direction':'desc'
 * 3. 'notes': '' (means this param to filter by rating, if passed, is ignored; same as not being set)
 * When this evaluates to true, the page will behave as it did on first load,
 * incrementally showing pre-rendered reviews until it needs to call to the API for more.
 * @returns {boolean}
 */

const getIsDefaultQuery = () => {
  const {
    sort,
    direction,
    notes
  } = getReviewsState();
  return originalReviewsState.sort === sort && originalReviewsState.direction === direction && originalReviewsState.notes === notes;
};
/**
 * Set up a query for getting filtered reviews
 * Resets query pagination, sort, and direction, takes in a `notes` (aka, rating) value for the next query
 * @param {string} notes - A value to use to query for reviews with a particular rating
 */

const setReviewsStateForFilter = notes => {
  setReviewsState(Object.assign({}, originalReviewsSortFilterState, {
    notes
  }));
};
const clearFilter = () => {
  // Reset both filter and sort, per client request
  setReviewsState(originalReviewsSortFilterState);
};
/**
 * Set up a query for getting sorted reviews
 * Resets query pagination and notes (aka, ratings filter)
 * and sets sort and direction variables for the next query
 * @param {Object} params
 * @param {string | undefined} params.sort - Sort to use for next API query
 * @param {string | undefined} params.direction - Direction to use for next
 * API query
 */

const setReviewsStateForSort = ({
  sort,
  direction
}) => {
  setReviewsState(Object.assign({}, originalReviewsSortFilterState, {
    sort,
    direction
  }));
};

/**
 * Helpers for querying and displaying ratings and reviews
 */
/**
 * Add a ratings percentage value to each review object
 * @param {Object[]} [reviews=[]] Array of reviews data objects
 * @returns {Object[]} Modified reviews array
 */

const addRatingsPercentage = (reviews = []) => reviews.map(review => {
  if (review.note) {
    // Multiply the note (a.k.a., rating, scale 1-5) by the multiplier to get a percentage value
    review.rating_percentage = review.note * STAR_RATING_PERCENTAGE_MULTIPLIER;
  }

  return review;
});

// @ts-check

/**
 * Attempt to create a Date object from an ISO-format timestamp.
 * If the raw timestamp does not return a Date object,
 * try to add a colon in the offset portion of the string and
 * pass again to the Date constructor.
 * Meant to handle issues parsing timestamps from Shopify on iOS
 * @see https://stackoverflow.com/questions/6427204/date-parsing-in-javascript-is-different-between-safari-and-chrome#49138448
 * (Note that none of the referenced solutions seemed to work as desired)
 * @param {string} timestamp - An ISO-format timestamp
 * @returns {Date|null} - A JavaScript Date object or null if the
 * Date could not be created
 */
const createDateObject = timestamp => {
  let date = new Date(timestamp);

  if (isNaN(date.getMonth())) {
    /**
     * Original timestamps are in the format "2018-09-12T08:52:30+0200"
     * If parsing fails, modTimestamp is set to have timezone
     * offset digits separated by a colon, e.g. "2018-09-12T08:52:30+02:00"
     */
    const modTimestamp = timestamp.replace(/([+-]\d{2})(\d{2})$/, '$1:$2');
    date = new Date(modTimestamp);
  }

  return isNaN(date.getMonth()) ? null : date;
};

// @ts-check
/**
 * A wrapper to check the existence of Handlebars before running code that expects it (an unchecked external gloabal defined in Rollup)
 * @param {function} callback A function to call if Handlebars exists
 * @returns {function} A function that takes any params and executes the callback, or a noop if Handlebars isn't available
 * @example handlebarsCheck(myFunction)([parameters])
 */

const handlebarsCheck = callback => Handlebars ? function (params) {
  callback(params);
} : function () {
  console.error('Cannot load new reviews. Missing templating engine.');
  return false;
};
/**
 * Closure for containing caching variables around the exported function, templateNewReviews
 */

const _templateNewReviews = () => {
  /**
   * Create naive cache for reused elements and variables used in templating
   */
  let reviewsContainerEl = null;
  let reviewsTplEl = null;
  let reviewsTemplateFn = null;
  let reviewsTemplateSource = null;
  /**
   * Function that takes in review data and uses a Handlebars compiled template function to
   * render a new set of reviews and insert them into the reviews container element
   * @param {Object[]} [reviews=[]] Review data retrieved from the reviews API
   * @returns (*) rendered HTML
   */

  return (reviews = []) => {
    var _reviewsTplEl;

    /**
     * Get Handlebars templates and containers, used cached values when set
     */
    reviewsTplEl = reviewsTplEl || document.getElementById("" + REVIEWS_CONTAINER_SELECTOR + TEMPLATE_SUFFIX);
    reviewsContainerEl = reviewsContainerEl || document.getElementById("" + REVIEWS_CONTAINER_SELECTOR + CONTAINER_SUFFIX);
    /**
     * Compile the reviews template for use after getting new review data
     */

    reviewsTemplateSource = reviewsTemplateSource || ((_reviewsTplEl = reviewsTplEl) == null ? void 0 : _reviewsTplEl.innerHTML);
    reviewsTemplateFn = reviewsTemplateFn || reviewsTemplateSource && Handlebars.compile(reviewsTemplateSource);
    /**
     * If the template function or container are missing, just return
     */

    if (!(typeof reviewsTemplateFn === 'function') || !(reviewsContainerEl && typeof reviewsContainerEl.insertAdjacentHTML === 'function')) {
      throw new Error('We do not have a Handlebars templating function or a viable container for rendering.');
    }

    const newReviewsHTML = reviewsTemplateFn({
      reviews: addRatingsPercentage(reviews)
    });

    if (newReviewsHTML) {
      return reviewsContainerEl.insertAdjacentHTML('beforeend', newReviewsHTML);
    }

    throw new Error('Templating new reviews failed');
  };
};
/**
 * Exports the closured function with caching
 */


const templateNewReviews = _templateNewReviews();
/**
 * An initialization function for registering Handlebars partials and helpers
 */

const _handlebarsInit = () => {
  /**
   * Get elements for registering partials
   */
  const verifiedPurchaseIconTplEl = document.getElementById(ICON_PREFIX + "verifiedPurchase" + TEMPLATE_SUFFIX);
  const helpfulIconTplEl = document.getElementById(ICON_PREFIX + "helpful" + TEMPLATE_SUFFIX);
  const logoNoBgEl = document.getElementById(ICON_PREFIX + "logoNoBg" + TEMPLATE_SUFFIX);
  /**
   * Register handlebars helpers
   */

  /**
   * Output the wrapped markup if any of the conditions are true.
   * @params {*} Values to be tested for truthiness or falsiness
   * Example usage:
   * {{#if_or cond1 cond2 cond3}}
   *  <p>At least one is true</p>
   * {{/if_or}}
   */

  Handlebars.registerHelper('if_or', function (...args) {
    const options = args[args.length - 1];
    const vals = args.slice(0, -1);
    const truthy = vals.some(val => Boolean(val));

    if (truthy) {
      return options.fn(this);
    }

    return options.inverse(this);
  });
  /**
   * Output a date timestamp formatted as d/m/YYYY
   * If the date object is not created, output an empty string
   * @params {string} timestamp - Timestamp string
   * Example usage:
   * {{date_format some_date_timestamp}}
   */

  Handlebars.registerHelper('date_format', function (timestamp) {
    const date = createDateObject(timestamp);
    return date ? date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear() : '';
  });
  /**
   * Register handlebars partials (SVG icon snippets) to inject into JS-templated reviews
   */

  if (verifiedPurchaseIconTplEl) {
    Handlebars.registerPartial(VERIFIED_PURCHASE_ICON_TEMPLATE_ID, verifiedPurchaseIconTplEl.innerHTML);
  }

  if (helpfulIconTplEl) {
    Handlebars.registerPartial(VOTING_ICON_TEMPLATE_ID, helpfulIconTplEl.innerHTML);
  }

  if (logoNoBgEl) {
    Handlebars.registerPartial(LOGO_WITHOUT_BACKGROUND_TEMPLATE_ID, logoNoBgEl.innerHTML);
  }
};

const handlebarsInit = handlebarsCheck(_handlebarsInit);

// @ts-check
/**
 * Get product review data for a product by model code
 * @param {Object} params
 * @param {string} params.modelCode A "model code" provided from DEC reviews
 * metafields
 * @param {Object} [params.queryParams] Extra query parameters to be added to
 * the request (optional)
 * @returns {Promise<Object>} The review data
 * @throws Will throw if the model code cannot be obtained from the template
 */

const fetchProductReviewsData = ({
  modelCode,
  queryParams
}) => {
  const params = Object.assign({
    offer: modelCode
  }, REVIEWS_BASE_QUERY_PARAMS, queryParams);
  return fetch(REVIEWS_BASE_URL + "?" + encode(params)).then(res => res.json());
};
/**
 * Wrapper for requesting product review data
 * @param {Object} queryParams Additional parameters needed for a particular
 * request (e.g. sort, direction)
 * @returns {Promise<Object>} Data from the request for reviews
 */


const fetchReviews = queryParams => {
  /**
   * Check for necessary model code value before calling the API - also cannot
   * be an empty string
   */

  if (typeof modelCode === 'string' && modelCode) {
    return fetchProductReviewsData({
      modelCode,
      queryParams
    });
  }

  return Promise.reject(new Error('Missing a Model Code. Cannot get new review data.'));
};

// @ts-check
let moreReviewsEl;
let defaultButtonTextEl;
let loadingButtonTextEl;
let loadingReviewsEl;
/** @type {HTMLElement[]} */

let reviewFilterEls;
/** @type {HTMLElement} */

let reviewFilterStatusEl;
/** @type {HTMLElement} */

let reviewFilterStarValueEl;
let loadingTimeout = null;
let wasLoading = false;
/**
 * Hides all reviews that aren't currently hidden
 * @TODO - A11y analysis here
 */

const hideAllReviews = () => getAllReviews().forEach(review => review.classList.add(IS_HIDDEN_CLASS));
/**
 * Unhide a set number of reviews (based on the `reviewsPerPage` value obtained
 * from the template)
 * @param {Object} params
 * @param {Object[]} [params.reviews=[]] Array of review elements
 * @param {boolean} [params.reset] Whether to reset to hiding all reviews before
 * showing the initial set
 */


const showMoreReviews = ({
  reviews,
  reset
} = {
  reviews: [],
  reset: false
}) => {
  let reviewsToUpdate;

  if (reset) {
    hideAllReviews();
    reviewsToUpdate = reviews;
  } else {
    reviewsToUpdate = reviews
    /**
     * Filter out only reviews that are hidden, of the set that was passed in
     */
    .filter(review => review.classList.contains(IS_HIDDEN_CLASS));
  }
  /**
   * Unhide only reviews up to the reviewsPerPage value (minus 1, zero-indexed)
   */


  reviewsToUpdate.some((review, index) => {
    review.classList.remove(IS_HIDDEN_CLASS);
    return index === reviewsPerPage - 1;
  });
};
/**
 * Fully remove all reviews that were dynamically loaded (i.e., not pre-loaded
 * with the page)
 */


const clearLoadedReviews = () => {
  getLoadedReviews().forEach(review => review.parentNode.removeChild(review));
};
/**
 * Removes all dynamically loaded reviews and then hides
 * all reviews
 * To be used before fetching new reviews from the API, with
 * updated query parameters (e.g., on changing sort type)
 */


const resetReviews = () => {
  clearLoadedReviews();
  hideAllReviews();
};
/**
 * Cancel a trigger to set loading state
 */


const cancelLoadingState = () => {
  if (loadingTimeout) clearTimeout(loadingTimeout);
  loadingTimeout = null;
};
/**
 * Set loading state after a timeout
 */


const setLoadingState = () => {
  cancelLoadingState();
  loadingTimeout = setTimeout(() => setReviewsState({
    loading: true
  }), REVIEWS_LOADING_TIMEOUT);
};
/**
 * Fetches reviews from the API and renders the data to the page using a
 * Handlebars templating function
 * @param {boolean} [isMoreReviewRequest] - Is a request for additional reviews
 * (rather than a new sort or filter request)
 */


const loadNewReviews = isMoreReviewRequest => {
  /**
   * Trigger a loading state, with timeout
   */
  setLoadingState();
  /**
   * Set state to reflect whether this is a request for additional reviews, or
   * a sort or filter
   */

  setReviewsState({
    isMoreReviewRequest: Boolean(isMoreReviewRequest)
  });
  /**
   * Get the list of all reviews currently rendered (dynamically loaded and
   * server-rendered)
   */

  const renderedReviewList = getAllReviews();
  /**
   * Get values currently registered on the state object
   * `prerenderedReviews`, `sort`, `direction`, and `notes`
   * won't be redefined before making a request
   * `page` may be redefined, so assign as a `let`
   */

  const currentState = getReviewsState();
  const {
    prerenderedReviews,
    sort,
    direction,
    notes
  } = currentState;
  let {
    page
  } = currentState;
  /**
   * If there are server-rendered reviews on the page, and not yet any
   * dynamically loaded reviews, set the `reviewsState` object, page value for
   * the upcoming API call.
   * This number will be the total number of pre-rendered reviews divided
   * by the default paginated value (used in every API call), plus one
   * (the next page)
   */

  if (getIsDefaultQuery() && prerenderedReviews > 0 && renderedReviewList.length === prerenderedReviews) {
    /**
     * Set page to a new value,
     * then update the state's `page` value
     */
    page = prerenderedReviews / reviewsPerPage + 1;
    setReviewsState({
      page
    });
  }
  /**
   * Get more reviews from the API to display, setting the page value for the call
   * Set the query parameter (nb) for number of reviews to request from the API
   * to the value from the template
   */


  fetchReviews({
    page,
    sort,
    direction,
    notes,
    nb: reviewsPerPage
  }).then(data => {
    if (!data || !Array.isArray(data.items)) {
      throw new Error('Review data not successfully retrieved from the API');
    }

    if (!isMoreReviewRequest) {
      resetReviews();
    }

    return templateNewReviews(data.items);
  })
  /**
   * After successfully updating the template, increment `reviewsState.page`
   * for the subsequent request
   */

  /**
   * Unset loading state, no matter what happens
   * `Promise.finally` may not be available, so unset in both `then` and `catch`
   */
  .then(() => {
    cancelLoadingState();
    setReviewsState({
      page: getReviewsState().page + 1,
      loading: false
    });
  }).catch(error => {
    console.error(error);
    cancelLoadingState();
    setReviewsState({
      loading: false
    });
  });
};
/**
 * Handle getting more reviews
 *
 * On page load, this begins by displaying more (hidden) server-rendered reviews,
 * then transitions to loading more from the API.
 * On sorted and filtered lists, will need to immediately go to the API.
 * @param {Event} event
 */

const moreReviewsRequestHandler = event => {
  event.preventDefault(); // Convert the prerenderedReviewList to an Array for running Array helpers on the NodeList

  const prerenderedReviewListArray = [...prerenderedReviewList]; // Get the number of visible, server-rendered reviews

  const visiblePrerenderedReviews = prerenderedReviewListArray.filter(review => !review.classList.contains(IS_HIDDEN_CLASS)).length;
  /**
   * If sort/filter are set to defalt and there are server-rendered reviews on the page
   * and the total number exceeds what's visible, just show more
   * (Note: 0 is not GT 0 - if that's the case, there are no server-rendered reviews)
   */

  if (getReviewsState().prerenderedReviews > visiblePrerenderedReviews && getIsDefaultQuery()) {
    showMoreReviews({
      reviews: prerenderedReviewListArray
    });
  } else {
    /**
     * See `validReviewNumbers`. If the total number of pre-rendered reviews
     * (> 0) is not evenly divisible by the default number of reviews per page
     * to load, do not try to make paginated requests for more reviews, and
     * output an error to the console
     */
    if (!validReviewNumbers) {
      console.error("Total number of pre-rendered reviews and reviews-per-page are not in\n        sync. Cannot dynamically calculate paginated requests for more reviews.");
      return;
    }
    /**
     * Need to load and dynamically display reviews after calling the API
     * Passed to the `handlebarsCheck` helper to ensure errors aren't thrown.
     * In this case, inform `loadNewReviews` that this is a request for
     * more reviews, not a sort or filter event.
     */


    handlebarsCheck(loadNewReviews)(true);
  }
};
/**
 * Removes all dynamically loaded reviews
 * and then starts to show pre-loaded (pre-rendered) reviews,
 * as is the default on page load
 */


const resetDefaultReviewsDisplay = () => {
  clearLoadedReviews();
  showMoreReviews({
    reviews: [...prerenderedReviewList],
    reset: true
  });
};
/**
 * Entry point for initializing 'Get more reviews' functionality
 */

const moreReviewsInit = () => {
  moreReviewsEl = document.querySelector("." + MORE_REVIEWS_BUTTON_CLASS);
  defaultButtonTextEl = document.querySelector("." + MORE_REVIEWS_BUTTON_TEXT_CLASS);
  loadingButtonTextEl = document.querySelector("." + MORE_REVIEWS_BUTTON_LOADING_TEXT_CLASS);
  loadingReviewsEl = document.querySelector("." + REVIEWS_LOADING_CLASS);
  moreReviewsEl && moreReviewsEl.addEventListener('click', moreReviewsRequestHandler); // @ts-ignore

  reviewFilterEls = [...document.querySelectorAll("button." + REVIEW_FILTER)];
  reviewFilterStatusEl = document.querySelector("." + REVIEW_FILTER_STATUS);
  reviewFilterStarValueEl = document.querySelector("." + REVIEW_FILTER_STAR_VALUE);
};
/**
 * Visually marks reviews that will be replaced by a new set of reviews after
 * data is returned from an API request
 */

const addUnloadingStyleToReviews = () => {
  document.querySelectorAll("." + REVIEW_CLASS).forEach(review => review.classList.add(IS_TRANSITIONING_CLASS));
};
/**
 * Visually unmarks reviews after data is returned from an API request
 */


const removeUnloadingStyleFromReviews = () => {
  document.querySelectorAll("." + REVIEW_CLASS).forEach(review => review.classList.remove(IS_TRANSITIONING_CLASS));
};
/**
 * Show various loading state updates in the UI, depending on the type of API
 * request being made.
 * @param {boolean} isMoreReviewRequest - Is a request for additional reviews
 * (rather than a new sort or filter request)
 */


const showLoadingState = isMoreReviewRequest => {
  wasLoading = true;
  moreReviewsEl && moreReviewsEl.setAttribute('disabled', '');
  showElement(loadingButtonTextEl);
  hideElement(defaultButtonTextEl);

  if (!isMoreReviewRequest) {
    showElement(loadingReviewsEl);
    addUnloadingStyleToReviews();
  }
};
/**
 * Remove loading state updates from the UI
 */


const removeLoadingState = () => {
  wasLoading = false;
  moreReviewsEl && moreReviewsEl.removeAttribute('disabled');
  hideElement(loadingButtonTextEl);
  showElement(defaultButtonTextEl);
  hideElement(loadingReviewsEl);
  removeUnloadingStyleFromReviews();
};
/**
 * Render function for updating the UI during loading of new reviews
 * Triggers loading state only after a pre-defined, short timeout
 * @param {import('./state').ReviewsState} reviewsState
 */


const renderLoading = ({
  loading,
  isMoreReviewRequest
}) => {
  if (loading) {
    return showLoadingState(isMoreReviewRequest);
  }

  if (wasLoading) {
    removeLoadingState();
  }
};
/**
 * The UI-loading render function is passed to the state change function returned
 * from `create-state.js`
 */


onReviewsStateChange(renderLoading);
/**
 * @param {import('./state').ReviewsState} state
 */

const renderSortFilterUI = ({
  notes,
  sort,
  direction
}) => {
  // Switch the sort dropdown back to the original value if the state matches the original sort
  if (reviewsSortSelect && sort === originalReviewsSortFilterState.sort && direction === originalReviewsSortFilterState.direction) {
    reviewsSortSelect.selectedIndex = 0;
  }

  reviewFilterEls.forEach(el => {
    if (el.dataset[STAR_RATING] === notes) {
      el.classList.add(IS_ACTIVE_CLASS);
    } else {
      el.classList.remove(IS_ACTIVE_CLASS);
    }
  });

  if (notes) {
    reviewFilterStarValueEl.textContent = " " + notes + " star";
    showElement(reviewFilterStatusEl);
  } else {
    hideElement(reviewFilterStatusEl);
  }
};

onReviewsStateChange(renderSortFilterUI);
onReviewsStateChange(() => {
  /**
   * If the default sort is selected (compared with the page-load default state),
   * call to reset the default display, using pre-loaded reviews. Otherwise,
   * reset the UI and call to get new reviews using a different sort query.
   */
  if (getIsDefaultQuery()) {
    resetDefaultReviewsDisplay();
  } else {
    loadNewReviews();
  }
}, state => [state.sort, state.direction, state.notes]);

// @ts-check
/**
 * Takes sorting parameters from data attributes on the sort select's options
 * and determines whether to reset the default reviews display (most recent first)
 * or to get more reviews with the appropriate `sort` and `direction` parameters
 * @param {Object} event
 */

const reviewsSortHandler = event => {
  var _selectedOption$datas, _selectedOption$datas2;

  const options = event.target.options;
  const selectedIndex = event.target.selectedIndex;

  if (!options || isNaN(selectedIndex)) {
    return;
  }

  const selectedOption = options[selectedIndex];
  /**
   * Set the correct sort parameters on the state object
   * Also set the page back to the default, initial state
   */

  setReviewsStateForSort({
    sort: selectedOption == null ? void 0 : (_selectedOption$datas = selectedOption.dataset) == null ? void 0 : _selectedOption$datas.sortType,
    direction: selectedOption == null ? void 0 : (_selectedOption$datas2 = selectedOption.dataset) == null ? void 0 : _selectedOption$datas2.sortDirection
  });
};
/**
 * Initialize the change listener for the reviews sorting select element
 */


const reviewsSortInit = () => {
  reviewsSortSelect && reviewsSortSelect.addEventListener('change', reviewsSortHandler);
};

/**
 * Very simple vanilla JS event delegator
 * @TODO - For some reason I can't figure out, removing listeners appears not
 * to be working
 * Leaving as-is for future debugging
 * In current use cases, we do not need to remove these event listeners, but
 * would be a nice-to-have for other use cases
 * @param {Object} params
 * @param {string} [params.base='document'] params.base - The base element to
 * delegate from
 * @param {string} params.selector - The selector to target
 * @param {string} params.type - The type of even to listen for or remove
 * @param {function} params.callback - The event listener callback to bind or
 * remove binding to
 * @param {string} params.listenerName - The name to use to register the
 * listener, which would otherwise be anonymous.
 * Allows removal of previously registered listeners
 * @param {Boolean} [params.remove=false] - Whether to remove this listener binding
 * @param {Boolean} [params.useCapture=false] - Whether to use only the capture
 * phase to register the listener
 */
const delegateEvent = function () {
  // Create a closure and an object to hold events to be registered and de-registered
  const events = {};
  return ({
    base = 'document',
    selector,
    type,
    callback,
    listenerName,
    remove = false,
    useCapture = false
  }) => {
    if (!selector || !type || !callback || !listenerName) {
      console.error('Event delegator missing required params');
      return;
    }

    events[listenerName] = function (e) {
      for (let target = e.target; target && target !== this; target = target.parentNode) {
        if (target.matches(selector)) {
          callback.call(target, e);
          break;
        }
      }
    };

    if (remove) {
      window[base].removeEventListener(type, events[listenerName], useCapture);
      delete events[listenerName];
      return;
    }

    window[base].addEventListener(type, events[listenerName], useCapture);
  };
}();

// @ts-check
/**
 * Handler for clicks on rows in the Reviews Ratings Matrix
 * 1. Gets the rating from data on the element
 * 2. Sets state for the upcoming API query
 * 3. Resets any previous sort selection
 * 4. Clears out previously loaded reviews and hides the page-loaded reviews
 * 5. Makes a query to get new, filtered-by-rating reviews and update the UI
 * @TODO - Analyze for any accessibility improvements
 * @this HTMLDivElement
 */

const reviewFilterHandler = function reviewFilterHandler() {
  const rating = this.dataset && this.dataset[STAR_RATING];

  if (!rating) {
    return;
  }

  setReviewsStateForFilter(rating);
};
/**
 * Settings passed to event delegation module
 */


const filterEventDelegationSettings = {
  selector: "." + REVIEW_FILTER,
  type: 'click',
  callback: reviewFilterHandler,
  listenerName: 'reviewFilterListener'
};
const reviewsFilteringInit = () => {
  delegateEvent(filterEventDelegationSettings);
  const clearReviewFilterButtons = document.querySelectorAll("." + REVIEW_CLEAR_FILTER + ",." + REVIEW_SUMMARY_CLEAR_FILTER);
  clearReviewFilterButtons.forEach(btn => btn.addEventListener('click', clearFilter));
};

/**
 * Ratings & Reviews
 * Works with server-rendered reviews on page load.
 * Uses a Reviews API to fetch ratings and reviews data,
 * renders or re-renders via Handlebars templates onto the page.
 */
/**
 * Put all functions that need to run on product-page load here
 * 1. Register Handlebars partials and helpers
 * 2. Initialize handling for displaying (and fetching) more reviews
 * 3. Initialize handling for sorting reviews
 * 4. Initialize handling of voting for reviews and answers
 */

const reviewsInit = () => {
  setPrerenderedReviewsOnState();
  handlebarsInit();
  moreReviewsInit();
  reviewsSortInit();
  reviewsFilteringInit();
};

// @todo Move color & size swatches logic out of this module and into
// the `ColorSwatches` & `SizeSwatches` modules
const colorSwatchesSelector = "." + JS_PREFIX + "ColorSwatches-option";
const sizeSwatchesSelector = "." + JS_PREFIX + "SizeSwatches-option";
/**
 * Checks product attributes for the "End of Life" tag and specifies whether the
 * unavailable state is "sold out" or "out of stock."
 *
 * @returns {string} A CSS class
 */

const getUnavailableCssClass = () => {
  if (isNonFollowedProduct(productsJSON)) {
    return IS_SOLD_OUT_CLASS;
  }

  return IS_OUT_OF_STOCK_CLASS;
};
/**
 * @todo Can this logic be handled in the ColorSwatches/SizeSwatches modules?
 * @param {JQuery<HTMLButtonElement>} elements
 * @param {Object} opts
 * @param {string[]} opts.existingOptions
 * @param {string} opts.nonexistentClass
 * @param {string[]} opts.availableOptions
 * @param {string} opts.unavailableClass
 * @param {Variant[]} opts.variantsFromModelCode

 */


const updateOptions = (elements, opts, dataSetParameter) => {
  elements.each(function () {
    const element = this;
    let value = dataSetParameter ? element == null ? void 0 : element.dataset[dataSetParameter] : element.value;
    if (dataSetParameter === 'modelCode') value = value.toString(); // Reset the classes on the element

    element.classList.remove(opts.nonexistentClass);
    element.classList.remove(opts.unavailableClass); // Then reapply them as needed
    // Removing and adding are done separately because the nonexistent class and unavailable class could be the same thing

    if (!opts.existingOptions.includes(value)) {
      element.classList.add(opts.nonexistentClass);
    }

    if (!opts.availableOptions.includes(value)) {
      element.classList.add(opts.unavailableClass);
    }

    opts.variantsFromModelCode.forEach(variant => {
      if (variant.option2 === value) {
        let priceType = getdataPriceType(variant.id);
        const stock = variant.inventory_quantity.toString();
        priceType = priceType.toString();
        element.dataset.stock = stock;
        element.dataset.priceType = priceType;

        if (variant.inventory_quantity > 3) {
          element.lastElementChild.innerHTML = translate("En inventario");
          element.lastElementChild.classList.remove('product__buybox_sizes_li_low_stock');
          element.lastElementChild.classList.add('product__buybox_sizes_li_stock');
        } else if (variant.inventory_quantity > 0) {
          element.lastElementChild.innerHTML = stock;
          element.lastElementChild.classList.add('product__buybox_sizes_li_low_stock');
          element.lastElementChild.classList.remove('product__buybox_sizes_li_stock');
        } else {
          element.lastElementChild.innerHTML = translate("Agotado");
          element.lastElementChild.classList.add('product__buybox_sizes_li_low_stock');
          element.lastElementChild.classList.remove('product__buybox_sizes_li_stock');
        }
      }
    });
  });
};
/**
 * Updates the color & size options "available" states
 *
 * @todo Consider moving this logic to `ColorSwatches` & `SizeSwatches` modules
 * @param {Object} state
 * @param {string | undefined} state.size
 * @param {string | undefined} state.color
 * @param {string | undefined} state.model
 * @param {Variant | undefined} state.variant
 */


const updateOptionStates = ({
  size,
  color,
  variant,
  model
}) => {
  /** @type JQuery<HTMLButtonElement> */
  const colorSwatches = jQuery(colorSwatchesSelector);
  /** @type JQuery<HTMLButtonElement> */

  const sizeSwatches = jQuery(sizeSwatchesSelector); // Update swatches with classes to display state in UI

  updateOptions(sizeSwatches, {
    existingOptions: getExistingSizesFromModel(model),
    nonexistentClass: IS_HIDDEN_CLASS,
    availableOptions: getAvailableSizesFromModel(model),
    unavailableClass: getUnavailableCssClass(),
    variantsFromModelCode: getVariantsFromModelCode(model)
  });
  updateOptions(colorSwatches, {
    existingOptions: getExistingColorsFromSize( // If there is a variant selected, then grey out the variants that don't exist for the current size
    // if there is no variant selected (meaning either size is not selected, or the selected size doesn't exist for this color)
    // then we display them all as not-greyed-out
    variant && size),
    nonexistentClass: IS_OUT_OF_STOCK_CLASS,
    availableOptions: getAvailableColorsFromSize( // If there is a variant selected, then grey out the variants that aren't available for the current size
    // if there is no variant selected (meaning either size is not selected, or the selected size doesn't exist for this color)
    // then we display them all as not-greyed-out
    variant && size),
    unavailableClass: getUnavailableCssClass(),
    variantsFromModelCode: getVariantsFromModelCode(model)
  }, "modelCode");
};

// @ts-check
/**
 * Attach JS to the Shopify Timber theme <select> element
 * @todo Consider removing jQuery dependency
 */

const $MasterSelect = jQuery('#productSelect');
/**
 * We want to keep the master `<select>` input  and the URL up-do-date with the
 * selection size/color combination.
 *
 * @param {Variant} variant
 */

const onVariantSelect$1 = variant => {
  // We can then update the master `<select>` input with the variant ID
  // @todo Consider removing jQuery dependency
  $MasterSelect.val(variant.id);
};

// @ts-check
const CURRENT_PRICE_CSS_CLASS = JS_PREFIX + "CurrentPrice";
const CROSSED_OUT_PRICE_CSS_CLASS = JS_PREFIX + "CrossedOutPrice";
const PRICE_LABEL_CSS_CLASS = JS_PREFIX + "PriceLabel";
const PRICE_AMOUNT_LABEL_CSS_CLASS = JS_PREFIX + "PriceAmount";
const SECOND_PRICE_AMOUNT_LABEL_CSS_CLASS = JS_PREFIX + "SecondPriceAmount";
const PRICE_DISCOUNT_CSS_CLASS = "product__buybox_discounted_percent"; // Multiple price elements exist in the DOM because there
// are different ones for smaller vs larger viewports, use `querySelectorAll`

/** @type {NodeListOf<HTMLElement>} */

const currentPriceEls = document.querySelectorAll("." + CURRENT_PRICE_CSS_CLASS);
/** @type {NodeListOf<HTMLElement>} */

const crossedOutPriceEls = document.querySelectorAll("." + CROSSED_OUT_PRICE_CSS_CLASS);
/**
 * Formats default Shopify price value, which is in cents,
 * to display format: $X.XX
 *
 * @param {number} price The price to format for display
 * @returns {string} A formatted price string (or blank string)
 */

const formatPrice = price => {
  if (price) {
    return formatPriceSingle(String(price));
  }

  return '';
};
/**
 * Generates a formatted price, ranged if needed
 *
 * @param {Object} obj
 * @param {number} obj.minPrice
 * @param {number} obj.maxPrice
 * @returns {string} A formatted price to display
 */


const formatPriceRange = ({
  minPrice,
  maxPrice
}) => minPrice === maxPrice ? // Show a single `price` when there is no range
formatPrice(maxPrice) : // Show variants' `price` range
formatPrice(minPrice) + " \u2013 " + formatPrice(maxPrice);
/**
 * Gets all prices for a given variant model
 *
 * @todo Consider using transducers if variants quantity is larger
 * @see: https://medium.com/javascript-scene/transducers-efficient-data-processing-pipelines-in-javascript-7985330fe73d
 *
 * @param {string} model A variant model
 * @returns {Array} An array of prices
 */


const getPricesByVariantColor = model => variantsJSON.filter(variant => getVariantOptions(variant).model === "" + model).map(variant => variant.price);
/**
 * Gets all `compare_at_price` values for a given variant model
 *
 * @todo Consider using transducers if variants quantity is larger
 * @see: https://medium.com/javascript-scene/transducers-efficient-data-processing-pipelines-in-javascript-7985330fe73d
 *
 * @param {string} model A variant model
 * @returns {Array} An array of `compare_at_price` values
 */


const getCompareAtPricesByColor = model => variantsJSON.filter(variant => getVariantOptions(variant).model === "" + model).map(variant => variant.compare_at_price);
/**
 * Helper to know if an HTML element is a crossed-out price element
 *
 * @param {HTMLElement} el
 * @returns {Boolean}
 */


const isCrossedOutPriceEl = el => el.classList.contains(CROSSED_OUT_PRICE_CSS_CLASS);
/**
 * Helper to know get price discount
 *
 * @param {number} price
 * @param {number} discountedPrice

 * @returns {number}
 */


const getPriceDiscount = (price, discountedPrice) => Math.round((price - discountedPrice) / price * 100);
/**
 * Helper that renders the price for a given set of HTML elements
 *
 * @param {Object} params
 * @param {NodeListOf<HTMLElement>} params.priceEls The price elements list
 * @param {string} [params.displayPrice=''] The price to render
 * @param {Boolean} [params.compareAtPrice=false] Should display as sale price?
 * @param {number} [params.price] Should display as sale price?
 * @param {number} [params.discountedPrice=null] Should display as sale price?

 */


const render$2 = ({
  priceEls,
  displayPrice = '',
  compareAtPrice = false,
  price,
  discountedPrice = null
}) => {
  priceEls.forEach(priceEl => {
    /** @type {HTMLElement | null} */
    const labelEl = priceEl.querySelector("." + PRICE_LABEL_CSS_CLASS);
    /** @type {HTMLElement | null} */

    const amountEl = priceEl.querySelector("." + PRICE_AMOUNT_LABEL_CSS_CLASS);
    const secondAmountEl = priceEl.querySelector("." + SECOND_PRICE_AMOUNT_LABEL_CSS_CLASS);
    const discountEl = priceEl.querySelector("." + PRICE_DISCOUNT_CSS_CLASS); // Handle the "compare" (crossed-out) logic to show/hide

    if (isCrossedOutPriceEl(priceEl)) {
      if (compareAtPrice) {
        // Allow the crossed-out "original" price element to be visible
        showElement(priceEl);
        discountEl.innerHTML = -getPriceDiscount(price, discountedPrice) + "%";
      } else {
        // Hide the crossed-out "original" price element, not needed
        hideElement(priceEl);
      }
    } // Handle the current price label logic


    if (labelEl) {
      labelEl.textContent = compareAtPrice ? priceEl.dataset.salePriceLabel : priceEl.dataset.regularPriceLabel;
    }

    if (displayPrice.includes("Infinity")) {
      crossedOutPriceEls.style.display = "none";
    } // Regardless of if current price or crossed-out price, update the display price


    if (amountEl && displayPrice.indexOf("test") === -1) {
      amountEl.textContent = displayPrice;
    }

    if (secondAmountEl && displayPrice.indexOf("test") === -1) secondAmountEl.textContent = displayPrice;
  });
};
/**
 * Handles updating the display prices when a variant is selected
 *
 * @param {Variant} variant
 */


const handleVariantSelection = ({
  price,
  compare_at_price: compareAtPrice
}) => {
  render$2({
    priceEls: currentPriceEls,
    displayPrice: formatPrice(price),
    compareAtPrice: compareAtPrice !== null
  });
  render$2({
    priceEls: crossedOutPriceEls,
    displayPrice: formatPrice(compareAtPrice),
    compareAtPrice: compareAtPrice !== null,
    price: compareAtPrice,
    discountedPrice: price
  });
};
/**
 * Handles updating the display prices when a model is selected
 *
 * @see https://app.gitbook.com/@decathlonusa/s/shopify/product-feature/product-page#price
 * @param {string} model
 */


const handleColorSelection = model => {
  const prices = getPricesByVariantColor(model);
  const minPrice = Math.min(...prices);
  const maxPrice = Math.max(...prices);
  /**
   * If all compare at prices are the same and exist for all sizes of selected
   * color, we want to show that compare at price crossed out. Otherwise,
   * show no compare at price (wait until a specific variant/size is
   * selected to show a crossed out price).
   */

  const compareAtPrices = getCompareAtPricesByColor(model);
  const allCompareAtPricesSame = compareAtPrices.every(compareAtPrice => compareAtPrice === compareAtPrices[0] && compareAtPrice); // Update normal price display amount & label

  render$2({
    priceEls: currentPriceEls,
    displayPrice: formatPriceRange({
      minPrice,
      maxPrice
    }),
    compareAtPrice: allCompareAtPricesSame
  }); // Update "compare at" crossed out price amount & show/hide

  render$2({
    priceEls: crossedOutPriceEls,
    compareAtPrice: allCompareAtPricesSame,
    displayPrice: formatPriceSingle(compareAtPrices[0]),
    discountedPrice: maxPrice,
    price: compareAtPrices[0]
  });
};
/**
 * Updates the price display with price and sale price if necessary
 *
 * @param {object} obj The state data object
 * @param {string | undefined} obj.model Currently selector model
 * @param {Variant | undefined} obj.variant Currently selected variant
 */


const onSwatchChange = ({
  model,
  variant
}) => {
  // A completed variant (color + size) selection takes priority
  if (variant) {
    handleVariantSelection(variant); // No need to continue

    return;
  }

  handleColorSelection(model);
};

// @ts-check

const modelCodeEls = document.querySelectorAll("." + JS_PREFIX + "ModelCode");
const modelCodeTextEls = document.querySelectorAll("." + JS_PREFIX + "ModelCode-text");
/**
 * Updates the UI with the variant's model code
 *
 * @param {string | null} model
 */

const onColorSelect$3 = model => {
  const modelCode = getModelCodeFromVariant(variantsJSON.find(variant => getVariantOptions(variant).model === "" + model));

  if (modelCode) {
    // Update the model code in the UI
    modelCodeTextEls.forEach(modelCodeTextEl => {
      modelCodeTextEl.textContent = "Ref : " + modelCode;
    }); // Then make sure any hidden model code wrappers are shown

    modelCodeEls.forEach(modelCodeEl => {
      modelCodeEl.classList.remove(IS_HIDDEN_CLASS);
    });
  } else {
    // No need to show model code wrappers if no model code exists
    modelCodeEls.forEach(modelCodeEl => {
      modelCodeEl.classList.add(IS_HIDDEN_CLASS);
    });
  }
};

// @ts-check
/**
 * @typedef State
 * @property {Variant | null} variant
 */

/** @type {State} */

const initialState$1 = {
  variant: null
};
const state$2 = createState(initialState$1);
/**
 * Updates product flags UI when variant changes
 * @param {Variant} variant
 */

const onVariantSelect$2 = variant => {
  state$2.updateState({
    variant
  });
};
/**
 * Updates the DOM to match the state
 * @param {State} state
 */

const render$3 = ({
  variant
}) => {
  const product = window.productJSON;
  const isOnSale = variant ? variant.compare_at_price > variant.price : product.compare_at_price > product.price; // PR 977 - Select only children of .js-de-BuyBoxFlags to:
  // - Avoid selecting product tiles elsewhere on the page (such as PAC)
  // - Select flags for both the mobile and desktop view

  const productFlagEls = document.querySelectorAll("." + JS_PREFIX + "BuyBoxFlags > ." + JS_PREFIX + "ProductFlag-lastCall");
  /**
   * Updates the flags hidden css class (show/hide)
   */

  productFlagEls.forEach(el => {
    if (isOnSale) showElement(el);else hideElement(el);
  });
};

state$2.onChange(render$3);

/**
 * Type for the ATC UI state
 *
 * @typedef {Object} UIState
 *
 * @property {string} addToCartButtonText
 * @property {string} validationText
 * @property {boolean} isAddToCartButtonDisabled
 * @property {boolean} isInAddToCartErrorState
 * @property {string | null} shopifyErrorMessage
 */

/**
 * Depending on what tag the product has, different text will render for the ATC button.
 *
 * There will be more product tags to account for in the future.
 *
 * @param {string[]} tags
 */

const getDefaultButtonText = tags => {
  if (tags.includes(ATC_PREORDER_TAG)) {
    return translate("Translation missing: es.products.product.atc_preorder");
  }

  return PRODUCT_PAGE_COPY.ADD_TO_CART;
};
/** @type {UIState} */


const DEFAULT_UI_STATE = {
  addToCartButtonText: getDefaultButtonText(productsJSON.tags),
  validationText: '',
  isAddToCartButtonDisabled: false,
  isInAddToCartErrorState: false,
  shopifyErrorMessage: null
};
/**
 * Returns the ATC AJAX error state based on the Shopify error `description` value
 *
 * @param {string} shopifyErrorMessage A Shopify error `description` value
 * @returns {UIState}
 */

const getShopifyErrorUIState = shopifyErrorMessage => {
  const defaultShopifyErrorUIState = Object.assign({}, DEFAULT_UI_STATE, {
    shopifyErrorMessage,
    isInAddToCartErrorState: true
  });
  const validationText = getCustomErrorMessage(shopifyErrorMessage, productsJSON); // Allows PAC to also receive the error message

  cartEventEmitter.emit('cartErrorText', validationText);
  /**
   * Handle "Inventory Case 1: Entirely Sold Out"
   * @see https://app.gitbook.com/@decathlonusa/s/shopify/product-feature/product-page#inventory-cases
   */

  if (isErrorScenario1(shopifyErrorMessage)) {
    // Emit quantity = 0 so that PAC displays 0 added items
    cartEventEmitter.emit('quantity', 0);

    if (isNonFollowedProduct(productsJSON)) {
      // Add to cart failed (422)
      // Emit `false` here because `isAjaxCartAddInProgress` is usually toggled
      // in the callback from GET `/cart.js`, which will never be called
      cartEventEmitter.emit('isAjaxCartAddInProgress', false);
      return Object.assign({}, defaultShopifyErrorUIState, {
        addToCartButtonText: PRODUCT_PAGE_COPY.SOLD_OUT,
        validationText,
        isAddToCartButtonDisabled: true
      });
    } // Add to cart failed (422)
    // Emit `false` here because `isAjaxCartAddInProgress` is usually toggled
    // in the callback from GET `/cart.js`, which will never be called


    cartEventEmitter.emit('isAjaxCartAddInProgress', false);
    return Object.assign({}, defaultShopifyErrorUIState, {
      addToCartButtonText: PRODUCT_PAGE_COPY.EMAIL_ME_WHEN_IN_STOCK,
      validationText
    });
  }
  /**
   * Handle "Inventory Case 2: Not sold out, can add at least 1 to cart"
   * @see https://app.gitbook.com/@decathlonusa/s/shopify/product-feature/product-page#inventory-cases
   */


  if (isErrorScenario2(shopifyErrorMessage)) {
    // Here we need to fire quantity = n so that PAC displays the modified quantity
    cartEventEmitter.emit('quantity', getQuantityFromMessage(shopifyErrorMessage)); // Do not emit `'isAjaxCartAddInProgress', false` here because it will
    // be handled in the callback from a follow-up GET `/cart.js` request

    return Object.assign({}, defaultShopifyErrorUIState, {
      validationText
    });
  }
  /**
   * Handle "Inventory Case 3: Not sold out, all stock already in cart"
   * @see https://app.gitbook.com/@decathlonusa/s/shopify/product-feature/product-page#inventory-cases
   */


  if (isErrorScenario3(shopifyErrorMessage)) {
    // Emit quantity = 0 so that PAC displays 0 added items
    cartEventEmitter.emit('quantity', 0); // Add to cart failed (422)
    // Emit `false` here because `isAjaxCartAddInProgress` is usually toggled
    // in the callback from GET `/cart.js`, which will never be called

    cartEventEmitter.emit('isAjaxCartAddInProgress', false);
    return Object.assign({}, defaultShopifyErrorUIState, {
      validationText
    });
  }
  /**
   * Handle "Inventory Case 4: Unknown Shopify error message - "Catch All" case"
   * @see https://app.gitbook.com/@decathlonusa/s/shopify/product-feature/product-page#inventory-cases
   */
  // Add to cart failed (422)
  // Emit `false` here because `isAjaxCartAddInProgress` is usually toggled
  // in the callback from GET `/cart.js`, which will never be called


  cartEventEmitter.emit('isAjaxCartAddInProgress', false);
  return Object.assign({}, defaultShopifyErrorUIState, {
    validationText
  });
};
/**
 * Returns the appropriate UI state depending on the `variant`
 *
 * @param {Variant | undefined} variant
 * @returns {UIState}
 */

const getUIState = variant => {
  if (!variant) {
    if (variantsJSON.every(isVariantOutOfStock)) {
      return Object.assign({}, DEFAULT_UI_STATE, {
        addToCartButtonText: PRODUCT_PAGE_COPY.EMAIL_ME_WHEN_IN_STOCK,
        validationText: PRODUCT_PAGE_COPY.ALL_SIZES_OUT_OF_STOCK
      });
    }

    return DEFAULT_UI_STATE;
  }

  if (isVariantSoldOut(variant)) {
    return Object.assign({}, DEFAULT_UI_STATE, {
      addToCartButtonText: PRODUCT_PAGE_COPY.SOLD_OUT,
      validationText: PRODUCT_PAGE_COPY.NEW_MODEL_IN_DESIGN,
      isAddToCartButtonDisabled: true
    });
  }

  if (isVariantOutOfStock(variant)) {
    return Object.assign({}, DEFAULT_UI_STATE, {
      addToCartButtonText: PRODUCT_PAGE_COPY.EMAIL_ME_WHEN_IN_STOCK,
      validationText: PRODUCT_PAGE_COPY.OUT_OF_STOCK
    });
  }

  if (!variantHasSufficientQuantity(variant)) {
    const shouldHideLimitedQuantityText = productsJSON.tags.includes(HIDE_ONLY_N_LEFT_TAG);
    return Object.assign({}, DEFAULT_UI_STATE, {
      // Products with the `HIDE_ONLY_N_LEFT_TAG` should not render "Only X left"
      // See DEC-5838
      validationText: shouldHideLimitedQuantityText ? '' : PRODUCT_PAGE_COPY.limitedQuantityLeft(variant.inventory_quantity)
    });
  }

  return DEFAULT_UI_STATE;
};

// @ts-check
const MODULE_NAME = 'AddToCart';
/**
 * UI elements
 */

/** @type {HTMLInputElement} */

const quantityInputEl = document.querySelector('.js-de-AddToCart-quantity');
/** @type {HTMLElement} */

const validationTextEl$1 = document.querySelector("." + VALIDATION_MESSAGE_CLASS);
/** @type {HTMLButtonElement} */

const addToCartButtonEl = document.querySelector('.js-de-AddToCart-btn');
/** @type {HTMLElement} */

const addToCartButtonTextEl = document.querySelector('.js-de-AddToCart-btn-text');
/**
 * Module Type Definitions
 */

/**
 * Type for the ATC module state
 *
 * @typedef {Object} ModuleState
 *
 * @property {string} module
 * @property {Variant} currentVariant
 * @property {string} addToCartButtonText
 * @property {string} validationText
 * @property {boolean} isAddToCartButtonDisabled
 * @property {boolean} isInAddToCartErrorState
 * @property {string | null} shopifyErrorMessage
 * @property {boolean} isProgrammaticAddToCart
 * @property {boolean} isLoading Whether the add to cart submit is loading
 */

/**
 * @type {ModuleState}
 */

const DEFAULT_MODULE_STATE = Object.assign({
  module: MODULE_NAME,
  currentVariant: null,
  isProgrammaticAddToCart: false,
  isLoading: false
}, DEFAULT_UI_STATE); // Create the module state

const state$3 = createState(DEFAULT_MODULE_STATE);
/** @typedef {() => void} CallBack */

/** @type {CallBack[]} */

const variantModificationListeners = [];
/**
 * Subscribe to modifications to the global productJSON.variants
 * In this case the modifications are changes in variant quantities
 * @param {CallBack} cb
 */

const onVariantModification = cb => variantModificationListeners.push(cb);

const handleVariantModification = () => {
  variantModificationListeners.forEach(listener => listener());
};
/**
 * Adds a given quantity of the current variant to cart programmatically
 * @param {string | number} quantity
 */


const addToCartProgrammatically = quantity => {
  if (!quantityInputEl || !addToCartButtonEl) return;
  /** Update the state */

  state$3.updateState({
    isProgrammaticAddToCart: true
  });
  /** Set up the quantity input with the available quantity value */

  quantityInputEl.value = String(quantity);
  /**
   * We are clicking the UI button instead of performing an AJAX request or
   * submitting the form directly because we want to make sure the
   * Persistent Cart logic comes into play.
   * We have to ensure the button is not disabled before clicking it
   * The button is disabled before making this change
   * because the component doesn't re-render until the next tick
   */

  addToCartButtonEl.disabled = false;
  addToCartButtonEl.click();
};

jQuery('body').on('addItemSuccess.ajaxCart', () => {
  state$3.updateState({
    isLoading: false
  });
});
/**
 * @todo Remove jQuery dependency, if possible
 */

jQuery('body').on('addItemError.ajaxCart', (e, {
  description
}) => {
  const currentVariant = state$3.getState().currentVariant;
  if (!description || !currentVariant) return; // Update the state with the proper error message/UI state

  state$3.updateState(Object.assign({}, DEFAULT_MODULE_STATE, getShopifyErrorUIState(description), {
    currentVariant,
    isLoading: false
  }));

  if (isErrorScenario1(description)) {
    // Entirely sold out
    currentVariant.available = false;
    currentVariant.inventory_quantity = 0;
    handleVariantModification();
  }

  if (isErrorScenario2(description)) {
    /**
     * Add available items for current variant to cart programmatically using
     * the Shopify error message to provide the quantity
     */
    addToCartProgrammatically(getQuantityFromMessage(description));
  }
});
/**
 * The handler for when Add to Cart is clicked
 * @param {Event} event
 */

const onAddToCartClick = event => {
  const {
    currentVariant,
    isProgrammaticAddToCart
  } = state$3.getState();

  if (!currentVariant) {
    // Prevent Add To Cart form submit from going through
    event.preventDefault();
    handleAddToCartAttemptWithNoVariant();
    return;
  }

  if (isVariantOutOfStock(currentVariant) && window.BISPopover) {
    // Show modal, with current variant selected
    window.BISPopover.show({
      variantId: currentVariant.id
    }); // Set modal email input with customer's email

    /** @type {HTMLIFrameElement} */

    const BISPopoverEl = document.querySelector('#BIS_frame');
    /** @type {HTMLInputElement} */

    const BISPopoverEmailInputEl = BISPopoverEl.contentDocument.querySelector('#email_address');
    const customer = window.Shopify.customer;

    if (BISPopoverEmailInputEl && customer) {
      BISPopoverEmailInputEl.value = customer.email;
    }
  } else {
    setTimeout(() => {
      // Display loading state, but only after click event has propagated
      state$3.updateState({
        isLoading: true
      });
    });
  }
  /**
   * If the ATC action was completed programmatically, then reset only the
   * `isProgrammaticAddToCart` flag and hold off resetting the UI state. This allows
   * the AJAX custom error to stay visible.
   */


  if (isProgrammaticAddToCart) {
    state$3.updateState({
      isProgrammaticAddToCart: false
    });
    return;
  } // Reset the state to the default for that variant
  // (clears out ajax shopify error state)


  state$3.updateState(getUIState(currentVariant));
  /**
   * Clears Shopify AJAX error message (in PAC component)
   *
   * @todo See if there's a chance to refactor so this emitter
   * can be removed from this file.
   */

  cartEventEmitter.emit('cartErrorText', '');
};
/**
 * To be called when a different variant is selected.
 * Resets the state, including resetting ajax error messages
 * @param {Variant | undefined} newVariant
 */


const onVariantSelect$3 = newVariant => {
  state$3.updateState(Object.assign({}, DEFAULT_MODULE_STATE, getUIState(newVariant), {
    currentVariant: newVariant
  }));
};
/**
 * Makes the DOM reflect the state
 * @param {ModuleState} state
 */

const render$4 = ({
  isAddToCartButtonDisabled,
  validationText,
  addToCartButtonText,
  isLoading
}) => {
  /**
   * Give priority to the error messages. This ensures the UI gets updated
   * regardless of the availability of `addToCartButtonEl` or `addToCartButtonTextEl`
   */
  if (validationTextEl$1) {
    validationTextEl$1.textContent = validationText;
  }
  /**
   * From a UX perspective, group the button and button text check together
   */


  if (!addToCartButtonEl || !addToCartButtonTextEl) return;
  addToCartButtonEl.disabled = isAddToCartButtonDisabled || isLoading;
  const buttonText = isLoading ? 'Adding to cart' : addToCartButtonText;
  addToCartButtonTextEl.textContent = buttonText; // We are setting aria-label so that screen readers do not read the all-caps text as individual characters

  addToCartButtonTextEl.setAttribute('aria-label', buttonText);
  /**
   * Disable opening of PAC drawer in the case that the ATC button
   * will open the e-mail modal
   */

  const shouldDrawerOpen = addToCartButtonText === PRODUCT_PAGE_COPY.EMAIL_ME_WHEN_IN_STOCK ? 'close' : 'open';
  addToCartButtonEl.setAttribute('data-drawer-action', shouldDrawerOpen);
};

state$3.onChange(render$4);
/**
 * Initialize the ATC UI
 */

const init$7 = () => {
  /**
   * Listener for Add to Cart button
   */
  if (addToCartButtonEl) {
    addToCartButtonEl.addEventListener('click', onAddToCartClick);
  }
};

/**
 * Remove or add a role from an element
 * @param {Object} params
 * @param {HTMLElement} params.el - The element on which to add or remove an
 * attribute / attribute + value
 * @param {string} params.name - The name of the attribute to be changed, added,
 * or removed
 * @param {string} params.value - The value to add or remove from a particular
 * attribute
 * @param {boolean} params.remove - Whether to remove the value. If false,
 * the value or attribute will be added
 *
 * @todo Consider a refactor using the MDN `Element.toggleAttribute()` polyfill
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/toggleAttribute#Polyfill
 */
const toggleAttributeValue = ({
  el,
  name,
  value,
  remove
}) => {
  if (!el || !el.getAttribute || !name || typeof remove !== 'boolean') {
    return;
  }

  let attrValues = el.getAttribute(name);
  /**
   * If there are no existing values for the given attribute set on the element,
   * just return. If the attribute is to be set, just set it directly and return.
   */

  if (!attrValues) {
    if (remove) {
      return;
    }

    el.setAttribute(name, value);
    return;
  }
  /**
   * Make an array of attribute values
   */


  attrValues = attrValues.split(' ');
  /**
   * If there are existing values, either filter out the value to be removed or
   * add the new one, if it isn't already in the list of values
   */

  if (remove) {
    attrValues = attrValues.filter(val => val !== value);
  } else if (!attrValues.some(val => val === value)) {
    attrValues.push(value);
  }
  /**
   * If there are no longer any values, remove the attribute
   */


  if (attrValues.length === 0) {
    el.removeAttribute(name);
    return;
  }
  /**
   * Convert values back to a string and set the attribute on the element
   */


  attrValues = attrValues.join(' ');
  el.setAttribute(name, attrValues);
};

/**
 * Focus Trap Module
 *
 * UI tab focus trap helper for a given parent dialog element.
 * Intended to be used with modal dialogs when open.
 *
 * @see https://www.w3.org/TR/wai-aria-practices-1.1/#dialog_modal
 * @see https://bitsofco.de/accessible-modal-dialog/#5whileopenpreventtabbingtooutsidethedialog
 */
/**
 * Module constants
 */

const MODULE_NAME$1 = 'FocusTrap';
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
 * Using a lowercase version to test against, default values are uppercased.
 */

const TAB_KEY_VALUE = 'tab';
/**
 * Focusable element list borrowed from edenspiekermann/a11y-dialog project
 * @see https://github.com/edenspiekermann/a11y-dialog/blob/cf4ed8155bf8db0336ab556f2e4eafcaebc9e905/a11y-dialog.js#L6-L18
 */

const NOT_INERT_SELECTOR = ':not([inert])';
const NOT_NEGATIVE_TAB_INDEX_SELECTOR = ':not([tabindex^="-"])';
const NOT_DISABLED_SELECTOR = ':not([disabled])';
const FOCUSABLE_ELEMENT_SELECTORS = ["a[href]" + NOT_NEGATIVE_TAB_INDEX_SELECTOR + NOT_INERT_SELECTOR, "area[href]" + NOT_NEGATIVE_TAB_INDEX_SELECTOR + NOT_INERT_SELECTOR, "input" + NOT_DISABLED_SELECTOR + NOT_INERT_SELECTOR, "select" + NOT_DISABLED_SELECTOR + NOT_INERT_SELECTOR, "textarea" + NOT_DISABLED_SELECTOR + NOT_INERT_SELECTOR, "button" + NOT_DISABLED_SELECTOR + NOT_INERT_SELECTOR, "iframe" + NOT_NEGATIVE_TAB_INDEX_SELECTOR + NOT_INERT_SELECTOR, "audio" + NOT_NEGATIVE_TAB_INDEX_SELECTOR + NOT_INERT_SELECTOR, "video" + NOT_NEGATIVE_TAB_INDEX_SELECTOR + NOT_INERT_SELECTOR, "[contenteditable]" + NOT_NEGATIVE_TAB_INDEX_SELECTOR + NOT_INERT_SELECTOR, "[tabindex]" + NOT_NEGATIVE_TAB_INDEX_SELECTOR + NOT_INERT_SELECTOR];
/**
 * Module state defaults
 *
 * @param {Object} state
 * @param {string} state.moduleName The name of the current module,
 *        helpful for debugging
 * @param {Element} state.focusableEls The focusable elements within
 *        the active dialog
 * @param {Element} state.firstFocusableEl The first focusable element within
 *        the active dialog
 * @param {Element} state.lastFocusableEl The last focusable element within
 *        the active dialog
 */

const DEFAULT_MODULE_STATE$1 = {
  module: MODULE_NAME$1,
  focusableEls: null,
  firstFocusableEl: null,
  lastFocusableEl: null
};
/**
 * Stores the state helper
 */

let stateHelper;
/**
 * Helper for detecting the "Tab" keyboard key
 *
 * @param {string} key A keyboard event `key`
 * @returns {boolean}
 */

const isTabKey = key => key.toLowerCase() === TAB_KEY_VALUE;
/**
 * Helper to retrieve the focusable elements for a given dialog
 *
 * @todo Refactor to work with non-ID values?
 *
 * @param {string} dialogId The ID of the given dialog
 * @return {NodeList} A NodeList of focusable elements for the given dialog
 */


const getFocusableElements = dialogId => document.querySelectorAll(FOCUSABLE_ELEMENT_SELECTORS.map(selector => "#" + dialogId + " " + selector).join());
/**
 * Helper to find out if multiple focusable elements exist
 *
 * @param {Object} state A state object
 * @param {NodeList} state.focusableEls A NodeList of focusable elements
 */


const hasMultipleFocusableElements = ({
  focusableEls
}) => focusableEls.length > 1;
/**
 * Updates first/last focusable elements for given dialog
 *
 * Should be called when a new dialog is opened. This allows the FocusTrap
 * module to update the current first/last focusable elements.
 *
 * @param {string} dialogId The ID of the given dialog
 */


const updateFocusableEls = dialogId => {
  const focusableEls = getFocusableElements(dialogId);
  stateHelper.updateState({
    focusableEls,
    firstFocusableEl: focusableEls[0],
    lastFocusableEl: focusableEls[focusableEls.length - 1]
  });
};
/**
 * Traps the tab focus
 *
 * Uses own FocusTrap module state to know when the first/last focusable
 * element has been tabbed to and resets the focus accordingly.
 *
 * @param {Event} keyboardEvent A keyboard event
 */

const trapFocus = keyboardEvent => {
  const {
    key,
    shiftKey
  } = keyboardEvent; // Scope the focus trap to the "Tab" key event

  if (isTabKey(key)) {
    const state = stateHelper.getState(); // No need to handle focus resets if there aren't enough focusable elements

    if (!hasMultipleFocusableElements(state)) {
      keyboardEvent.preventDefault();
      return;
    } // Handle forward (Tab) and backward (Shift + Tab) tabbing


    if (shiftKey) {
      if (document.activeElement === state.firstFocusableEl) {
        keyboardEvent.preventDefault();
        state.lastFocusableEl.focus();
      }
    } else if (document.activeElement === state.lastFocusableEl) {
      keyboardEvent.preventDefault();
      state.firstFocusableEl.focus();
    }
  }
};
/**
 * Initialize FocusTrap module
 */

const init$8 = () => {
  stateHelper = createState(DEFAULT_MODULE_STATE$1);
};

// @ts-check
/**
 * Query string module
 *
 * Provides helpers for interacting with URL paramaters
 */

/**
 * Updates the variant id in the URL when a new variant is selected
 *
 * @param {string | number | null | undefined} variantId The variant ID
 */

const updateUrlVariant = variantId => {
  /** @type any */
  const parsedQueryParams = decode( // Remove "?"
  window.location.search.substr(1));
  parsedQueryParams.variant = variantId === null ? undefined : variantId;
  const updatedUrl = "?" + encode(parsedQueryParams);
  updateUrl(updatedUrl);
};
/**
 * @param {string} newUrl
 */

const updateUrl = newUrl => {
  window.realReplaceState({}, null, newUrl);
};
/**
 * @param {string} newHash
 */

const updateHash = newHash => // If the new hash is '#' or '', remove it entirely
updateUrl(newHash.replace(/#$/, '') === '' ? window.location.href.replace(window.location.hash, '') // URL without hash
: newHash);

/**
 * Drawer Module
 *
 * Controls the opening/closing of the drawer UI. For accessibility purposes,
 * the Drawer module is treated as a Dialog.
 * @see https://www.w3.org/TR/wai-aria-practices-1.1/#dialog_modal
 */
/**
 * Module constants
 */

const MODULE_NAME$2 = 'Drawer';
const CLICK_EVENT$3 = 'click';
const KEY_DOWN_EVENT = 'keydown';
/**
 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/key/Key_Values
 * Using a lowercase version to test against, default values are uppercased.
 */

const ESCAPE_KEY_VALUE = 'escape';
const OPEN_ACTION = 'open';
const STATE_PREFIX = CSS_PREFIX + "is-";
const DRAWER_PREFIX = MODULE_NAME$2 + "-";
const TOGGLE_SELECTOR = "." + JS_PREFIX + DRAWER_PREFIX + "toggle";
const OVERLAY_SELECTOR = "." + JS_PREFIX + DRAWER_PREFIX + "overlay";
const MAIN_CONTENT_WRAP_SELECTOR = "." + JS_PREFIX + DRAWER_PREFIX + "wrap";
const DRAWER_IN_FLOW_CLASS = STATE_PREFIX + "inPageFlow";
const IS_OPEN_CLASS = STATE_PREFIX + "open";
const IS_OPENING_CLASS = STATE_PREFIX + "opening";
const IS_CLOSED_CLASS = STATE_PREFIX + "closed";
const IS_CLOSING_CLASS = STATE_PREFIX + "closing";
const IS_DRAWER_OPEN_CLASS = STATE_PREFIX + "drawerOpen";
const POST_ADD_TO_CART_DRAWER_ID = 'post-add-to-cart-drawer';
/**
 * TRANSITION_DURATION value must match (in milliseconds) the value in associated
 * CSS for transition duration ($transition-speed-normal)
 *
 * @see assets/product.scss.liquid
 */

const TRANSITION_DURATION = 200;
/**
 * Module state defaults
 *
 * @param {Object} state
 * @param {string} state.module The name of the module
 * @param {boolean} state.isOpen Keeps track of drawer "open" state
 + @param {Element} state.drawerEl The current drawer element to perform actions on
 * @param {Element} state.lastOpenToggleEl Toggle that last opened the drawer
 * @param {NodeList} state.wrapperEls Main content wrapper elements
 */

const DEFAULT_MODULE_STATE$2 = {
  module: MODULE_NAME$2,
  isOpen: false,
  drawerEl: null,
  lastOpenToggleEl: null,
  wrapperEls: null,
  htmlEl: null,
  windowScrollPosition: 0
};
/**
 * Reference to the `createState` helper. The `createState`
 * helper assists to create, update and get module state.
 * @see scripts/utilities/create-state.js
 */

let stateHelper$1;
/**
 * Helper to confirm if the given action is "open"
 *
 * Anything other than "open" will return `false`.
 *
 * @param {string} action The toggle action in question ("open"/"close")
 * @returns {boolean} Is the action set to "open"?
 */

const isActionOpen = action => action.trim().toLowerCase() === OPEN_ACTION;
/**
 * Helper for detecting the "Escape" keyboard key
 *
 * @param {string} key A keyboard event `key`
 * @returns {boolean}
 */


const isEscapeKey = key => key.toLowerCase() === ESCAPE_KEY_VALUE;
/**
 * The keyboard event handler
 *
 * @param {KeyboardEvent} keyboardEvent
 */


const keyboardEventHandler = keyboardEvent => {
  const {
    key
  } = keyboardEvent;
  /**
   * For better accessibility, the drawer should close via the "escape" key
   */

  if (isEscapeKey(key)) {
    // Update the module state to a "closed" state
    stateHelper$1.updateState({
      isOpen: false
    }); // Render the UI with the new state

    render$5(stateHelper$1.getState());
  } // Handles trapping the tab focus within the open dialog


  trapFocus(keyboardEvent);
};
/**
 * Updates the keyboard event listeners depending on the state
 *
 * @param {Object} state The state data object
 * @param {boolean} state.isOpen Whether the drawer is open or not
 */


const updateKeyboardListeners = ({
  isOpen
}) => {
  if (isOpen) {
    document.addEventListener(KEY_DOWN_EVENT, keyboardEventHandler);
  } else {
    document.removeEventListener(KEY_DOWN_EVENT, keyboardEventHandler);
  }
};
/**
 * Toggle or update classes on the drawer when applied to content that also
 * appears in page flow when the drawer is closed
 *
 * @param {Object} params
 * @param {HTMLElement} params.drawerEl - The drawer component element
 * @param {boolean} params.isOpen - Whether the action being handled is to open the
 * drawer
 */


const inFlowDisplayStateChangeUpdates = ({
  drawerEl,
  isOpen
}) => {
  drawerEl.classList.toggle(DRAWER_IN_FLOW_CLASS, !isOpen);
  toggleAttributeValue({
    el: drawerEl,
    name: 'role',
    value: 'dialog',
    remove: !isOpen
  });
};
/**
 * Get the window y-axis scroll position, storing to state
 */


const updateWindowScrollPosition = () => stateHelper$1.updateState({
  windowScrollPosition: window.pageYOffset
});
/**
 * Set the window y-axis scroll position from state
 *
 * Note the conditional use of `document.documentElement`, `document.body`, or `window.scrollTo`
 * `document.documentElement.scrollTop` is for IE
 * `document.body.scrollTop` is for Chrome, Safari, and Opera
 * `window.scrollTo` is for Firefox
 */


const setWindowScrollPosition = () => {
  const {
    windowScrollPosition
  } = stateHelper$1.getState();

  if (typeof window.scrollTo === 'function') {
    window.scrollTo(0, windowScrollPosition);
  } else {
    const scrollEl = document.documentElement || document.body;
    scrollEl.scrollTop = windowScrollPosition;
  }
};
/**
 * Toggle or otherwise update classes on the drawer and drawer content
 * @param {Object} params
 * @param {Element} params.drawerEl - The drawer component element
 * @param {boolean} params.isOpen - Whether the action being handled is to open the
 * drawer
 * @param {NodeList} params.wrapperEls A NodeList of main content wrapper elements
 */


const updateBaseDrawerClasses = ({
  drawerEl,
  isOpen,
  wrapperEls
}) => {
  /**
   * Toggle fixed positioning on the wrapper(s) of the drawer, to prevent
   * scrolling content outside the drawer
   */
  wrapperEls.forEach(wrap => {
    wrap.classList.toggle(FIXED_CLASS, isOpen);
  });
  /**
   * Add or remove an active class to the drawer
   */

  drawerEl.classList.toggle(IS_ACTIVE_CLASS, isOpen);
};
/**
 * Updates for accessibility on opening and closing the drawer
 * @param {Object} params
 * @param {Element} params.drawerEl - The drawer component element
 * @param {Element} params.lastOpenToggleEl The last toggle that opened the drawer
 * @param {boolean} params.isOpen - Whether the action being handled is to open the
 * drawer
 */


const updateAccessibilityState = ({
  drawerEl,
  isOpen,
  lastOpenToggleEl
}) => {
  const closeToggle = document.querySelector("#" + drawerEl.id + " " + TOGGLE_SELECTOR);
  /**
   * For accessibility, set the focus on the close toggle for an open
   * drawer or the last-used drawer-open toggle if the drawer is closing
   */

  isOpen && closeToggle && closeToggle.focus();
  !isOpen && lastOpenToggleEl && lastOpenToggleEl.focus();
};
/**
 * Base updates needed on opening or closing the drawer, separate from those
 * needed for a drawer with content that also displays in page flow
 * @param {Object} state
 * @param {Element} state.drawerEl - The drawer component element
 * @param {boolean} state.isOpen - Whether the action being handled
 * is to open the drawer
 * @param {Element} state.lastOpenToggleEl The last toggle that opened the drawer
 * @param {NodeList} state.wrapperEls A NodeList of main content wrapper elements
 * drawer
 */


const baseStateChangeUpdates = ({
  drawerEl,
  isOpen,
  lastOpenToggleEl,
  wrapperEls
}) => {
  updateBaseDrawerClasses({
    drawerEl,
    isOpen,
    wrapperEls
  });
  updateAccessibilityState({
    drawerEl,
    isOpen,
    lastOpenToggleEl
  });
};
/**
 * Timed updates of transition-related classes on the drawer
 *
 * IIFE wraps returned function and provides timeout placeholder variables
 * in closure
 *
 * @param {Object} state
 * @param {Element} state.drawerEl - The drawer component element
 * @param {Element} state.htmlEl - The HTML (root) element, which needs
 * to have a class set when the drawer is open to avoid double y-axis scrollbars
 * @param {boolean} state.isOpen - Whether the action being handled
 * is to open the drawer
 */


const setDrawerTransitionStates = (() => {
  let openTimeout = null;
  let closeTimeout = null;
  const closeStateCssClasses = [IS_CLOSED_CLASS, IS_CLOSING_CLASS];
  const openStateCssClasses = [IS_OPEN_CLASS, IS_OPENING_CLASS];
  return function _setDrawerTransitionStates({
    drawerEl,
    htmlEl,
    isOpen
  }) {
    if (isOpen) {
      closeTimeout && clearTimeout(closeTimeout);
      drawerEl.classList.remove(...closeStateCssClasses, IS_OPEN_CLASS);
      drawerEl.classList.add(IS_OPENING_CLASS);
      openTimeout = setTimeout(() => {
        drawerEl.classList.remove(IS_OPENING_CLASS, ...closeStateCssClasses);
        drawerEl.classList.add(IS_OPEN_CLASS);
        /**
         * Avoid double vertical scroll bars when drawer is open
         * by removing overflow on the root element
         */

        htmlEl.classList.add(HIDE_OVERFLOW_Y_CLASS);
      }, TRANSITION_DURATION);
    } else {
      openTimeout && clearTimeout(openTimeout);
      drawerEl.classList.remove(...openStateCssClasses, IS_CLOSED_CLASS);
      drawerEl.classList.add(IS_CLOSING_CLASS);
      closeTimeout = setTimeout(() => {
        drawerEl.classList.remove(IS_CLOSING_CLASS, ...openStateCssClasses);
        drawerEl.classList.add(IS_CLOSED_CLASS);
      }, TRANSITION_DURATION);
      /**
       * Modify the point at which `overflow-y: scroll` is added back to
       * the `html` (root) element, to avoid visible repositioning of page
       * elements when the page scrollbar reappears
       */

      setTimeout(() => {
        htmlEl.classList.remove(HIDE_OVERFLOW_Y_CLASS); // Sets the window scroll position, referenced from state

        setWindowScrollPosition();
      }, TRANSITION_DURATION / 4);
    }
  };
})();
/**
 * Set or unset a class on UI wrapper elements indicating the drawer is
 * in some state of transition
 * @see `assets/product-collapse.scss.liquid`
 * @param {Object} state - UI state
 * @param {NodeList} state.wrapperEls - Wrappers that should be aware of drawer state
 */


const setDrawerInTransitionOnWrapper = ({
  wrapperEls
}, inTransition = true) => {
  const classListMethod = inTransition ? 'add' : 'remove';
  wrapperEls.forEach(el => el.classList[classListMethod](IS_DRAWER_OPEN_CLASS));
};
/**
 * Helper to unset a class on UI wrapper elements indicating the drawer is
 * no longer in some state of transition
 * @param {Object} state
 */


const unsetDrawerInTransitionOnWrapper = state => setDrawerInTransitionOnWrapper(state, false);
/**
 * Handles UI updates for the drawer
 * Forks behavior and staggers timing for updates with drawers that display
 * content that is also shown in page flow
 *
 * IIFE wraps returned function and provides timeout placeholder variables
 * in closure
 *
 * @param {Object} state The new UI state
 */


const updateUI = (() => {
  let baseStateChangeTimeout = null;
  let inFlowDisplayStateChangeTimeout = null;
  return function _updateUI(state) {
    const {
      isOpen,
      drawerEl
    } = state;
    const displaysInPageFlow = drawerEl.dataset.displayInPageFlow;
    setDrawerTransitionStates(state);
    /**
     * If the drawer is opening ...
     */

    if (isOpen) {
      setDrawerInTransitionOnWrapper(state);
      inFlowDisplayStateChangeTimeout && clearTimeout(inFlowDisplayStateChangeTimeout);
      /**
       * ... and is set to show content that also appears in page flow ...
       */

      if (displaysInPageFlow) {
        /**
         * Toggle in-flow-display drawer classes, then use a timeout set to the
         * default transition duration to apply other class updates to the drawer
         * and its content
         */
        inFlowDisplayStateChangeUpdates(state);
        baseStateChangeTimeout = setTimeout(() => {
          baseStateChangeUpdates(state);
        }, TRANSITION_DURATION);
      } else {
        /**
         * ... Otherwise, just update the base set of drawer classes ...
         */
        baseStateChangeUpdates(state);
      }
      /**
       * ... or, if the drawer is closing ...
       */

    } else {
      baseStateChangeTimeout && clearTimeout(baseStateChangeTimeout);
      /**
       * ... update the base set of drawer classes ...
       */

      baseStateChangeUpdates(state);
      /**
       * ... and if the drawer is set to show content that also appears in page
       * flow, use a timeout set to the default transition duration to update
       * in-flow-display drawer classes
       */

      if (displaysInPageFlow) {
        inFlowDisplayStateChangeTimeout = setTimeout(() => {
          inFlowDisplayStateChangeUpdates(state);
          unsetDrawerInTransitionOnWrapper(state);
        }, TRANSITION_DURATION);
      } else {
        unsetDrawerInTransitionOnWrapper(state);
      }
    }
  };
})();
/**
 * Handle all UI and listener updates based on the provided state
 *
 * @param {Object} state The state to render against
 */


const render$5 = state => {
  updateUI(state);
  updateKeyboardListeners(state);
};
/**
 * Handler for the toggle action
 *
 * @param {Object} event The event object
 */


const toggleHandler = function toggleHandler(event) {
  const {
    drawerAction,
    drawerId,
    drawerPreventDefault = 'true'
  } =
  /** @type {DrawerToggleDataAttributes} */
  event.currentTarget.dataset;

  if (drawerPreventDefault.toLowerCase() === 'true') {
    event.preventDefault();
  }

  const drawerEl = document.getElementById(drawerId); // No need to run any further logic if we have no drawer to work with

  if (!drawerEl) {
    return;
  } // Only open Post Add to Cart drawer if a variant is selected


  if (drawerEl.id === POST_ADD_TO_CART_DRAWER_ID && !getUrlVariant()) {
    return;
  }

  const isOpen = isActionOpen(drawerAction);
  const newState = {
    isOpen,
    drawerEl
  };

  if (isOpen) {
    newState.lastOpenToggleEl = event.currentTarget; // Let the FocusTrap module update the first/last focusable elements

    updateFocusableEls(drawerId); // Captures the window scroll position, saving it to state

    updateWindowScrollPosition();
  } // Update the module state


  stateHelper$1.updateState(newState); // Render all UI updates based on new state

  render$5(stateHelper$1.getState());
};
/**
 * Initialize Drawer toggles
 *
 * @param {Element} toggle Drawer toggle element to initialize
 */


const initToggle = toggle => {
  /**
   * `<a>` toggle elements are progressively-enhanced by JS and should
   * be treated as buttons when accessing the UI via screen readers.
   */
  if (toggle.tagName.toLowerCase() === 'a') {
    toggle.setAttribute('role', 'button');
  }
  /**
   * JS progressively-enhanced toggles have aria-labels added to them for
   * a better UX when accessed via screen readers.
   */


  const ariaLabel = toggle.dataset.drawerToggleAriaLabel;

  if (ariaLabel) {
    toggle.setAttribute('aria-label', ariaLabel); // This is cleanup, no longer needed once JS takes over.

    toggle.removeAttribute('data-drawer-toggle-aria-label');
  }

  toggle.addEventListener(CLICK_EVENT$3, toggleHandler);
};
/**
 * Initialize Drawer
 */


const init$9 = () => {
  stateHelper$1 = createState(Object.assign({}, DEFAULT_MODULE_STATE$2, {
    // Get all content wrapper elements
    wrapperEls: document.querySelectorAll(MAIN_CONTENT_WRAP_SELECTOR),
    htmlEl: document.querySelector('html')
  })); // Initialize toggles

  document.querySelectorAll(TOGGLE_SELECTOR + ", " + OVERLAY_SELECTOR).forEach(initToggle); // Initialize the FocusTrap module

  init$8();
};

// @ts-check
/**
 * Throttles a function to only be called a certain interval. Does not pass
 * parameters to callback or preserve callback return value
 * @param {() => any} cb
 * @param {Number} interval
 * @returns {() => void}
 */

const throttle = (cb, interval) => {
  let runThisTime = false;
  setInterval(() => {
    if (runThisTime) cb();
    runThisTime = false;
  }, interval);
  return () => {
    runThisTime = true;
  };
};
/**
 * Determine which section should be shown in the URL hash based on the scroll position
 * Loops through the headings to find the section that is visible at the cutoff of the top ~third of the screen
 * We _could_ use IntersectionObserver but it isn't supported in IE11 and this is way tinier than a polyfill.
 * Since it doesn't know where the sections end,
 * it finds the section that is _right before_ the heading that is highest up but still below the cutoff
 * @param {HTMLElement[]} targets
 */


const getMatchingTarget = targets => {
  const screenHeight = window.innerHeight;
  const isAtPageBottom = screenHeight + document.documentElement.scrollTop >= document.documentElement.scrollHeight; // If we have scrolled all the way to the bottom, it should auto-select the last item

  if (isAtPageBottom) return targets[targets.length - 1];
  /** The index in the targets array of the highest heading that is below the cutoff */

  const firstHeadingBelowCutoff = targets.findIndex(thisTarget => {
    // The bottom of the target is the top of the corresponding heading
    const headingTop = thisTarget.getBoundingClientRect().bottom; // 0.3 is the cutoff of where it is looking for the active section
    // It is the % of the distance down from the top of the screen where it is looking

    const isBelowCutoff = headingTop > 0.3 * screenHeight;
    return isBelowCutoff;
  }); // If all of the headings are above the cutoff, return the last heading

  if (firstHeadingBelowCutoff === -1) return targets[targets.length - 1]; // We want to select the target for the section that is right above the first heading below the cutoff
  // The section that is at the cutoff is the section right before the first section below the cutoff
  // if firstHeadingBelowCutoff is zero, this returns undefined because all of the sections are too low

  return targets[firstHeadingBelowCutoff - 1];
};
/**
 * Sets up active state of the active item in the sticky nav
 */


const init$a = () => {
  const links = document.querySelectorAll("li:not(." + IS_HIDDEN_CLASS + ") ." + JS_PREFIX + "StickyMenuItem");
  const targets = [...links].map(link => document.getElementById(link.getAttribute('href').replace(/^#/, '')));
  let lastHash = window.location.hash;
  /**
   * Sets the correct classes on all the sticky nav items
   */

  const updateLinksState = () => {
    links.forEach(link => {
      if (link.getAttribute('href') === window.location.hash) {
        link.classList.add(IS_ACTIVE_CLASS);
      } else {
        link.classList.remove(IS_ACTIVE_CLASS);
      }
    });
  };
  /**
   * Updates the URL hash and links if the user have scrolled to a different
   * section
   */


  const updateScrollState = () => {
    const matchingTarget = getMatchingTarget(targets);
    const newHash = "#" + (matchingTarget ? matchingTarget.id : ''); // Using replaceState instead of window.location.hash because we don't want it to jump

    if (lastHash !== newHash) {
      lastHash = newHash;
      updateHash(newHash);
    }

    updateLinksState();
  };

  updateScrollState();
  window.addEventListener('hashchange', updateLinksState);
  window.addEventListener('scroll', throttle(updateScrollState, 100));
};

/**
 * Return a URL for a thumbnail image, given a Shopify Image URL
 * @param {string} url - A Shopify Image URL
 * @returns {string} - A modified URL
 */
const getThumbnailImageSrc = url => {
  // @TODO - Test for use of 100x or x100 (check this) and use 100x instead of small to create
  const smallThumbRegEx = /[_small|_100x]\./;
  const imageSuffixRegEx = /(\.[jpg|jpeg|gif|png|webp])/;

  if (smallThumbRegEx.test(url)) {
    return url;
  }

  return url.replace(imageSuffixRegEx, '_100x$1');
};

// @ts-check
/**
 * Return an object with all DOM selectors needed for the  module to work
 * @returns {PickupOptionsEls} All elements for the module
 */

const initUI = () => ({
  storeTileListEl: document.querySelector("." + STORE_PICKUP_LIST_SELECTOR),
  userLocationCityEl: document.querySelector("." + STORE_PICKUP_USER_CITY_SELECTOR),
  userLocationStateEl: document.querySelector("." + STORE_PICKUP_USER_STATE_SELECTOR),
  storeAddress1El: document.querySelector("." + STORE_PICKUP_ADDRESS),
  storeCityEl: document.querySelector("." + STORE_PICKUP_CITY),
  pickupTimeFrameEl: document.querySelector("." + PICKUP_TIME_FRAME),
  storePickupOptionsEl: document.querySelector("." + STORE_PICKUP_OPTIONS),
  storePickupDetailsEl: document.querySelector("." + STORE_PICKUP_DETAILS),
  selectForPickupOptionsMessageEl: document.querySelector("." + SELECT_FOR_PICKUP_OPTIONS_MESSAGE),
  thumbnailImageEl: document.querySelector("." + STORE_PICKUP_THUMBNAIL_IMAGE),
  variantColorEl: document.querySelector("." + STORE_PICKUP_VARIANT_COLOR),
  variantSizeEl: document.querySelector("." + STORE_PICKUP_VARIANT_SIZE),
  locationUpdateMessageEl: document.querySelector("." + STORE_PICKUP_LOCATION_UPDATE_MESSAGE),
  locationUpdateMessageContentEl: document.querySelector("." + STORE_PICKUP_LOCATION_UPDATE_MESSAGE_CONTENT),
  defaultLocationUpdateMessageEl: document.querySelector("." + STORE_PICKUP_DEFAULT_LOCATION_UPDATE_MESSAGE)
});
/**
 * Get and check the DOM elements needed for this module to work correctly.
 * Creates a closure around the queried elements object
 */


const verifyElements = () => {
  let pickupOptionsEls = initUI();

  for (const el in pickupOptionsEls) {
    if (!pickupOptionsEls[el]) {
      console.error("Missing required element " + el);
      pickupOptionsEls = null;
      break;
    }
  }
  /**
   * Function that returns previously queried elements or null if a required
   * element was not found
   * @returns {PickupOptionsEls | null}
   */


  return () => {
    return pickupOptionsEls;
  };
};
/**
 * Get the DOM elements needed for this module to work correctly
 * @returns {Object | null} - An object of required DOM elements to act on or
 * null if any one of the queried selectors did not return an element
 */


const getUIElements = verifyElements();

// @ts-check
/**
 * Build a list of stores for pickup, to be displayed in the fulfillment
 * options drawer (or anywhere)
 *
 * @param {{
 *  stores: Store[],
 *  selectedVariantInventory: VariantInventory | undefined
 * }} params
 * @returns {string} A collection of store tile components
 */

const buildStoreTile = ({
  stores,
  selectedVariantInventory
}) => {
  /**
   * Helper to generate the pickup option copy to render
   * @param {PickupOption} pickupOption
   * @returns {string}
   */
  return stores.map(store => {
    const inventoryAtStore = selectedVariantInventory == null ? void 0 : selectedVariantInventory.inventoryByLocation.find(location => location.id === store.shopify_id);
    const pickupOption = inventoryAtStore && inventoryAtStore.available > 0 ? getSoonestPickupOption(store) : PickupOption.PICKUP_TOMORROW; // @todo Use translation key for "Free" text

    return "\n          <li class=\"de-StorePickup-tile de-u-flex de-u-flexJustifyBetween\">\n            <div>\n              <h6\n                class=\"de-u-spaceBottomNone\n                      de-u-textSemibold de-u-textGrow1 de-u-lineHeight2\">\n                Free " + getPickupOptionText(pickupOption) + "\n              </h6>\n              <p class=\"de-u-spaceBottomNone de-u-lineHeight3 de-u-textShrink1\">\n                <span class=\"de-u-textSemibold de-u-textBlack de-u-lineHeight3\">\n                  " + store.city + "\n                </span> " + store.street1 + "\n              </p>\n              " + (store.street2 ? "<p class=\"de-u-textShrink1 de-u-spaceBottomNone\">\n                  " + store.street2 + "\n                </p>" : '') + "\n            </div>\n            <div class=\"de-u-flex de-u-flexAlignItemsCenter de-u-padRight06\">\n              " + store.distance + "\n            </div>\n          </li>\n        ";
  }).join('');
};
/**
 * Updates the selected product variant details in the fulfillment options drawer
 * @param {Object} selectedVariant - The details of the selected product variant
 */

const updateProductInDrawer = selectedVariant => {
  var _selectedVariant$feat;

  const {
    variantColorEl,
    variantSizeEl,
    thumbnailImageEl
  } = getUIElements();
  if (selectedVariant.option1) variantSizeEl.textContent = selectedVariant.option1;
  if (selectedVariant.option2) variantColorEl.textContent = selectedVariant.option2;
  if ((_selectedVariant$feat = selectedVariant.featured_image) == null ? void 0 : _selectedVariant$feat.src) thumbnailImageEl.setAttribute('src', getThumbnailImageSrc(selectedVariant.featured_image.src));
};
/**
 * Sets a story city and address for display in fulfillment options on the
 * page (in buybox)
 * @param {Object} store - The data for the store closest to a user
 * (determined prior to passing in here)
 */

const setClosestStoreInfo = store => {
  const {
    storeCityEl,
    storeAddress1El
  } = getUIElements();
  storeCityEl.innerHTML = store.city;
  storeAddress1El.innerHTML = store.street1;
};

var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a),
        arrB = isArray(b),
        i,
        length,
        key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;

      for (i = length; i-- !== 0;) if (!equal(a[i], b[i])) return false;

      return true;
    }

    if (arrA != arrB) return false;
    var dateA = a instanceof Date,
        dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();
    var regexpA = a instanceof RegExp,
        regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();
    var keys = keyList(a);
    length = keys.length;
    if (length !== keyList(b).length) return false;

    for (i = length; i-- !== 0;) if (!hasProp.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  return a !== a && b !== b;
};

// @ts-check
/**
 * @typedef FulfillmentOptionsState
 * @property {Object[]} stores
 * @property {Partial<import('./api').UserLocationData>} userLocationData
 * @property {(variantId: number) => VariantInventory} getVariantInventory
 */

/**
 * Module for storing, updating, and retrieving store and user location data
 */

const {
  getState: getFulfillmentOptionState,
  updateState: updateFulfillmentOptionState
} = createState(
/** @type {FulfillmentOptionsState} */
{
  stores: [],
  userLocationData: {}
});
/**
 * Wrapper for updating state
 * 1. Checks existing against new values
 * 2. Checks for what's passed and if it differs from existing state it
 *   a. Updates state using the function from the `create-state` module
 *   b. Emits an event with a `type` and `data`, which can be listened for
 *      to trigger UI updates
 * @param {Partial<FulfillmentOptionsState>} stateUpdate - An update to the existing state, which may
 * or may not differ from current values
 */

const updateState = stateUpdate => {
  const {
    stores,
    userLocationData,
    getVariantInventory
  } = stateUpdate;
  if (getVariantInventory) updateFulfillmentOptionState({
    getVariantInventory
  });
  const {
    stores: existingStores,
    userLocationData: existingUserLocationData
  } = getFulfillmentOptionState(); // Do not update stores if an empty array is passed

  if (stores && stores.length > 0 && !fastDeepEqual(stores, existingStores)) {
    updateFulfillmentOptionState({
      stores
    });
  }

  if (userLocationData && !fastDeepEqual(userLocationData, existingUserLocationData)) {
    updateFulfillmentOptionState({
      userLocationData
    });
  }
};

// @ts-check
/**
 * @param {PickupOption} pickupOption
 */

const updatePickupOptions = pickupOption => {
  const {
    storePickupDetailsEl,
    pickupTimeFrameEl,
    selectForPickupOptionsMessageEl,
    storePickupOptionsEl
  } = getUIElements();
  showElement$1(storePickupOptionsEl);

  if (pickupOption === PickupOption.SELECT_FOR_OPTIONS) {
    hideElement$1(storePickupDetailsEl);
    showElement$1(selectForPickupOptionsMessageEl);
  } else {
    showElement$1(storePickupDetailsEl);
    hideElement$1(selectForPickupOptionsMessageEl);
  }

  pickupTimeFrameEl.textContent = getPickupOptionText(pickupOption);
};
/**
 * Toggle the fulfillment (store pickup) options block
 * @param {boolean} show - whether to show pickup options
 */


const setPickupOptionVisibility = show => {
  const {
    storePickupOptionsEl
  } = getUIElements();
  const classListAction = show ? REMOVE : ADD;
  storePickupOptionsEl.classList[classListAction](IS_HIDDEN_CLASS);
};
/**
 * Show the fulfillment (store pickup) options block
 */


const showPickupOption = () => setPickupOptionVisibility(true);
/**
 * Hide the fulfillment (store pickup) options block
 */


const hidePickupOption = () => setPickupOptionVisibility(false);
/**
 * Update the user location portion of the drawer
 * @param {Partial<import('./api').UserLocationData>} userLocationData
 */


const updateUserLocationUI = ({
  stateCode,
  city
}) => {
  const {
    userLocationCityEl,
    userLocationStateEl
  } = getUIElements();

  if (stateCode) {
    userLocationStateEl.textContent = stateCode;
  }

  if (city) {
    userLocationCityEl.textContent = city;
  }
};
/**
 * Update store list in drawer, at or after module initialization
 * @param {object} props
 * @param {Store[]} props.stores - An array of one or more store objects
 * @param {VariantInventory | undefined} props.selectedVariantInventory
 */

const updateStoreList = ({
  stores,
  selectedVariantInventory
}) => {
  const {
    storeTileListEl
  } = getUIElements();
  if (!storeTileListEl) return;
  storeTileListEl.innerHTML = buildStoreTile({
    stores,
    selectedVariantInventory
  });
};
/**
 * @TODO - Implement a helper function that toggles a message in the drawer
 * if an updated location is
 * 1. Too far from stores
 * 2. Invalid
 */

/**
 * Update closest store information in buybox, at or after module
 * initialization
 * @param {Object[]} stores - An array of one or more store objects
 */


const updateClosestStore = stores => {
  // Get the first store (they are sorted closest first)
  const closestStore = stores[0]; // If there is no pickup store within range, hide the pickup option and return

  if (!closestStore) {
    /**
     * @TODO - Determine whether this function should stay
     * There seems to be no reason to re-hide the pickup option block if it
     * was shown on page load, even if the user changes location within
     * the drawer. Saving for the moment.
     */
    hidePickupOption();
    return;
  }

  setClosestStoreInfo(closestStore);
  /**
   * Show the pickup options block (Showing store details is controlled by
   * swatch selection)
   */

  showPickupOption();
  return closestStore;
};
/**
 * Update product fulfillment (store pickup) drawer UI elements
 *
 * @param {Object} params The Decathlon stores and user's location
 * @param {Array} params.stores A collection of store data
 * @param {import('./api').UserLocationData | {}} params.userLocationData
 * @param {Object | null} [params.selectedVariant] A selected product variant
 * @param {(variantId: number) => VariantInventory} params.getVariantInventory
 */

const updateDrawerUI = ({
  stores,
  userLocationData,
  selectedVariant,
  getVariantInventory
}) => {
  // If a variant hasn't been selected, no need to update drawer content because
  // the user cannot open the drawer until a variant is selected.
  if (!selectedVariant) return;
  updateUserLocationUI(userLocationData);
  updateProductInDrawer(selectedVariant);
  const selectedVariantInventory = ENABLE_ONE_HOUR_PICKUP ? getVariantInventory == null ? void 0 : getVariantInventory(selectedVariant.id) : undefined;
  updateStoreList({
    stores,
    selectedVariantInventory
  });
};
/**
 * Update product fulfillment (store pickup) page UI elements
 * @param {Object} params
 * @param {Array} params.stores - A collection of store data
 * @param {Variant | null} [params.selectedVariant] A selected product variant
 * @param {(variantId: number) => VariantInventory} params.getVariantInventory
 */


const updatePageUI = ({
  stores,
  selectedVariant,
  getVariantInventory
}) => {
  if (stores.length === 0) {
    // No stores are within range, do not display fulfillment (pickup) options
    return;
  }

  if (!selectedVariant) {
    updatePickupOptions(PickupOption.SELECT_FOR_OPTIONS);
    return;
  }

  const closestStore = updateClosestStore(stores);

  if (!ENABLE_ONE_HOUR_PICKUP) {
    updatePickupOptions(PickupOption.PICKUP_TOMORROW);
    return;
  }

  const variantInventory = getVariantInventory(selectedVariant.id);
  const closestStoreId = closestStore == null ? void 0 : closestStore.shopify_id;
  const inventoryAtClosestStore = closestStoreId && (variantInventory == null ? void 0 : variantInventory.inventoryByLocation.find(location => location.id === closestStoreId));

  if (inventoryAtClosestStore && inventoryAtClosestStore.available > 0) {
    updatePickupOptions(getSoonestPickupOption(closestStore));
  } else {
    updatePickupOptions(PickupOption.PICKUP_TOMORROW);
  }
};
/**
 * Master function for updating product fulfillment options block in buybox
 * and the drawer content
 * @param {object} [params = {}]
 * @param {number} [params.id] - A variant ID
 * @param {string} [params.color] - A variant color
 * @param {string} [params.size] - A variant size
 */


const updateUI$1 = ({
  id,
  color,
  size
} = {}) => {
  const {
    stores,
    userLocationData,
    getVariantInventory
  } = getFulfillmentOptionState();
  const selectedVariant = color && size ? getAvailableSelectedVariant({
    color,
    size
  }) : id ? getAvailableSelectedVariant({
    id
  }) : null;
  updatePageUI({
    stores,
    selectedVariant,
    getVariantInventory
  });
  updateDrawerUI({
    stores,
    userLocationData,
    selectedVariant,
    getVariantInventory
  });
};

// @ts-check
const API_ENDPOINT = "/apps/" + undefined + "/v1";
/**
 * Initializes variants inventory by location for a given product ID
 * @param {number} productId
 */

const getVariantsInventoryForProductId = async productId => {
  /**
   * Retrieves variant inventory for a given variant ID
   * @param {number} variantId The variant ID to filter by
   */
  const getVariantInventory = variantId => variantsInventory.find(variantInventory => variantInventory.variantId === variantId);
  /**
   * The number of variants we are requesting inventory information for (used in shopify's request cost calculation)
   * It is capped at 80 to prevent the request cost going above the allowed maximum
   */


  const numOfVariants = Math.min(variantsJSON.length, 80); // Fetches and caches inventory data

  const variantsInventory = ENABLE_ONE_HOUR_PICKUP ? await fetch(API_ENDPOINT + "/inventory/products/" + productId + "?numOfVariants=" + numOfVariants).then(async res => {
    if (!res.ok) return [];
    /** @type {VariantsInventoryJSON} */

    const json = await res.json();
    return json.variants;
  }).catch(() =>
  /** @type {VariantInventory[]} */
  []) : []; // API to interact with inventory data

  return {
    getVariantInventory
  };
};

// @ts-check
/**
 * Initialize the Fulfillment Options / Store Pickup (with drawer) module
 * Use store distance and user location data to set up the page on load
 * @param {object} props
 * @param {number} props.productId The PDP product ID
 * @TODO -
 * 1) Get selected product variant into drawer content
 * 2) Use geolocation if available
 * 3) Allow user to choose location or allow geolocation within drawer
 */

const init$b = async ({
  productId
}) => {
  try {
    // Get all needed DOM elements for this module
    const pickupOptionsEls = getUIElements(); // Abort if any needed elements are not available

    if (!pickupOptionsEls) {
      throw new Error('Did not get all required DOM elements');
    }
    /**
     * Retrieve user location based on IP address
     */


    const userLocationData = await fetchUserLocationData();
    /**
     * Abort if fulfillment options won't work because location data aren't available
     */

    if (!userLocationData) {
      return;
    } // Retrieve ordered list of stores available within an acceptable distance


    const storeList = await getAvailablePickupStores(userLocationData); // Set stores and userLocationData in our state module

    updateState({
      stores: storeList,
      userLocationData,
      getVariantInventory: storeList.length > 0 ? (await getVariantsInventoryForProductId(productId)).getVariantInventory : undefined
    });
    /**
     * @TODO - Consider updating this file, `update-ui`, and the main product-page
     * `index` to invert the async initialization responsibilities:
     * The goal would be to do all async initialization in this module *after* the
     * product-page init passes in color/size/id data on page load.
     * This module would still need to expose an updateUI function for controlling
     * fulfillment options updates on product selection.
     */
    // Return the updateUI method to be used when product selection changes

    return updateUI$1;
  } catch (error) {
    console.error('Error thrown in fulfillment options init:', error); // All errors thrown from product page modules are caught during its initialization

    throw error;
  }
};

// @ts-check
/**
 * Root element(s)
 */

/** @type {HTMLButtonElement} */

const addToCartButtonEl$1 = document.querySelector("." + JS_PREFIX + "AddToCart-btn");
/**
 * Module constants
 */

const CLICK_EVENT$4 = 'click';
const KEY_DOWN_EVENT$1 = 'keydown';
const ESCAPE_KEY_VALUE$1 = 'escape';
/**
 * Has the document binding been initialized
 */

let isListenerInitialized = false;
/**
 * Helper for detecting the "Escape" keyboard key
 *
 * @param {string} key A keyboard event `key`
 * @returns {boolean}
 */

const isEscapeKey$1 = key => key.toLowerCase() === ESCAPE_KEY_VALUE$1;
/**
 * The keyboard event handler
 *
 * @param {KeyboardEvent} keyboardEvent
 */


const keyboardEventHandler$1 = ({
  key
}) => {
  /**
   * For better accessibility, the modal should close via the "escape" key
   */
  if (isEscapeKey$1(key) && window.BISPopover && window.BISPopover.form) {
    window.BISPopover.form.hide();
  }
};
/** @type {HTMLElement | undefined} */


let lastFocusedElement;
/**
 * Handle ATC click event
 *
 * Sets up binding to allow BIS modal closing via Escape key
 * and overrides BIS Modal "hide()" to reset focus on "Email Me" CTA button
 * for better keyboard accessibility UX
 */

const onAddToCartClick$1 = () => {
  var _window$BISPopover;

  if ((_window$BISPopover = window.BISPopover) == null ? void 0 : _window$BISPopover.form) {
    /**
     * Store the element that was focused before the modal was opened. It will
     * be focused after the modal is closed
     */
    lastFocusedElement =
    /** @type {HTMLElement} */
    document.activeElement; // Save popover-bound original `form.hide` function

    const originalFormHideFunction = window.BISPopover.form.hide.bind(window.BISPopover.form);
    /**
     * Intercept `form.hide` (bound to the modal close button [x]) and also
     * custom-bound to ESC keydown, to re-focus where the user focus was
     * before opening the modal
     */

    window.BISPopover.form.hide = () => {
      originalFormHideFunction();
      lastFocusedElement.focus();
    };
  }

  if (!isListenerInitialized) {
    // Add keydown listener to document
    bindDocumentKeyDown();
    isListenerInitialized = true;
  }
};
/**
 * Add event listener to document
 */


const bindDocumentKeyDown = () => {
  /** @type {HTMLIFrameElement} */
  const BISPopeverEl = document.querySelector('#BIS_frame');

  if (BISPopeverEl) {
    BISPopeverEl.contentDocument.addEventListener(KEY_DOWN_EVENT$1, keyboardEventHandler$1);
  }
};
/**
 * Initialize BISPopover accessibility enhancement(s)
 */


const init$c = () => {
  /**
   * Listener for Add to Cart button
   */
  if (addToCartButtonEl$1) {
    addToCartButtonEl$1.addEventListener(CLICK_EVENT$4, onAddToCartClick$1);
  }
};

// @ts-check
let updateFulfillmentOptionsUI = null;
/**
 * @typedef State
 * @property {string} [model]
 * @property {string} [size]
 * @property {string} [color]
 */

const state$4 = createState(
/** @type {State} */
{});
/** @param {State} state */

const getVariantFromState = ({
  model,
  size
}) => model && size && getSelectedVariant({
  model,
  size
});
/**
 * @param {State} state The current UI state
 */


const getComputedState = state => {
  return {
    color: state.color,
    size: state.size,
    model: state.model,
    variant: getVariantFromState(state)
  };
};
/**
 * Sets up listeners for custom UI components
 */


const setUpListeners = () => {
  handleSizeSelect(size => {
    state$4.updateState({
      size
    });
  });
  handleColorSelect((color, model) => {
    state$4.updateState({
      color,
      model
    });
  });
  onVariantModification(() => {
    const fullState = getComputedState(state$4.getState());
    updateOptionStates(fullState);
  });
}; // When the variant changes


state$4.onChange(state => {
  const variant = getVariantFromState(state);
  onVariantSelect$3(variant);
  onVariantSelect$2(variant);
  onVariantSelect(variant);
  updateUrlVariant(variant == null ? void 0 : variant.id);

  if (variant) {
    // MasterSelect requires a full variant to update
    onVariantSelect$1(variant); // The updateFulfillmentOptionsUI function will be undefined on page load,
    // but will update on subsequent page actions

    updateFulfillmentOptionsUI && updateFulfillmentOptionsUI(state);
  }
}, state => [getVariantFromState(state)]); // When the color changes

state$4.onChange(({
  color,
  model
}) => {
  if (!color || !model) return;
  onColorSelect$2(model);
  onColorSelect(model); // Model code can be updated without size

  onColorSelect$3(model);
}, state => [state.color, state.model]); // When a swatch changes (color _or_ size)

state$4.onChange(state => {
  const {
    color,
    size,
    model
  } = state;
  const variant = getVariantFromState(state);
  updateOptionStates({
    color,
    size,
    variant,
    model
  }); // Price can be updated even if no variant (color + size) has been selected
  // @see: https://app.gitbook.com/@decathlonusa/s/shopify/product-feature/product-page#price

  onSwatchChange({
    model,
    variant
  });
}, state => [state.size, state.color, state.model]);
/**
 * Updates UI to reflect variant in URL
 */

const selectUrlVariant = () => {
  const urlVariantId = Number(getUrlVariant());
  const variant = getSelectedVariant({
    id: urlVariantId
  });

  if (variant) {
    const options = getVariantOptions(variant);
    const targetColorSwatch = [...swatchOptionEls].find(swatch => {
      return swatch.dataset.modelCode == options.model;
    });

    if (targetColorSwatch) {
      targetColorSwatch.click();
    }

    return urlVariantId;
  }
};
/**
 * Initialize
 */


const init$d = async () => {
  init$4();
  init$3();
  setUpListeners();
  reviewsInit();
  init$9();
  init();
  init$1();
  init$7();
  init$6();
  selectUrlVariant();
  init$a();
  init$c();
  /**
   * We are limiting the initialization of Fulfillment Options to only California.
   * If Decathlon stores expand outside of California, we'll want to revisit this logic.
   * This means less pings to the Google Maps APIs, which is the goal of this change.
   *
   * getCurrentLocation() is a call to IPStack (no Google Maps API involvement)
   *
   * @see https://favro.com/organization/3b9e0cac6fa6e11b48d8b159/9250833f54e7836c6801659c?card=DEC-5077
   */

  {
    const currentLocation = await getCurrentLocation();

    if (currentLocation && isLocationPickupApproved(currentLocation)) {
      // Suggest leaving the async setup for fulfillment options to last
      updateFulfillmentOptionsUI = await init$b({
        productId
      });
      /**
       * The updateFulfillmentOptionsUI function will be undefined in the master
       * updateUI function on page load, so call here as soon as it's defined
       * This fixes a bug where the UI wasn't showing the initial in-store option state
       * @see https://favro.com/organization/3b9e0cac6fa6e11b48d8b159/9250833f54e7836c6801659c?card=DEC-5530
       */

      updateFulfillmentOptionsUI();
      /**
       * Obtain UrlVariantId at this time so that all init() functions have
       * completed & default selections have been made
       */

      const urlVariantId = Number(getUrlVariant());
      if (urlVariantId) updateFulfillmentOptionsUI({
        id: urlVariantId
      });
    }
  }

  console.log('init');
  init$2();
}; // Call the async init to return the Promise and log errors


init$d().then(() => console.log('Product page initialized.')).catch(error => console.error(error));
